
import { defineMessages } from "react-intl";

export default defineMessages({
  // FAITS VS OPINIONS (added for SOPE test)
  FAITSOPINIONSTITLE: {
    id: "app.faitsopinionstitle",
    defaultMessage: "FAITS VS OPINIONS"
  },
  SCOPEREPORT_FAITS_VS_OPINIONS_DESC: {
      id: "app.faits_vs_opinions_desc",
      defaultMessage:
        "Le test Faits et Opinions évalue votre capacité à distinguer clairement une information factuelle vérifiable d'un jugement, d'une interprétation ou d'une opinion personnelle. Cette compétence relève de l'intelligence fluide — c'est-à-dire de la mécanique de la pensée, indépendante de vos connaissances ou de votre expérience professionnelle.",
    },
  SCOPEREPORT_FAITS_VS_OPINIONS_SUBTITLE: {
      id: "app.faits_vs_opinions_subtitle",
      defaultMessage:
        "Dans le contexte professionnel, cette aptitude joue un rôle clé à plusieurs niveaux :",
    },
  SCOPEREPORT_FAITS_VS_OPINIONS_EXPLANATION: {
      id: "app.faits_vs_opinions_explanation",
      defaultMessage:
        "Confondre un fait et une opinion peut conduire à des raisonnements biaisés, à des décisions fondées sur des perceptions plutôt que sur des réalités vérifiables. Savoir distinguer ce que l'on sait de ce que l'on croit renforce la crédibilité et la précision dans les échanges professionnels. Une nuance importante : les personnes avec un niveau élevé d'assurance en soi ont parfois tendance à prendre leurs propres opinions pour des faits. Un score plus bas sur ce test peut donc inviter à explorer ce point spécifiquement.",
    },
  FAITSOPINIONSFAIT: {
    id: "app.faitsopinionsfait",
    defaultMessage: "Fait vérifiable"
  },
  FAITSOPINIONSOPINION: {
    id: "app.faitsopinionsopinion",
    defaultMessage: "Opinion/Jugement"
  },
  FAITSOPINIONSQUESTION1: {
    id: "app.faitsopinionsquestion1",
    defaultMessage: "La Terre tourne autour du Soleil."
  },
  FAITSOPINIONSQUESTION2: {
    id: "app.faitsopinionsquestion2",
    defaultMessage: "Le chocolat est meilleur que la vanille."
  },
  FAITSOPINIONSQUESTION3: {
    id: "app.faitsopinionsquestion3",
    defaultMessage: "L’eau bout à 100°C au niveau de la mer."
  },
  FAITSOPINIONSQUESTION4: {
    id: "app.faitsopinionsquestion4",
    defaultMessage: "Les chiens sont plus intelligents que les chats."
  },
  FAITSOPINIONSQUESTION5: {
    id: "app.faitsopinionsquestion5",
    defaultMessage: "Paris est la capitale de la France."
  },
  FAITSOPINIONSQUESTION6: {
    id: "app.faitsopinionsquestion6",
    defaultMessage: "Il est préférable de se lever tôt le matin."
  },
  FAITSOPINIONSQUESTION7: {
    id: "app.faitsopinionsquestion7",
    defaultMessage: "L’eau gèle à 0°C."
  },
  FAITSOPINIONSQUESTION8: {
    id: "app.faitsopinionsquestion8",
    defaultMessage: "Les vacances d’été sont plus agréables que celles d’hiver."
  },
  FAITSOPINIONSQUESTION9: {
    id: "app.faitsopinionsquestion9",
    defaultMessage: "Le corps humain a 206 os."
  },
  FAITSOPINIONSQUESTION10: {
    id: "app.faitsopinionsquestion10",
    defaultMessage: "La lecture est le meilleur passe-temps."
  },
  FAITSOPINIONSQUESTION11: {
    id: "app.faitsopinionsquestion11",
    defaultMessage: "L’air est composé principalement d’azote."
  },
  FAITSOPINIONSQUESTION12: {
    id: "app.faitsopinionsquestion12",
    defaultMessage: "Il vaut mieux vivre à la campagne qu’en ville."
  },
  FAITSOPINIONSQUESTION13: {
    id: "app.faitsopinionsquestion13",
    defaultMessage: "L’éléphant est le plus grand animal terrestre."
  },
  FAITSOPINIONSQUESTION14: {
    id: "app.faitsopinionsquestion14",
    defaultMessage: "Le bleu est la plus belle couleur."
  },
  FAITSOPINIONSQUESTION15: {
    id: "app.faitsopinionsquestion15",
    defaultMessage: "L’eau est composée de deux atomes d’hydrogène et d’un atome d’oxygène."
  },
  FAITSOPINIONSQUESTION16: {
    id: "app.faitsopinionsquestion16",
    defaultMessage: "Il est important de faire du sport régulièrement."
  },
  FAITSOPINIONSQUESTION17: {
    id: "app.faitsopinionsquestion17",
    defaultMessage: "La Tour Eiffel se trouve à Paris."
  },
  FAITSOPINIONSQUESTION18: {
    id: "app.faitsopinionsquestion18",
    defaultMessage: "Les films sont plus divertissants que les livres."
  },
  FAITSOPINIONSAID: {
    id: "app.faitsopinionsaid",
    defaultMessage: "Classez chaque affirmation comme fait vérifiable ou opinion/jugement"
  },
  // Info-footer multilingual keys
  INFO_FOOTER_TITLE: {
    id: "app.info_footer_title",
    defaultMessage: "New to SCOPE?"
  },
  INFO_FOOTER_TEXT: {
    id: "app.info_footer_text",
    defaultMessage: "If you’ve landed here by chance or through a search, SCOPE is a professional assessment tool available through certified coaches. To learn more about the assessment, or to connect with a coach and unlock your personal evaluation, visit <link>ppe-evaluation.com</link>."
  },
  /* -----------------------------SCOPE-TEST----------------------------- */

  FAKE_STRENGTHS_INTRO: { id: "app.fake_strengths_intro", defaultMessage: "Intro line" },
  FAKE_STRENGTHS_1: { id: "app.fake_strengths_1", defaultMessage: "Bullet 1" },
  FAKE_STRENGTHS_2: { id: "app.fake_strengths_2", defaultMessage: "Bullet 2" },

  GENERIC_INTRO_TITLE: {
    id: "app.generic_intro_title",
    defaultMessage: "Explorez votre potentiel avec SCOPE",
  },
  GENERIC_INTRO_SUBTITLE: {
    id: "app.generic_intro_subtitle",
    defaultMessage: "Une expérience d’évaluation unique — accessible uniquement via un coach certifié",
  },
  GENERIC_INTRO_1: {
    id: "app.generic_intro_1",
    defaultMessage: "SCOPE est une évaluation développée scientifiquement pour offrir des informations précieuses sur votre potentiel personnel. Elle combine l’auto-réflexion avec des mesures objectives pour explorer vos traits, compétences et motivations—révélant comment vous pensez, ressentez et réagissez face aux défis."
  },
  GENERIC_INTRO_2: {
    id: "app.generic_intro_2",
    defaultMessage: "SCOPE n’est pas un test que l’on passe seul. Il est disponible exclusivement auprès de coachs certifiés, qui vous accompagnent non seulement pendant l’évaluation mais aussi lors d’un débriefing personnalisé—vous aidant à interpréter les résultats et à les appliquer concrètement dans votre vie ou votre travail."
  },
  GENERIC_INTRO_3: {
    id: "app.generic_intro_3",
    defaultMessage: "Pour commencer, vous aurez besoin d’une clé unique fournie par votre coach. Cette clé est essentielle pour accéder à l’évaluation et garantir que vos résultats vous sont bien attribués en toute sécurité. Si vous n’avez pas encore de clé, veuillez contacter votre coach pour en obtenir une."
  },
  GENERIC_INTRO_4: {
    id: "app.generic_intro_4",
    defaultMessage: "Il n’y a pas de bonnes ou de mauvaises réponses, et il ne s’agit pas de rentrer dans une case. Vous serez invité à répondre honnêtement et instinctivement, afin que les résultats reflètent vraiment qui vous êtes."
  },
  GENERIC_INTRO_5: {
    id: "app.generic_intro_5",
    defaultMessage: "Intéressé(e) par l’évaluation SCOPE ou par un contact avec un coach certifié ?"
  },
  // API USER CONFIRMTION
  CONFIRM_USER: {
    id: "app.confirm_user",
    defaultMessage: "Confirmez votre accès à SCOPE",
  },
  SEND_PIN_TO_CONFIRM_USER_DESC: {
    id: "app.send_pin_to_confirm_user_desc",
    defaultMessage: "A fin de confirmer votre identité, veuillez cliquer sur 'Envoyer PIN' et un code PIN serait envoyé à votre adresse e-mail.",
  },
  SEND_PIN: {
    id: "app.send_pin",
    defaultMessage: "Envoyer PIN",
  },

  START_SCOPE: {
    id: "app.start_scope",
    defaultMessage: "Demarrer SCOPE",
  },

  PIN_LABEL: {
    id: "app.pin_label",
    defaultMessage: "PIN",
  },
  
  CHECK_PIN_RECEIVED_DESC: {
    id: "app.check_pin_received_desc",
    defaultMessage: "Veuillez entrer le code PIN que vous avez reçu par e-mail. Si vous n'avez pas reçu de code PIN, veuillez verifier votre dossier de spam.",
  },
  
  //LES PAGES D'ACCUEILS
  ACCUEIL5_INFO1: {
    id: "app.accueil5_info1",
    defaultMessage: "Avant de commencer, n’oubliez pas ce qui suit :  ",
  },
  ACCUEIL5_INFO2: {
    id: "app.accueil5_info2",
    defaultMessage:
      "Veuillez ne pas interrompre le déroulement du test qui est chronométré automatiquement. Pour la validité des résultats, il est essentiel que vous vous concentriez pleinement sur les tests et que vous n’ayez recours à aucune aide. La saisie des réponses doit être complète au risque de fausser les résultats et les conclusions du test. ",
  },
  ACCUEIL5_INFO3: {
    id: "app.accueil5_info3",
    defaultMessage:
      "Veuillez répondre sincèrement et de votre mieux. Il n’y a pas de bonnes ou de mauvaises réponses. En outre, ne réfléchissez pas longtemps avant de répondre ; les premières réponses sont généralement les meilleures. ",
  },
  ACCUEIL5_INFO8: {
    id: "app.accueil5_info8",
    defaultMessage:
      "Prévoyez au moins 30 à 45 minutes devant vous, connectez-vous avec un email valide et enfin ne vous déconnectez pas afin d’éviter de devoir tout recommencer à zéro.",
  },

  //LES PAGES D'ACCUEILS DE FIN
  ACCUEIL5_INFO4: {
    id: "app.accueil5_info4",
    defaultMessage: "Merci d’avoir rempli de le test SCOPE",
  },
  ACCUEIL5_INFO5: {
    id: "app.accueil5_info5",
    defaultMessage: "Voici votre temps :  ",
  },
  ACCUEIL5_INFO6: {
    id: "app.accueil5_info6",
    defaultMessage: "Vous recevrez les résultats de votre test par e-mail.",
  },
  ACCUEIL5_INFO7: {
    id: "app.accueil5_info7",
    defaultMessage:
      "En cliquant sur terminer vous serez redirigé sur Skillspot.me",
  },

  //LES BOUTONS,MODALS, CHECK EMAIL ET TOAST INFORMATIONS DU TEST
  MODAL_BUTTON: { id: "modal.button", defaultMessage: "Log out" },
  INPUT_EMAIL: { id: "app.input_email", defaultMessage: "Adresse Email..." },
  EMAIL_QUESTION: {
    id: "email.question",
    defaultMessage: "Please enter your email so we can send you the results : ",
  },
  EMAIL_WRONG: {
    id: "email.wrong",
    defaultMessage: "You have entered an invalid email address, try again",
  },
  INFORMATION_SHOULDLOG: {
    id: "information.shouldlog",
    defaultMessage: "You should log in to do the test",
  },
  TOAST_WELCOME: { id: "app.toast_welcome", defaultMessage: "Bienvenue, " },
  TOAST_WELCOMEBACK: {
    id: "app.toast_welcomeback",
    defaultMessage: "Bon retour, ",
  },
  TOAST_GOODBYE: { id: "app.toast_goodbye", defaultMessage: "Au revoir, " },
  MODAL_TITLE: { id: "modal.title", defaultMessage: "Déconnexion ?" },
  MODAL_TEXT1: {
    id: "modal.text1",
    defaultMessage:
      "If you log out, all your data will be deleted and you will have to start all over again.",
  },
  MODAL_TEXT2: {
    id: "modal.text2",
    defaultMessage: "Are you sure you want to log out ?",
  },
  LOADING_PAGE: { id: "app.loading_page", defaultMessage: "Chargement..." },

  DEFINITIONS:{
    id: "app.definitions",
    defaultMessage: "Définitions",
  },
  //LES PAGES D'INSTRUCTIONS AVANT CHAQUE CATEGORIES
  //test personnalité vrai ou faux
  INFO1: {
    id: "app.info1",
    defaultMessage:
      "L’instrument suivant est fréquemment utilisé par des professionnels en Ressources Humaines. Il fournit d’importantes informations concernant le potentiel personnel dans le domaine du travail.",
  },
  INFOINST1: {
    id: "app.infoinst1",
    defaultMessage:
      "Pour chaque affirmation sur les écrans à venir, veuillez indiquer, en cliquant sur le bouton suivant, si elle est VRAIE ou FAUSSE pour vous.",
  },

  //suppposition
  INFO2: {
    id: "app.info2",
    defaultMessage:
      "Le test suivant évalue vos capacités à identifier les déductions qui découlent d’une supposition donnée avec une certitude absolue - sans recourir à des informations supplémentaires. ",
  },
  INFOINST2bis: {
    id: "app.infoinst2bis",
    defaultMessage:
      "Qu’est-ce qui peut être déduit d’une supposition donnée sans avoir d’autres informations ? Décidez pour chacune de déductions, si elle est vraie ou pas. Si elle est vraie, cliquez  sur la déduction même.",
  },

  //trais de personnalité
  INFO3: {
    id: "app.info3",
    defaultMessage:
      "Le test suivant étudie les traits de personnalité centraux qui influencent notre comportement dans une grande variété de situations. Sur les pages suivantes, les descriptions de personnalité sont présentés comme des auto-descriptions de personnes possédant ces traits à un degré très élevé. ",
  },
  INFOINST3: {
    id: "app.infoinst3",
    defaultMessage:
      "Les descriptions dans les cases gauches et droites décrivent des comportements, des préférences, et des opinions, qui définissent les deux extrêmes d’une dimension de la personnalité. Pour répondre, décidez d’abord, si vous êtes similaire à la personne décrite à gauche ou à celle décrite à droite. Ensuite, indiquez à quel degré vous êtes similaire à la personne choisie en cliquant sur le cercle respectif. La taille des cercles reflète le degré de similarité.",
  },
  INFOINST3BIS: {
    id: "app.infoinst3bis",
    defaultMessage:
      'Instructions : Utilisez l’échelle ci-dessous pour indiquer à quel degré vous possédez chaque trait. Lisez attentivement les descriptions dans chaque case et choisissez le côté puis la position sur ce côté qui représentent au mieux votre façon de penser et d’agir en général. Ensuite, cliquez sur le bouton qui correspond à l’impression que vous avez de vous-même. Sur le prochain écran, le premier trait de personnalité apparaîtra. Veuillez décider quel côté de la dimension de personnalité vous décrit le mieux et cliquer sur le bouton qui correspond au degré auquel vous possédez ce trait. Pour terminer l’exemple et commencer le test, cliquez sur l’un des boutons de réponse et ensuite sur "Continuer". ',
  },
  INFOINST3EXEMPLE1: {
    id: "app.infoinst3exemple1",
    defaultMessage:
      "Je peux m’enthousiasmer pour un tas de choses et parfois j’ai le sentiment que je m’excite trop facilement. ",
  },
  INFOINST3EXEMPLEREPONSE1: {
    id: "app.infoinst3exemplereponse1",
    defaultMessage:
      "Si vous possédiez ce trait à un degré très élevé vous cliqueriez ici.",
  },
  INFOINST3EXEMPLE2: {
    id: "app.infoinst3exemple2",
    defaultMessage:
      "Je suis généralement décontracté et je ne m’emporte pas facilement. ",
  },
  INFOINST3EXEMPLEREPONSE2: {
    id: "app.infoinst3exemplereponse2",
    defaultMessage:
      "Si vous possédiez ce trait à un degré modéré, vous cliqueriez ici.",
  },

  //preferences professionnelles
  INFO4: {
    id: "app.info4",
    defaultMessage:
      "Le test suivant étudie vos préférences professionnelles, tels que les conditions de travail et les aspects de l’emploi, qui inciteront les gens à choisir un emploi plus qu’un autre. Votre tâche sera de choisir à plusieurs reprises entre deux positions selon leurs caractéristiques attrayantes. ",
  },
  INFOINST4: {
    id: "app.infoinst4",
    defaultMessage:
      "Les écrans suivants vous présenteront deux types d’emploi A et B dont les caractéristiques professionnelles sont attrayantes. Veuillez imaginer ce choix et sélectionner l’emploi que vous préféreriez en cliquant sur l’alternative correspondante. ",
  },

  //supposition
  INFO5: {
    id: "app.info5",
    defaultMessage:
      "Pour maîtriser des situations de crise, nous utilisons tous plusieurs types de stratégies. Ce test mesure votre propension à vous servir de certaines de ces stratégies. Nous allons vous demander d’imaginer que vous vivez une situation de crise typique et d’indiquer la probabilité que vous utilisiez une stratégie particulière dans cette situation. ",
  },
  INFOINST5: {
    id: "app.infoinst5",
    defaultMessage:
      "Dans les écrans suivants nous allons vous présenter 9 stratégies couramment utilisées, illustrées par des exemples. Veuillez indiquer pour chacune la probabilité que vous utilisiez cette stratégie pour maîtriser le stress dans la situation donnée. ",
  },

  //preferences et tendances
  INFO6: {
    id: "app.info6",
    defaultMessage:
      "Le test suivant étudie vos préférences et vos tendances comportementales. Il contient un certain nombre de propositions décrivant des attitudes et des comportements typiques. ",
  },
  INFOINST6: {
    id: "app.infoinst6",
    defaultMessage:
      "Pour chaque proposition, indiquez à quel point celle-ci vous décrit, selon des alternatives de réponse qui vous seront proposées.",
  },

  //reactions emo
  INFO7: {
    id: "app.info7",
    defaultMessage:
      "Le test suivant étudie la nature de vos réactions émotionnelles. Il vous sera demandé d’imaginer diverses situations et d’indiquer avec quelle intensité vous ressentiriez différentes émotions dans ces situations. ",
  },
  INFOINST7: {
    id: "app.infoinst7",
    defaultMessage:
      "Imaginez chaque situation le plus vivement possible et indiquez quelles émotions vous ressentiriez et à quelle intensité en glissant le curseur au point correspondant. Comme on peut expérimenter diverses émotions à la fois, vous pouvez en indiquer plusieurs. Vous devez impérativement répondre à chaque émotion avant de passer à l’écran suivant.",
  },
  INFOINST7BIS: {
    id: "app.infoinst7bis",
    defaultMessage:
      'Vous devez bouger tous les curseurs avant de pouvoir cliquer sur "Suivant."',
  },
  //test de logique
  INFO8: {
    id: "app.info8",
    defaultMessage:
      "Dans les écrans suivants vous trouverez un test de raisonnement logique. Votre tâche consiste à décider quelles conclusions suivent logiquement des affirmations données.",
  },
  INFOINST8: {
    id: "app.infoinst8",
    defaultMessage:
      "Pour rendre les choses plus intéressantes, les affirmations sont assez absurdes. Il vous faut les prendre comme elles vous sont présentées - comme faits - et examiner pour chaque conclusion présentée, si elle est vraie, selon l’affirmation donnée.",
  },

  //valeurs humaines
  INFO9: {
    id: "app.info9",
    defaultMessage:
      "Le test suivant a pour objectif de mettre en lumière l’importance des valeurs humaines tel l’amour, la morale, le pouvoir ou encore le succès dans votre comportement. Malheureusement, certaines situations délicates obligent à privilégier une valeur afin de guider le comportement. Par exemple, au cas où un ami a commis une faute, il faut choisir si on réagit selon la valeur « justice » ou la valeur « amitié ».",
  },
  INFOINST9: {
    id: "app.infoinst9",
    defaultMessage:
      "Les écrans suivants vous présenteront à chaque fois deux valeurs humaines. En imaginant un événement dans lequel ces valeurs sont en concurrence, vous indiquerez la valeur que vous choisiriez. ",
  },
  INFO10: {
    id: "app.info10",
    defaultMessage:
      "Vous êtes arrivé à la fin de votre séance SCOPE. Pour interpréter vos résultats, il nous faut un minimum d’informations de base vous concernant.",
  },
  INFOINST10: {
    id: "app.infoinst10",
    defaultMessage:
      "Répondez aux questions suivantes en cochant la réponse qui vous concerne.",
  },
  EXEMPLE: { id: "app.exemple", defaultMessage: "EXEMPLE" },

  //INDICATION POUR LES 34 QUESTIONS DE TEST DE PERSONNALITé
  INDICATIONTF: {
    id: "app.indicationtf",
    defaultMessage:
      "Veuillez indiquer si l’affirmation est VRAIE ou FAUSSE pour vous",
  },

  //LES QUESTIONS CATEGORIES  Test de personnalité (34 questions)
  QUESTIONTF1: {
    id: "app.questiontf1",
    defaultMessage:
      "Je me réveille frais/fraîche et reposé/e presque tous les matins",
  },
  QUESTIONTF2: {
    id: "app.questiontf2",
    defaultMessage:
      "Souvent, je ne suis pas au courant des bavardages et commérages dans le groupe auquel j’appartiens ",
  },
  QUESTIONTF3: {
    id: "app.questiontf3",
    defaultMessage:
      "La plupart des gens sont honnêtes surtout par peur d’être punis",
  },
  QUESTIONTF4: {
    id: "app.questiontf4",
    defaultMessage:
      "J’aime que les gens se demandent ce que je vais bien pouvoir encore inventer ",
  },
  QUESTIONTF5: {
    id: "app.questiontf5",
    defaultMessage:
      "De bien des façons, les pauvres vont mieux que les riches ",
  },
  QUESTIONTF6: {
    id: "app.questiontf6",
    defaultMessage: "Je n’ai jamais bu de manière immodérée ",
  },
  QUESTIONTF7: {
    id: "app.questiontf7",
    defaultMessage:
      "Je suis souvent dérangé(e) par des pensées inutiles qui tournent dans ma tête ",
  },
  QUESTIONTF8: {
    id: "app.questiontf8",
    defaultMessage: "Je pense qu’en général je suis le leader de mon groupe ",
  },
  QUESTIONTF9: {
    id: "app.questiontf9",
    defaultMessage: "Ma peau semble être extrêmement sensible au toucher ",
  },
  QUESTIONTF10: {
    id: "app.questiontf10",
    defaultMessage:
      "Plutôt que de perdre un avantage ou un profit, la plupart des gens n’hésiteront pas à employer des moyens déloyaux pour les obtenir ",
  },
  QUESTIONTF11: {
    id: "app.questiontf11",
    defaultMessage:
      "Je n’appréhende pas d’entrer dans une pièce où se trouvent déjà d’autres personnes ",
  },
  QUESTIONTF12: {
    id: "app.questiontf12",
    defaultMessage: "Des soucis, j’en ai eus plus que de raison",
  },
  QUESTIONTF13: {
    id: "app.questiontf13",
    defaultMessage:
      "Je remarque souvent que mes mains tremblent quand j’essaie de faire quelque chose ",
  },
  QUESTIONTF14: {
    id: "app.questiontf14",
    defaultMessage:
      "La plupart du temps, je trouve que la vie vaut la peine d’être vécue ",
  },
  QUESTIONTF15: {
    id: "app.questiontf15",
    defaultMessage:
      "Je ne reproche à personne d’essayer de s’emparer de tout ce qu’elle peut obtenir dans ce monde ",
  },
  QUESTIONTF16: {
    id: "app.questiontf16",
    defaultMessage: "J’ai l’impression d’avoir été souvent puni/e sans raison ",
  },
  QUESTIONTF17: {
    id: "app.questiontf17",
    defaultMessage: "Le succès est affaire de volonté",
  },
  QUESTIONTF18: {
    id: "app.questiontf18",
    defaultMessage:
      "J’ai du mal à être moi-même en présence d’autres personnes ",
  },
  QUESTIONTF19: {
    id: "app.questiontf19",
    defaultMessage: "J’aime préparer et décider ce que chacun devrait faire ",
  },
  QUESTIONTF20: {
    id: "app.questiontf20",
    defaultMessage: "J’ai vécu des expériences très étranges ",
  },
  QUESTIONTF21: {
    id: "app.questiontf21",
    defaultMessage:
      "Je prends très au sérieux les problèmes moraux et les questions éthiques ",
  },
  QUESTIONTF22: {
    id: "app.questiontf22",
    defaultMessage:
      "Il me semble que d’antan, les gens avaient plus de plaisir qu’aujourd’hui",
  },
  QUESTIONTF23: {
    id: "app.questiontf23",
    defaultMessage: "Parfois, je me sens assez découragé/e ",
  },
  QUESTIONTF24: {
    id: "app.questiontf24",
    defaultMessage:
      "Les enseignants attendent souvent trop de travail de leurs élèves",
  },
  QUESTIONTF25: {
    id: "app.questiontf25",
    defaultMessage:
      "J’agis souvent de manière impulsive, sans prendre le temps de réfléchir ",
  },
  QUESTIONTF26: {
    id: "app.questiontf26",
    defaultMessage:
      "Dans leur for intérieur, la plupart des gens détestent se mettre en quatre pour aider les autres",
  },
  QUESTIONTF27: {
    id: "app.questiontf27",
    defaultMessage:
      "Le futur est trop incertain pour pouvoir faire de sérieux projets",
  },
  QUESTIONTF28: {
    id: "app.questiontf28",
    defaultMessage:
      "Je pense que la plupart des gens sont prêts à mentir par intérêt ",
  },
  QUESTIONTF29: {
    id: "app.questiontf29",
    defaultMessage:
      "Si j’en avais l’occasion, je ferais un bon meneur d’hommes ",
  },
  QUESTIONTF30: {
    id: "app.questiontf30",
    defaultMessage:
      "Les gens semblent se tourner instinctivement vers moi quand des décisions doivent être prises ",
  },
  QUESTIONTF31: {
    id: "app.questiontf31",
    defaultMessage:
      "Si on prend soin de soi, on n’a pas à se soucier des autres ",
  },
  QUESTIONTF32: {
    id: "app.questiontf32",
    defaultMessage:
      "Quand les affaires marchent, il n’y a pas de mal à en profiter au maximum aussi longtemps que ça dure",
  },
  QUESTIONTF33: {
    id: "app.questiontf33",
    defaultMessage:
      "La plupart des gens seraient disposés à mentir si cela pouvait leur profiter ",
  },
  QUESTIONTF34: {
    id: "app.questiontf34",
    defaultMessage: "Ma façon de faire peut être mal comprise par les autres ",
  },

  //QUESTIONS SUPPOSITION
  SUPPOSITIONTITRE: {
    id: "app.suppositiontitre",
    defaultMessage: "SUPPOSITION",
  },
  SUPPOSITIONINFO1: {
    id: "app.suppositioninfo1",
    defaultMessage:
      "Après avoir commandé une nouvelle voiture, il faut souvent attendre un long moment avant qu’elle soit livrée ",
  },
  SUPPOSITIONQUESTION1: {
    id: "app.suppositionquestion1",
    defaultMessage:
      "Il faut souvent attendre un long moment avant qu’une nouvelle voiture soit livrée car beaucoup de gens achètent de nouvelles ",
  },
  SUPPOSITIONQUESTION2: {
    id: "app.suppositionquestion2",
    defaultMessage:
      "Certaines personnes qui achètent une nouvelle voiture doivent attendre un long moment avant que la voiture soit livrée ",
  },
  SUPPOSITIONQUESTION3: {
    id: "app.suppositionquestion3",
    defaultMessage:
      "Il est impossible d’accélérer la livraison de nouvelles voitures ",
  },
  SUPPOSITIONQUESTION4: {
    id: "app.suppositionquestion4",
    defaultMessage:
      "Beaucoup d’appels téléphoniques sont nécessaires pour la livraison d’une voiture ",
  },

  SUPPOSITIONINFO2: {
    id: "app.suppositioninfo2",
    defaultMessage:
      "Aux Etats-Unis, il y a plus de gens qui mangent un repas chaud le soir qu’à midi ",
  },
  SUPPOSITIONQUESTION5: {
    id: "app.suppositionquestion5",
    defaultMessage:
      "Les Américains pensent qu’ils apprécient mieux un repas chaud le soir qu’à midi ",
  },
  SUPPOSITIONQUESTION6: {
    id: "app.suppositionquestion6",
    defaultMessage:
      "Le nombre de repas chauds mangés aux Etats-Unis n’est pas indépendant du moment de la journée ",
  },
  SUPPOSITIONQUESTION7: {
    id: "app.suppositionquestion7",
    defaultMessage:
      "Aux Etats-Unis, plus de repas chauds sont cuisinés pour le dîner que pour le déjeuner ",
  },
  SUPPOSITIONQUESTION8: {
    id: "app.suppositionquestion8",
    defaultMessage:
      "Les Américains préfèrent manger leurs repas chauds le soir ",
  },

  SUPPOSITIONINFO3: {
    id: "app.suppositioninfo3",
    defaultMessage: "Le nombre de crimes diminue d’année en année ",
  },
  SUPPOSITIONQUESTION9: {
    id: "app.suppositionquestion9",
    defaultMessage: "Le travail de la police est plus efficace qu’auparavant ",
  },
  SUPPOSITIONQUESTION10: {
    id: "app.suppositionquestion10",
    defaultMessage:
      "Il y a eu plus de crimes commis l’année passée qu’il y en aura probablement l’année prochaine ",
  },
  SUPPOSITIONQUESTION11: {
    id: "app.suppositionquestion11",
    defaultMessage:
      "La somme d’argent perdue à cause du crime diminue d’année en année ",
  },
  SUPPOSITIONQUESTION12: {
    id: "app.suppositionquestion12",
    defaultMessage:
      "Il y a moins de criminels aujourd’hui que dix ans auparavant ",
  },

  SUPPOSITIONINFO4: {
    id: "app.suppositioninfo4",
    defaultMessage:
      "Malgré le fait que le nombre de personnes obèses augmente constamment et que les médecins nous avertissent des risques que les aliments riches en graisse et en sucre entraînent pour la santé, la consommation de ces aliments continue d’augmenter ",
  },
  SUPPOSITIONQUESTION13: {
    id: "app.suppositionquestion13",
    defaultMessage:
      "La plupart des gens doutent que le fait de manger certains aliments entraîne des risques pour la santé ",
  },
  SUPPOSITIONQUESTION14: {
    id: "app.suppositionquestion14",
    defaultMessage:
      "Les avertissements des médecins n’ont pas encore affecté les habitudes alimentaires",
  },
  SUPPOSITIONQUESTION15: {
    id: "app.suppositionquestion15",
    defaultMessage:
      "Manger est un comportement qui n’est pas affecté par les conseils médicaux ",
  },
  SUPPOSITIONQUESTION16: {
    id: "app.suppositionquestion16",
    defaultMessage:
      "La plupart des gens préfèrent accepter des risques de santé plutôt que d’arrêter de manger leurs aliments préférés ",
  },

  //traits de personnalité
  TRAITSPERSONNALITEINSTRUCTION: {
    id: "app.traitspersonnaliteinstruction",
    defaultMessage:
      "Veuillez cliquer sur le cercle indiquant le degré de similarité entre la personne choisie et vous.",
  },
  TRAITSPERSONNALITEDEFAULT: {
    id: "app.traitspersonnalitedefault",
    defaultMessage:
      "Cliquez sur l’un des cercles ci-dessus pour pouvoir continuer.",
  },
  TRAITSPERSONNALITELVL1: {
    id: "app.traitspersonnalitelvl1",
    defaultMessage: "bas",
  },
  TRAITSPERSONNALITELVL2: {
    id: "app.traitspersonnalitelvl2",
    defaultMessage: "modéré",
  },
  TRAITSPERSONNALITELVL3: {
    id: "app.traitspersonnalitelvl3",
    defaultMessage: "élevé",
  },
  TRAITSPERSONNALITELVL4: {
    id: "app.traitspersonnalitelvl4",
    defaultMessage: "très élevé",
  },

  TRAITSPERSONNALITE1: {
    id: "app.traitspersonnalite1",
    defaultMessage:
      "Je déteste rester longtemps seul et je préfère travailler en groupe. J’aime sortir, rencontrer des gens, et passer de bons moments en compagnie d’autres personnes.",
  },
  TRAITSPERSONNALITE1BIS: {
    id: "app.traitspersonnalite1bis",
    defaultMessage:
      "Après le travail ce que j’aime le mieux c’est rester à la maison. Je déteste me rendre à des soirées où je suis obligé/e de parler à beaucoup de monde. Je suis très facilement dérangé/e par le bruit et je n’aimerais pas passer mes vacances dans des stations touristiques.",
  },

  TRAITSPERSONNALITE2: {
    id: "app.traitspersonnalite2",
    defaultMessage:
      "Je me mets volontiers dans des situations excitantes et je me sens donc attiré/e par les sports : la varappe, le parapente ou la plongée sous-marine. J’aime les voitures, les motos ou les bateaux rapides et je me divertis volontiers avec des films d’horreur ou des attractions excitantes de fêtes foraines. J’adore aussi le jeu de hazard et je prends des risques même quand il s’agit de l’argent.",
  },
  TRAITSPERSONNALITE2BIS: {
    id: "app.traitspersonnalite2bis",
    defaultMessage:
      "Je ne comprends pas comment certaines personnes peuvent risquer leur vie en pratiquant un sport dangereux alors qu’on peut faire des choses bien moins risquées. En choisissant une voiture ou des outils, je tiens compte avant tout de la sécurité. Comme distraction, j’aime aller au théâtre où voir un film sérieux et pendant mes vacances, je tiens surtout à me reposer.",
  },

  TRAITSPERSONNALITE3: {
    id: "app.traitspersonnalite3",
    defaultMessage:
      "Je considère qu’il est malsain de réprimer ses impulsions et je ne peux que rarement résister aux tentations. Quand tout à coup j’ai envie de faire quelque chose, je le fais coûte que coûte. Je pense qu’il est bien d’agir spontanément et de montrer ses sentiments.",
  },
  TRAITSPERSONNALITE3BIS: {
    id: "app.traitspersonnalite3bis",
    defaultMessage:
      "Je ne comprends pas les gens qui cèdent à tous leurs désirs. Je réfléchis toujours avant de faire quelque chose que j’aimerais beaucoup faire. En fait, cela ne m’arrive pas souvent de vouloir obtenir ou faire quelque chose à tout prix. J’essaie de contrôler mes sentiments autant que possible.",
  },

  TRAITSPERSONNALITE4: {
    id: "app.traitspersonnalite4",
    defaultMessage:
      "Quelques fois, je trouve difficile de lutter contre les sentiments de tristesse et de solitude et parfois la vie me semble sombre et sans espoir. J’ai tendance à baisser les bras très vite quand quelque chose va de travers.",
  },
  TRAITSPERSONNALITE4BIS: {
    id: "app.traitspersonnalite4bis",
    defaultMessage:
      "Je ne suis pas du genre triste et je ne suis pas facilement découragé(e). Je suis de nature optimiste et généralement, je gère bien les situations difficiles. Je n’arrive pas à m’imaginer ce que l’on peut ressentir quand on est dépressif/ve.",
  },

  TRAITSPERSONNALITE5: {
    id: "app.traitspersonnalite5",
    defaultMessage:
      "Je suis très sûr/e de moi. Je n’ai pas peur de me comparer aux autres et je n’ai jamais souffert d’un complexe d’infériorité. Je sais aussi accepter les critiques même très dures.",
  },
  TRAITSPERSONNALITE5BIS: {
    id: "app.traitspersonnalite5bis",
    defaultMessage:
      "Parfois je doute de moi-même et j’éprouve souvent de la honte ou de la culpabilité. Par conséquent, j’ai de la peine à supporter les critiques. Mon estime de moi est probablement inférieure à celle des autres.",
  },

  TRAITSPERSONNALITE6: {
    id: "app.traitspersonnalite6",
    defaultMessage:
      "En général, j’ai ma propre opinion et donc je ne supporte pas de devoir me soumettre à d’autres personnes. Pour cette raison, j’ai tendance à être assez dominant/e dans les discussions et j’essaie d’influencer les autres. Dans les groupes j’ai tendance à prendre l’initiative et à conduire à des décisions.",
  },
  TRAITSPERSONNALITE6BIS: {
    id: "app.traitspersonnalite6bis",
    defaultMessage:
      "J’accepte facilement les conseils de personnes en position d’autorité. Je n’aime pas mettre en avant mon point de vue dans les discussions et je déteste être vu/e comme dominant/e. Par conséquent, je préfère laisser à d’autres la responsabilité de prendre des décisions pour le groupe.",
  },

  TRAITSPERSONNALITE7: {
    id: "app.traitspersonnalite7",
    defaultMessage:
      "Je trouve juste de réagir agressivement lorsque mes intérêts sont menacés et je ne peux pas m’empêcher de répondre de la même façon quand quelqu’un se comporte de manière agressive envers moi. En général, il y a peu de gens que j’aime bien et en qui j’ai confiance. Par contre, il y en a beaucoup que je ne peux vraiment pas supporter.",
  },
  TRAITSPERSONNALITE7BIS: {
    id: "app.traitspersonnalite7bis",
    defaultMessage:
      "Je trouve toujours quelque chose de positif chez les gens, même chez les plus désagréables. Je suis une personne extrêmement pacifique et lors de conflits, je préfère céder, même si je dois mettre de côté mes intérêts personnels.",
  },

  TRAITSPERSONNALITE8: {
    id: "app.traitspersonnalite8",
    defaultMessage:
      "J’agis consciencieusement dans toutes les circonstances et je passe en général pour un/e perfectionniste. On peut me faire confiance et je ne renonce pas facilement lorsque des difficultés surviennent dans la réalisation d’un projet.",
  },
  TRAITSPERSONNALITE8BIS: {
    id: "app.traitspersonnalite8bis",
    defaultMessage:
      "Je ne suis pas une personne très compulsive et je trouve difficile d’organiser mon temps. C’est pourquoi on ne peut pas toujours compter sur moi en ce qui concerne les rendez-vous et les engagements. Je gère les problèmes comme ils viennent et je suis incapable de tenir compte de tous les petits détails.",
  },

  //PREFERENCES PROFESSIONNELLES
  PREFERENCESPRO1: {
    id: "app.preferencespro1",
    defaultMessage:
      "Veuillez choisir l’emploi que vous préféreriez en cliquant sur l’alternative correspondante.",
  },
  PREFERENCESPRO1REPONSE1: {
    id: "app.preferencespro1reponse1",
    defaultMessage: 'Exercer du "leadership" / Avoir beaucoup d’autorité',
  },
  PREFERENCESPRO1REPONSE2: {
    id: "app.preferencespro1reponse2",
    defaultMessage: "Tâches très variées / Grande flexibilité",
  },

  PREFERENCESPRO2REPONSE1: {
    id: "app.preferencespro2reponse1",
    defaultMessage: " Stimulation intellectuelle / Potentiel de créativité",
  },
  PREFERENCESPRO2REPONSE2: {
    id: "app.preferencespro2reponse2",
    defaultMessage: "  Salaire élevé / Promotion rapide",
  },

  PREFERENCESPRO3REPONSE1: {
    id: "app.preferencespro3reponse1",
    defaultMessage: "  Aimer son travail / Avoir du plaisir au travail",
  },
  PREFERENCESPRO3REPONSE2: {
    id: "app.preferencespro3reponse2",
    defaultMessage: "Sécurité de l’emploi / Engagement de longue durée",
  },

  PREFERENCESPRO4REPONSE1: {
    id: "app.preferencespro4reponse1",
    defaultMessage: "  Salaire élevé / Promotion rapide",
  },
  PREFERENCESPRO4REPONSE2: {
    id: "app.preferencespro4reponse2",
    defaultMessage: '  Exercer du "leadership" / Avoir beaucoup d’autorité',
  },

  PREFERENCESPRO5REPONSE1: {
    id: "app.preferencespro5reponse1",
    defaultMessage: " Stimulation intellectuelle / Potentiel de créativité",
  },
  PREFERENCESPRO5REPONSE2: {
    id: "app.preferencespro5reponse2",
    defaultMessage: "    Sécurité de l’emploi / Engagement de longue durée",
  },

  PREFERENCESPRO6REPONSE1: {
    id: "app.preferencespro6reponse1",
    defaultMessage: "  Tâches très variées / Grande flexibilité",
  },
  PREFERENCESPRO6REPONSE2: {
    id: "app.preferencespro6reponse2",
    defaultMessage: " Aimer son travail / Avoir du plaisir au travail",
  },

  PREFERENCESPRO7REPONSE1: {
    id: "app.preferencespro7reponse1",
    defaultMessage: 'Exercer du "leadership" / Avoir beaucoup d’autorité',
  },
  PREFERENCESPRO7REPONSE2: {
    id: "app.preferencespro7reponse2",
    defaultMessage: "Stimulation intellectuelle / Potentiel de créativité",
  },

  PREFERENCESPRO8REPONSE1: {
    id: "app.preferencespro8reponse1",
    defaultMessage: " Sécurité de l’emploi / Engagement de longue durée",
  },
  PREFERENCESPRO8REPONSE2: {
    id: "app.preferencespro8reponse2",
    defaultMessage: "Tâches très variées / Grande flexibilité",
  },

  PREFERENCESPRO9REPONSE1: {
    id: "app.preferencespro9reponse1",
    defaultMessage: " Aimer son travail / Avoir du plaisir au travail",
  },
  PREFERENCESPRO9REPONSE2: {
    id: "app.preferencespro9reponse2",
    defaultMessage: " Salaire élevé / Promotion rapide",
  },

  PREFERENCESPRO10REPONSE1: {
    id: "app.preferencespro10reponse1",
    defaultMessage: 'Exercer du "leadership" / Avoir beaucoup d’autorité',
  },
  PREFERENCESPRO10REPONSE2: {
    id: "app.preferencespro10reponse2",
    defaultMessage: "Sécurité de l’emploi / Engagement de longue durée",
  },

  PREFERENCESPRO11REPONSE1: {
    id: "app.preferencespro11reponse1",
    defaultMessage: "Salaire élevé / Promotion rapide",
  },
  PREFERENCESPRO11REPONSE2: {
    id: "app.preferencespro11reponse2",
    defaultMessage: "Tâches très variées / Grande flexibilité",
  },

  PREFERENCESPRO12REPONSE1: {
    id: "app.preferencespro12reponse1",
    defaultMessage: "Stimulation intellectuelle / Potentiel de créativité",
  },
  PREFERENCESPRO12REPONSE2: {
    id: "app.preferencespro12reponse2",
    defaultMessage: "   Aimer son travail / Avoir du plaisir au travail",
  },

  PREFERENCESPRO13REPONSE1: {
    id: "app.preferencespro13reponse1",
    defaultMessage: "Sécurité de l’emploi / Engagement de longue durée",
  },
  PREFERENCESPRO13REPONSE2: {
    id: "app.preferencespro13reponse2",
    defaultMessage: "Salaire élevé / Promotion rapide",
  },

  PREFERENCESPRO14REPONSE1: {
    id: "app.preferencespro14reponse1",
    defaultMessage: "Aimer son travail / Avoir du plaisir au travail",
  },
  PREFERENCESPRO14REPONSE2: {
    id: "app.preferencespro14reponse2",
    defaultMessage: 'Exercer du "leadership" / Avoir beaucoup d’autorité',
  },

  PREFERENCESPRO15REPONSE1: {
    id: "app.preferencespro15reponse1",
    defaultMessage: " Tâches très variées / Grande flexibilité",
  },
  PREFERENCESPRO15REPONSE2: {
    id: "app.preferencespro15reponse2",
    defaultMessage: "Stimulation intellectuelle / Potentiel de créativité",
  },

  //SITUATIONS DE CRISE
  //ces 2 phrases apparaissent sur toutes les pages qui ont les questions les strategies de crise
  SITUATIONSCRISE: {
    id: "app.situationcrise",
    defaultMessage:
      "Vous avez travaillé très intensivement sur un projet professionnel important. Mais ce projet fut un effroyable échec. ",
  },
  SITUATIONSCRISE1: {
    id: "app.situationscrise1",
    defaultMessage:
      "Quelle est la probabilité que vous utilisiez cette stratégie dans la situation donnée ? ",
  },
  SITUATIONCRISETITLE: {
    id: "app.situationcrisetitle",
    defaultMessage: "SITUATION",
  },
  STRATEGYCRISETITLE: {
    id: "app.strategycrisetitle",
    defaultMessage: "STRATEGIE",
  },
  SITUATIONCRISELVL1: {
    id: "app.situationcriselvl1",
    defaultMessage: "Très basse",
  },
  SITUATIONCRISELVL2: { id: "app.situationcriselvl2", defaultMessage: "Basse" },
  SITUATIONCRISELVL3: {
    id: "app.situationcriselvl3",
    defaultMessage: "Modérée",
  },
  SITUATIONCRISELVL4: {
    id: "app.situationcriselvl4",
    defaultMessage: "Relativement élevée",
  },
  SITUATIONCRISELVL5: {
    id: "app.situationcriselvl5",
    defaultMessage: "Élevée",
  },
  SITUATIONCRISELVL6: {
    id: "app.situationcriselvl6",
    defaultMessage: "Très élevée",
  },

  STRATEGIECRISE1A: {
    id: "app.strategiecrise1a",
    defaultMessage:
      "J’utilise cette expérience pour me faire une image réaliste de moi-même. ",
  },
  STRATEGIECRISE1B: {
    id: "app.strategiecrise1b",
    defaultMessage:
      "Je pense aux progrès que je dois faire pour mieux maîtriser à l’avenir des problèmes similaires. ",
  },
  STRATEGIECRISE1C: {
    id: "app.strategiecrise1c",
    defaultMessage:
      "J’essaie d’adapter mes objectifs et mes désirs aux circonstances. ",
  },

  STRATEGIECRISE2A: {
    id: "app.strategiecrise2a",
    defaultMessage: "J’essaie d’acquérir une vision claire de ma situation. ",
  },
  STRATEGIECRISE2B: {
    id: "app.strategiecrise2b",
    defaultMessage:
      "Je pense à tout ce que je peux faire pour faire face à cette situation.",
  },
  STRATEGIECRISE2C: {
    id: "app.strategiecrise2c",
    defaultMessage:
      "J’étudie les avantages et inconvénients des différentes façons d’agir. ",
  },

  STRATEGIECRISE3A: {
    id: "app.strategiecrise3a",
    defaultMessage:
      "Je me dis que ça ne vaut pas la peine de s’énerver pour ce qui s’est passé.",
  },
  STRATEGIECRISE3B: {
    id: "app.strategiecrise3b",
    defaultMessage:
      "J’essaie d’éviter que la situation m’éprouve émotionnellement.",
  },
  STRATEGIECRISE3C: {
    id: "app.strategiecrise3c",
    defaultMessage: "J’essaie de couper tout sentiment à la racine.",
  },

  STRATEGIECRISE4A: {
    id: "app.strategiecrise4a",
    defaultMessage:
      "Je vois un psychologue ou un homme d’église pour pouvoir parler de mes sentiments.",
  },
  STRATEGIECRISE4B: {
    id: "app.strategiecrise4b",
    defaultMessage:
      "J’essaie de trouver un groupe d’entraide dans lequel je puisse partager mes sentiments avec d’autres.",
  },
  STRATEGIECRISE4C: {
    id: "app.strategiecrise4c",
    defaultMessage:
      "Je m’adresse à quelqu’un qui puisse me comprendre et compatir à mes sentiments. ",
  },

  STRATEGIECRISE5A: {
    id: "app.strategiecrise5a",
    defaultMessage:
      "Je passe sans cesse en revue tous les aspects de mon problème.",
  },
  STRATEGIECRISE5B: {
    id: "app.strategiecrise5b",
    defaultMessage:
      "Quand je me réveille la nuit, je rumine aussitôt mon problème.",
  },
  STRATEGIECRISE5C: {
    id: "app.strategiecrise5c",
    defaultMessage:
      "Je réfléchis constamment à mon problème et, par conséquent, je ne peux plus vraiment me concentrer sur autre chose.",
  },

  STRATEGIECRISE6A: {
    id: "app.strategiecrise6a",
    defaultMessage:
      "Je cherche d’abord la faute en moi pour ce qui s’est passé. ",
  },
  STRATEGIECRISE6B: {
    id: "app.strategiecrise6b",
    defaultMessage:
      "Je me demande pourquoi je me mets toujours dans de telles situations.",
  },
  STRATEGIECRISE6C: {
    id: "app.strategiecrise6c",
    defaultMessage:
      "J’essaie d’évaluer au mieux à quel point je suis responsable de ce qui est arrivé. ",
  },

  STRATEGIECRISE7A: {
    id: "app.strategiecrise7a",
    defaultMessage:
      "Je cherche conseil et secours auprès d’amis ou de parents proches.",
  },
  STRATEGIECRISE7B: {
    id: "app.strategiecrise7b",
    defaultMessage:
      "J’essaie de trouver une personne compétente qui puisse m’aider à résoudre mon problème.",
  },
  STRATEGIECRISE7C: {
    id: "app.strategiecrise7c",
    defaultMessage:
      "Je m’efforce de trouver des gens qui ont maîtrisé des problèmes semblables pour profiter de leur expérience.",
  },

  STRATEGIECRISE8A: {
    id: "app.strategiecrise8a",
    defaultMessage: "J’imagine que les choses vont s’arranger d’elles-mêmes. ",
  },
  STRATEGIECRISE8B: {
    id: "app.strategiecrise8b",
    defaultMessage:
      "J’espère qu’il s’agit simplement d’une erreur et que tout se résoudra.",
  },
  STRATEGIECRISE8C: {
    id: "app.strategiecrise8c",
    defaultMessage: "Je souhaite que quelqu’un remette les choses en ordre.",
  },

  STRATEGIECRISE9A: {
    id: "app.strategiecrise9a",
    defaultMessage:
      "Je me dis que j’ai déjà résolu des problèmes beaucoup plus difficiles.",
  },
  STRATEGIECRISE9B: {
    id: "app.strategiecrise9b",
    defaultMessage:
      "Je pense qu’à ma place d’autres auraient craqué bien avant moi.",
  },
  STRATEGIECRISE9C: {
    id: "app.strategiecrise9c",
    defaultMessage:
      "Je me répète que je suis quelqu’un sachant maîtriser une telle situation sans trop de difficultés. ",
  },

  //preferences de vos tendances
  //apparait ds chaque slide
  PREFERENCESTENDANCESQUESTION1: {
    id: "app.preferencestendancesquestion1",
    defaultMessage:
      "Jusqu’à quel point la déclaration suivante s’applique-t-elle à vous ? ",
  },
  PREFERENCESTENDANCES1: {
    id: "app.preferencestendances1",
    defaultMessage:
      "Les gens n’ont pas besoin de me dire ce qu’ils ressentent, je le devine. ",
  },
  PREFERENCESTENDANCES2: {
    id: "app.preferencestendances2",
    defaultMessage: "Je passe assez vite par-dessus mes accès de colère. ",
  },
  PREFERENCESTENDANCES3: {
    id: "app.preferencestendances3",
    defaultMessage:
      "Je suis très mauvais(e) au mime ou à d’autres jeux de ce type. ",
  },
  PREFERENCESTENDANCES4: {
    id: "app.preferencestendances4",
    defaultMessage:
      "Les gens me disent que je ferais un(e) bon(ne) acteur(rice). ",
  },
  PREFERENCESTENDANCES5: {
    id: "app.preferencestendances5",
    defaultMessage:
      "Quand je suis en colère, j’explose ou je ronge mon frein en silence. ",
  },
  PREFERENCESTENDANCES6: {
    id: "app.preferencestendances6",
    defaultMessage:
      "En général, j’arrive assez bien à donner une bonne impression de moi aux autres. ",
  },
  PREFERENCESTENDANCES7: {
    id: "app.preferencestendances7",
    defaultMessage:
      "Je peux bien contrôler des sentiments inopportuns et ainsi me concentrer sur ce que je fais.",
  },
  PREFERENCESTENDANCES8: {
    id: "app.preferencestendances8",
    defaultMessage:
      "Je montre que j’apprécie une personne en la touchant ou en la serrant dans mes bras.",
  },
  PREFERENCESTENDANCES9: {
    id: "app.preferencestendances9",
    defaultMessage:
      "J’aime prendre des trajets différents pour me rendre en des mêmes lieux. ",
  },
  PREFERENCESTENDANCES10: {
    id: "app.preferencestendances10",
    defaultMessage:
      "Quand je suis anxieux(se) à l’idée d’une épreuve (examen, discours en public), j’ai des difficultés à bien me préparer.",
  },
  PREFERENCESTENDANCES11: {
    id: "app.preferencestendances11",
    defaultMessage:
      "J’ai des difficultés à gérer le conflit et les désagréments émotionnels dans mes relations. ",
  },
  PREFERENCESTENDANCES12: {
    id: "app.preferencestendances12",
    defaultMessage:
      "Je n’aime pas être regardé(e) par un grand nombre de personnes. ",
  },
  PREFERENCESTENDANCES13: {
    id: "app.preferencestendances13",
    defaultMessage:
      "Mon quotidien est plein de choses qui retiennent mon intérêt. ",
  },
  PREFERENCESTENDANCES14: {
    id: "app.preferencestendances14",
    defaultMessage: "Je suis généreux(se) avec mes amis.",
  },
  PREFERENCESTENDANCES15: {
    id: "app.preferencestendances15",
    defaultMessage: "J’ai d’habitude une expression faciale neutre. ",
  },
  PREFERENCESTENDANCES16: {
    id: "app.preferencestendances16",
    defaultMessage: "En général, je pense soigneusement avant d’agir.",
  },
  PREFERENCESTENDANCES17: {
    id: "app.preferencestendances17",
    defaultMessage:
      "J’aime avoir affaire à des situations nouvelles et inhabituelles.",
  },
  PREFERENCESTENDANCES18: {
    id: "app.preferencestendances18",
    defaultMessage: "J’aime passer inaperçu(e) dans une foule. ",
  },
  PREFERENCESTENDANCES19: {
    id: "app.preferencestendances19",
    defaultMessage: "Je suis plus curieux(se) que la plupart des gens. ",
  },
  PREFERENCESTENDANCES20: {
    id: "app.preferencestendances20",
    defaultMessage: "Je peux facilement exprimer mes émotions par téléphone. ",
  },
  PREFERENCESTENDANCES21: {
    id: "app.preferencestendances21",
    defaultMessage:
      "Je suis conscient(e) de mes sentiments, même les plus subtils. ",
  },
  PREFERENCESTENDANCES22: {
    id: "app.preferencestendances22",
    defaultMessage: "On me considère comme une personne très énergique.",
  },
  PREFERENCESTENDANCES23: {
    id: "app.preferencestendances23",
    defaultMessage:
      "Je touche souvent physiquement mes amis au cours d’une conversation.",
  },
  PREFERENCESTENDANCES24: {
    id: "app.preferencestendances24",
    defaultMessage: "Je suis timide en face d’étranger. ",
  },
  PREFERENCESTENDANCES25: {
    id: "app.preferencestendances25",
    defaultMessage: "Mon rire est léger et discret.",
  },
  PREFERENCESTENDANCES26: {
    id: "app.preferencestendances26",
    defaultMessage:
      "Lors de petites fêtes, je suis souvent le centre d'attention.",
  },
  PREFERENCESTENDANCES27: {
    id: "app.preferencestendances27",
    defaultMessage: "J’aime faire des choses nouvelles et différentes. ",
  },
  PREFERENCESTENDANCES28: {
    id: "app.preferencestendances28",
    defaultMessage:
      "J’ai souvent de la difficulté à me débarrasser de ma mauvaise humeur. ",
  },
  PREFERENCESTENDANCES29: {
    id: "app.preferencestendances29",
    defaultMessage:
      "Ma compréhension des sentiments des autres accroît ma tolérance à leur égard. ",
  },
  PREFERENCESTENDANCES30: {
    id: "app.preferencestendances30",
    defaultMessage: "Je me remets rapidement d’un sursaut de surprise. ",
  },
  PREFERENCESTENDANCES31: {
    id: "app.preferencestendances31",
    defaultMessage:
      "Je me décrirais volontiers comme étant une assez forte personnalité. ",
  },
  PREFERENCESTENDANCES32: {
    id: "app.preferencestendances32",
    defaultMessage: "La plupart des gens que je rencontre sont agréables. ",
  },
  PREFERENCESTENDANCES33: {
    id: "app.preferencestendances33",
    defaultMessage:
      "Je suis capable de prendre un regard séducteur si je le désire. ",
  },
  PREFERENCESTENDANCES34: {
    id: "app.preferencestendances34",
    defaultMessage:
      "J’aime goûter des nourritures que je ne connais pas encore. ",
  },
  PREFERENCESTENDANCES35: {
    id: "app.preferencestendances35",
    defaultMessage:
      "En général, je réussis à identifier correctement le climat émotionnel d’un groupe ou d’une relation. ",
  },
  PREFERENCESTENDANCES36: {
    id: "app.preferencestendances36",
    defaultMessage:
      "Quand j’entends de la bonne musique, je peux difficilement rester en place. ",
  },
  PREFERENCESTENDANCES37: {
    id: "app.preferencestendances37",
    defaultMessage:
      "Je pense qu’utiliser mes sentiments me permet de prendre de grandes décisions. ",
  },
  PREFERENCESTENDANCES38: {
    id: "app.preferencestendances38",
    defaultMessage:
      "Au lieu d’abandonner face aux revers ou aux déceptions, je garde espoir et reste optimiste. ",
  },
  PREFERENCESTENDANCES39: {
    id: "app.preferencestendances39",
    defaultMessage:
      "Je suis capable de résister à la tentation pour réaliser mes objectifs plutôt que de me laisser diriger par mes impulsions. ",
  },

  //la nature des vos reactions emo
  //les 2 phrases suivant appraissent ds chaque slide de cette catégorie
  REACTIONSEMOCONSIGNE1: {
    id: "app.reactiosemoconsigne1",
    defaultMessage:
      "Vous devez travailler avec l’un de vos collègues pour terminer un projet important. Il vous impose ses idées sur la marche à suivre et n’arrête pas de critiquer votre travail. ",
  },
  REACTIONSEMOCONSIGNE2: {
    id: "app.reactiosemoconsigne2",
    defaultMessage:
      "Quelles émotions ressentiriez-vous dans ces situations et à quelle intensité ? ",
  },
  REACTIONSEMOPASDUTOUT: {
    id: "app.reactionsemopasdutout",
    defaultMessage: "pas du tout",
  },
  REACTIONSEMOTRESFORTEMENT: {
    id: "app.reactionsemotresfortement",
    defaultMessage: "très fortement",
  },

  //les possiblilités de reponses pour chaque quesitions de cette catégories
  REACTIONSEMO1POSSIBILITE1: {
    id: "app.reactionsemo1possibilite1",
    defaultMessage: "Résignation, tristesse ",
  },
  REACTIONSEMO1POSSIBILITE2: {
    id: "app.reactionsemo1possibilite2",
    defaultMessage: "Irritation, colère ",
  },
  REACTIONSEMO1POSSIBILITE3: {
    id: "app.reactionsemo1possibilite3",
    defaultMessage: "Tranquillité, sérénité ",
  },
  REACTIONSEMO1POSSIBILITE4: {
    id: "app.reactionsemo1possibilite4",
    defaultMessage: "Inquiétude, anxiété ",
  },
  REACTIONSEMO1POSSIBILITE5: {
    id: "app.reactionsemo1possibilite5",
    defaultMessage: "Embarras, honte",
  },

  REACTIONSEMO1: {
    id: "app.reactiosemo1",
    defaultMessage:
      "Vous avez du mal à vous lever le matin et par conséquent vous êtes souvent en retard au travail. Aujourd’hui, alors que vous aviez 30 minutes de retard en entrant, vous avez croisé votre chef qui semblait être contrarié. Sa secrétaire vient de vous téléphoner pour vous dire qu’il veut vous voir.",
  },
  REACTIONSEMO2: {
    id: "app.reactiosemo2",
    defaultMessage:
      "Au cours d’une discussion orageuse, vous avez fait des remarques acerbes sur un collègue absent. Il vous semble maintenant qu’il vous évite.",
  },
  REACTIONSEMO3: {
    id: "app.reactiosemo3",
    defaultMessage:
      "La semaine dernière, vous avez enfin réussi à prendre rendez-vous avec votre supérieur pour parler de votre promotion. Vous venez d’arriver à la maison après le travail et vous réalisez que vous avez complètement oublié ce rendez-vous qui devait avoir lieu l’après-midi même.",
  },
  REACTIONSEMO4: {
    id: "app.reactiosemo4",
    defaultMessage:
      "Ces derniers jours, vous avez passé beaucoup de temps sur un problème difficile. Il vous semblait que vous aviez finalement trouvé la solution. Maintenant, il s’avère que vous aviez négligé un point important.",
  },
  REACTIONSEMO5: {
    id: "app.reactiosemo5",
    defaultMessage:
      "Vous devez travailler avec l'un de vos collègues pour terminer un projet important. Il vous impose ses idées sur la marche à suivre et n'arrête pas de critiquer votre travail.",
  },

  //test de logique
  TESTLOGIQUEAFFIRMATIONTITLE: {
    id: "app.testlogiqueaffirmationtitle",
    defaultMessage: "AFFIRMATIONS",
  },
  AIDECHECKBOX: {
    id: "app.aidecheckbox",
    defaultMessage:
      "Merci de cliquer sur chacune des déductions qui vous semble vraie.",
  },

  TESTLOGIQUE1AFFIRMATIONA: {
    id: "app.testlogique1affirmationa",
    defaultMessage: "A : Tous les sportifs sont des singes",
  },
  TESTLOGIQUE1AFFIRMATIONB: {
    id: "app.testlogique1affirmationb",
    defaultMessage: "B : Quelques singes boivent du thé",
  },
  TESTLOGIQUE1: {
    id: "app.testlogique1",
    defaultMessage:
      "Veuillez indiquer, pour chacune des déductions suivantes, si elle est vraie ou fausse. Plusieurs déductions peuvent être vraies.",
  },
  TESTLOGIQUE1DEDUCTIONS1: {
    id: "app.testlogique1deductions1",
    defaultMessage: "Tous les singes sont des sportifs ",
  },
  TESTLOGIQUE1DEDUCTIONS2: {
    id: "app.testlogique1deductions2",
    defaultMessage: "Aucun sportif ne boit du thé ",
  },
  TESTLOGIQUE1DEDUCTIONS3: {
    id: "app.testlogique1deductions3",
    defaultMessage: "Quelques singes sont des sportifs ",
  },
  TESTLOGIQUE1DEDUCTIONS4: {
    id: "app.testlogique1deductions4",
    defaultMessage: "Les sportifs boivent n’importe quoi ",
  },
  TESTLOGIQUE1DEDUCTIONS5: {
    id: "app.testlogique1deductions5",
    defaultMessage: "Quelques sportifs ne sont pas des singes ",
  },
  TESTLOGIQUE1DEDUCTIONS6: {
    id: "app.testlogique1deductions6",
    defaultMessage: "Un sportif est susceptible de boire du thé ",
  },

  TESTLOGIQUE2AFFIRMATIONA: {
    id: "app.testlogique2affirmationa",
    defaultMessage: "Quelques chiens sont en métal",
  },
  TESTLOGIQUE2AFFIRMATIONB: {
    id: "app.testlogique2affirmationb",
    defaultMessage: "Le métal est rigide mais n’aboie pas",
  },
  TESTLOGIQUE2: { id: "app.testlogique2", defaultMessage: "" },
  TESTLOGIQUE2DEDUCTIONS1: {
    id: "app.testlogique2deductions1",
    defaultMessage: "Il y a des chiens qui sont rigides ",
  },
  TESTLOGIQUE2DEDUCTIONS2: {
    id: "app.testlogique2deductions2",
    defaultMessage: "Ce qui est rigide, n’aboie pas ",
  },
  TESTLOGIQUE2DEDUCTIONS3: {
    id: "app.testlogique2deductions3",
    defaultMessage: "Quelques chiens n’aboient pas ",
  },
  TESTLOGIQUE2DEDUCTIONS4: {
    id: "app.testlogique2deductions4",
    defaultMessage: "Les animaux en métal n’aboient pas ",
  },
  TESTLOGIQUE2DEDUCTIONS5: {
    id: "app.testlogique2deductions5",
    defaultMessage: "S’il aboie, il peut être en métal ",
  },
  TESTLOGIQUE2DEDUCTIONS6: {
    id: "app.testlogique2deductions6",
    defaultMessage: "Les chiens aboyant ne sont pas en métal ",
  },

  TESTLOGIQUE3AFFIRMATIONA: {
    id: "app.testlogique3affirmationa",
    defaultMessage: "A : Tous les enseignants sont des éléphants",
  },
  TESTLOGIQUE3AFFIRMATIONB: {
    id: "app.testlogique3affirmationb",
    defaultMessage: "B : Tous les éléphants savent nager",
  },
  TESTLOGIQUE3: { id: "app.testlogique3", defaultMessage: "" },
  TESTLOGIQUE3DEDUCTIONS1: {
    id: "app.testlogique3deductions1",
    defaultMessage: "Quelqu’un qui sait nager est un éléphant ",
  },
  TESTLOGIQUE3DEDUCTIONS2: {
    id: "app.testlogique3deductions2",
    defaultMessage: "Tous les éléphants sont des enseignants ",
  },
  TESTLOGIQUE3DEDUCTIONS3: {
    id: "app.testlogique3deductions3",
    defaultMessage: "Tous les enseignants savent nager ",
  },
  TESTLOGIQUE3DEDUCTIONS4: {
    id: "app.testlogique3deductions4",
    defaultMessage: "Quelqu’un qui sait nager est un enseignant ",
  },
  TESTLOGIQUE3DEDUCTIONS5: {
    id: "app.testlogique3deductions5",
    defaultMessage: "Quelques éléphants sont des enseignants",
  },
  TESTLOGIQUE3DEDUCTIONS6: {
    id: "app.testlogique3deductions6",
    defaultMessage: "Quelqu’un qui ne sait pas nager n’est pas un éléphant ",
  },

  TESTLOGIQUE4AFFIRMATIONA: {
    id: "app.testlogique4affirmationa",
    defaultMessage:
      "A : Les serpents peuvent marcher puisqu’ils ont des jambes",
  },
  TESTLOGIQUE4AFFIRMATIONB: {
    id: "app.testlogique4affirmationb",
    defaultMessage: " B : Les vaches n’ont pas de jambes",
  },
  TESTLOGIQUE4: { id: "app.testlogique4", defaultMessage: "" },
  TESTLOGIQUE4DEDUCTIONS1: {
    id: "app.testlogique4deductions1",
    defaultMessage: "Il est possible de marcher avec des jambes ",
  },
  TESTLOGIQUE4DEDUCTIONS2: {
    id: "app.testlogique4deductions2",
    defaultMessage: "Sans jambes, on ne peut pas marcher sur le sol ",
  },
  TESTLOGIQUE4DEDUCTIONS3: {
    id: "app.testlogique4deductions3",
    defaultMessage: "Les vaches ne peuvent pas marcher ",
  },
  TESTLOGIQUE4DEDUCTIONS4: {
    id: "app.testlogique4deductions4",
    defaultMessage: "Les serpents et les vaches n’ont rien en commun ",
  },
  TESTLOGIQUE4DEDUCTIONS5: {
    id: "app.testlogique4deductions5",
    defaultMessage: "Tous les serpents sont des vaches ",
  },
  TESTLOGIQUE4DEDUCTIONS6: {
    id: "app.testlogique4deductions6",
    defaultMessage: "Les vaches ne sont pas des serpents ",
  },

  //l'importance des valeurs humaines
  VALEURSHUMAINES: {
    id: "app.valeurshumaines",
    defaultMessage: "Veuillez cliquer sur l’alternative que vous choisiriez",
  },
  VALEURSHUMAINES1: {
    id: "app.valeurshumaines1",
    defaultMessage: "Pouvoir /Influence",
  },
  VALEURSHUMAINES1BIS: {
    id: "app.valeurshumaines1bis",
    defaultMessage: "Honneur /Intégrité / Honneur",
  },

  VALEURSHUMAINES2: {
    id: "app.valeurshumaines2",
    defaultMessage: "Succès /Statut",
  },
  VALEURSHUMAINES2BIS: {
    id: "app.valeurshumaines2bis",
    defaultMessage: "Moralité / Conduite éthique /Ethique",
  },

  VALEURSHUMAINES3: {
    id: "app.valeurshumaines3",
    defaultMessage: "Paix /Harmonie",
  },
  VALEURSHUMAINES3BIS: {
    id: "app.valeurshumaines3bis",
    defaultMessage: " Amour /Affection",
  },

  VALEURSHUMAINES4: {
    id: "app.valeurshumaines4",
    defaultMessage: "Moralité / Conduite éthique /Ethique",
  },
  VALEURSHUMAINES4BIS: {
    id: "app.valeurshumaines4bis",
    defaultMessage: "Pouvoir /Influence",
  },

  VALEURSHUMAINES5: {
    id: "app.valeurshumaines5",
    defaultMessage: "Succès /Statut",
  },
  VALEURSHUMAINES5BIS: {
    id: "app.valeurshumaines5bis",
    defaultMessage: "Amour /Affection",
  },

  VALEURSHUMAINES6: {
    id: "app.valeurshumaines6",
    defaultMessage: "  Honneur /Intégrité / Honneur",
  },
  VALEURSHUMAINES6BIS: {
    id: "app.valeurshumaines6bis",
    defaultMessage: "Paix /Harmonie",
  },

  VALEURSHUMAINES7: {
    id: "app.valeurshumaines7",
    defaultMessage: " Pouvoir /Influence",
  },
  VALEURSHUMAINES7BIS: {
    id: "app.valeurshumaines7bis",
    defaultMessage: "Succès /Statut",
  },

  VALEURSHUMAINES8: {
    id: "app.valeurshumaines8",
    defaultMessage: "  Amour /Affection",
  },
  VALEURSHUMAINES8BIS: {
    id: "app.valeurshumaines8bis",
    defaultMessage: " Honneur /Intégrité / Honneur",
  },

  VALEURSHUMAINES9: {
    id: "app.valeurshumaines9",
    defaultMessage: " Paix /Harmonie",
  },
  VALEURSHUMAINES9BIS: {
    id: "app.valeurshumaines9bis",
    defaultMessage: "    Moralité / Conduite éthique /Ethique",
  },

  VALEURSHUMAINES10: {
    id: "app.valeurshumaines10",
    defaultMessage: "Pouvoir /Influence",
  },
  VALEURSHUMAINES10BIS: {
    id: "app.valeurshumaines10bis",
    defaultMessage: "Amour /Affection",
  },

  VALEURSHUMAINES11: {
    id: "app.valeurshumaines11",
    defaultMessage: " Moralité / Conduite éthique /Ethique",
  },
  VALEURSHUMAINES11BIS: {
    id: "app.valeurshumaines11bis",
    defaultMessage: " Honneur /Intégrité / Honneur",
  },

  VALEURSHUMAINES12: {
    id: "app.valeurshumaines12",
    defaultMessage: "Succès /Statut",
  },
  VALEURSHUMAINES12BIS: {
    id: "app.valeurshumaines12bis",
    defaultMessage: "Paix /Harmonie",
  },

  VALEURSHUMAINES13: {
    id: "app.valeurshumaines13",
    defaultMessage: "  Amour /Affection",
  },
  VALEURSHUMAINES13BIS: {
    id: "app.valeurshumaines13bis",
    defaultMessage: " Moralité / Conduite éthique /Ethique",
  },

  VALEURSHUMAINES14: {
    id: "app.valeurshumaines14",
    defaultMessage: "Paix /Harmonie",
  },
  VALEURSHUMAINES14BIS: {
    id: "app.valeurshumaines14bis",
    defaultMessage: "Pouvoir /Influence",
  },

  VALEURSHUMAINES15: {
    id: "app.valeurshumaines15",
    defaultMessage: "Honneur /Intégrité / Honneur",
  },
  VALEURSHUMAINES15BIS: {
    id: "app.valeurshumaines15bis",
    defaultMessage: " Succès / Statut",
  },

  //informations vous concernant
  INFOPERSO1: { id: "app.infoperso1", defaultMessage: "Vous êtes ..." },
  INFOPERSO1A: { id: "app.infoperso1a", defaultMessage: "Un homme" },
  INFOPERSO1B: { id: "app.infoperso1b", defaultMessage: "Une femme" },

  INFOPERSO2: { id: "app.infoperso2", defaultMessage: "Quel est votre âge?" },
  INFOPERSO2A: { id: "app.infoperso2a", defaultMessage: "moins de 20 ans" },
  INFOPERSO2B: { id: "app.infoperso2b", defaultMessage: "20-29 ans" },
  INFOPERSO2C: { id: "app.infoperso2c", defaultMessage: "30-39 ans" },
  INFOPERSO2D: { id: "app.infoperso2d", defaultMessage: "40-49 ans" },
  INFOPERSO2E: { id: "app.infoperso2e", defaultMessage: "50-59 ans" },
  INFOPERSO2F: { id: "app.infoperso2f", defaultMessage: "60 ans ou plus" },

  INFOPERSO3: {
    id: "app.infoperso3",
    defaultMessage:
      "Laquelle des descriptions ci-dessous correspond le mieux à votre niveau de scolarisation et de formation professionnelle ?",
  },
  INFOPERSO3A: {
    id: "app.infoperso3a",
    defaultMessage: "Ecole obligatoire et apprentissage ou formation technique",
  },
  INFOPERSO3B: {
    id: "app.infoperso3b",
    defaultMessage: "Ecole secondaire supérieure et école professionnelle",
  },
  INFOPERSO3C: {
    id: "app.infoperso3c",
    defaultMessage: "Université ou Haute Ecole Supérieure",
  },

  INFOPERSO4: {
    id: "app.infoperso4",
    defaultMessage: "Où avez-vous grandi ? ",
  },
  INFOPERSO4A: { id: "app.infoperso4a", defaultMessage: "Europe" },
  INFOPERSO4B: { id: "app.infoperso4b", defaultMessage: "Europe de l’est " },
  INFOPERSO4C: { id: "app.infoperso4c", defaultMessage: "Proche Orient " },
  INFOPERSO4D: { id: "app.infoperso4d", defaultMessage: "Afrique " },
  INFOPERSO4E: { id: "app.infoperso4e", defaultMessage: "Asie" },
  INFOPERSO4F: { id: "app.infoperso4f", defaultMessage: "Australie/NZ" },
  INFOPERSO4G: { id: "app.infoperso4g", defaultMessage: "Amérique Latine" },
  INFOPERSO4H: { id: "app.infoperso4h", defaultMessage: "Amérique du Nord" },

  INFOPERSO5: {
    id: "app.infoperso5",
    defaultMessage:
      "Dans quelle catégorie se situe votre poste actuel (ou votre dernier poste en date) ?",
  },
  INFOPERSO5A: { id: "app.infoperso5a", defaultMessage: "Cadre supérieur" },
  INFOPERSO5B: { id: "app.infoperso5b", defaultMessage: " Cadre moyen" },
  INFOPERSO5C: {
    id: "app.infoperso5c",
    defaultMessage: "Personnel de vente ou administratif",
  },
  INFOPERSO5D: { id: "app.infoperso5d", defaultMessage: "Personnel technique" },
  INFOPERSO5E: { id: "app.infoperso5e", defaultMessage: " Autres" },
  COMPARISONGROUP: {
    id: "app.comparisongroup",
    defaultMessage:
      "Groupe de comparaison :",
  },
  //MENU
  MENUCHANGERLANGUE: {
    id: "app.menuchangerlangue",
    defaultMessage: "Changer la langue",
  },
  MENUPROGRESSION: { id: "app.menuprogression", defaultMessage: "Progression" },

  //les boutons
  BTN_LOGIN: { id: "app.login_btn", defaultMessage: "Connexion" },
  BTNLOGOUT: { id: "app.btnlogout", defaultMessage: "Quitter" },
  BTNCONTINUER: { id: "app.btncontinuer", defaultMessage: "Continuer" },
  BTNCOMMENCER: { id: "app.btncommencer", defaultMessage: "Commencer" },
  BTNSUIVANT: { id: "app.btnsuivant", defaultMessage: "Suivant" },
  BTNTERMINER: { id: "app.btnterminer", defaultMessage: "Terminer" },
  BTNVOIRRESULTATS: {
    id: "app.btnvoirresultats",
    defaultMessage: "Voir les résultats",
  },

  BTNTELECHARGERINPUTSCSV: {
    id: "app.btntelechargerinputscsv",
    defaultMessage: "Télécharger les données saisies(.csv)",
  },
  BTNTELECHARGERINPUTSTXT: {
    id: "app.btntelechargerinputstxt",
    defaultMessage: "Télécharger les données saisies(.txt)",
  },
  BTNTELECHARGERRESULTATSCSV: {
    id: "app.btntelechargerresultatscsv",
    defaultMessage: "Télécharger les résultats(.csv)",
  },
  BTNTELECHARGERRESULTATSTXT: {
    id: "app.btntelechargerresultatstxt",
    defaultMessage: "Télécharger les résultats(.txt)",
  },
  RBVRAI: { id: "app.rbvrai", defaultMessage: "VRAI" },
  RBFAUX: { id: "app.rbFaux", defaultMessage: "FAUX" },
  RBPASDUTOUT: { id: "app.rbpasdutout", defaultMessage: "Pas du tout" },
  RBAPEINE: { id: "app.rbapeine", defaultMessage: "Un peu" },
  RBASSEZ: { id: "app.rbassez", defaultMessage: "Assez bien" },
  RBTOUTAFAIT: { id: "app.rbtoutafait", defaultMessage: "Complètement" },

  //Login page
  MSG_WRONG_EMAIL: {
    id: "app.msg_wrong_email",
    defaultMessage: "Email non existant",
  },
  MSG_WRONG_PASS: {
    id: "app.msg_wrong_pass",
    defaultMessage: "Mauvais mot de passe",
  },
  MSG_EMAIL_ALREADY: {
    id: "app.msg_already",
    defaultMessage: "Cet email à déjà passé le test scope",
  },
  MSG_SUCCESS: { id: "app.msg_success", defaultMessage: "Connexion réussie !" },
  LOGIN_TITLE: { id: "app.login_title", defaultMessage: "Connexion" },
  LOGIN_SUB_TITLE: { id: "app.sub-title", defaultMessage: "" },
  LOGIN_TEXT: { id: "app.login_text", defaultMessage: "" },
  LOGIN_EMAIL: { id: "app.login_email", defaultMessage: "Email" },
  LOGIN_KEY: { id: "app.login_key", defaultMessage: "Clé" },
  LOGIN_BTN_CONNEXION: {
    id: "app.login_btn_connexion",
    defaultMessage: "Se connecter",
  },
  LOGIN_ALREADY_TEXT: {
    id: "app.login_already_text",
    defaultMessage:
      'Si vous avez déjà passé le test scope et que vous appuyer sur "se connecter" vous serez redirigé vers la page de vos résultats.',
  },

  //les titres
  TITRE: { id: "app.titre", defaultMessage: "Scope" },
  TITREBIS: { id: "app.titrebis", defaultMessage: "Bienvenue sur le test" },
  TITRE1: { id: "app.titre1", defaultMessage: "Informations" },
  TITRE2: { id: "app.titre2", defaultMessage: "Instructions" },

  //les modals
  MODAL_LOGOUT_TITLE: {
    id: "app.modal_logout_title",
    defaultMessage: "Se déconnecter ?",
  },
  MODAL_LOGIN_TITLE: {
    id: "app.modal_login_title",
    defaultMessage: "Connexion",
  },
  MODAL_ERRORMSG_EMAIL: {
    id: "app.modal_errormsg_email",
    defaultMessage: "Cet email est déjà utilisé, merci d’en utiliser un autre.",
  },
  MODAL_ERRORMSG_INVALID: {
    id: "app.modal_errormsg_invalid",
    defaultMessage: "Cet email n’est pas valide",
  },
  MODAL_LOGOUT_PARAGRAPH1: {
    id: "app.modal_logout_paragraph1",
    defaultMessage:
      "Si vous vous déconnectez, toutes vos données seront effacées et vous devrez tout recommencer.",
  },
  MODAL_LOGOUT_PARAGRAPH2: {
    id: "app.modal_logout_paragraph2",
    defaultMessage: "Vous êtes sûr de vouloir vous déconnecter ?",
  },
  MODAL_LOGOUT_BUTTON: {
    id: "app.modal_logout_button",
    defaultMessage: "Déconnexion",
  },

  // SCOPE REPORT GUIDE
  SCOPEREPORT_GUIDE_TITLE_1: {
    id: "app.scopeReport_guide_title_1",
    defaultMessage: "Cher(e) Participant(e), ",
  },
  SCOPEREPORT_GUIDE_PARAGRAPH_1_1: {
    id: "app.scopeReport_guide_paragraph_1_1",
    defaultMessage:
      "Ce rapport contient les résultats de l’exploration de votre potentiel personnel à l’aide de SCOPE, un logiciel sophistiqué d’évaluation basé sur la recherche scientifique. Comme ce rapport fournit des informations très riches, veuillez lire attentivement les explications suivantes avant de passer aux résultats.",
  },
  SCOPEREPORT_GUIDE_PARAGRAPH_1_1_A: {
    id: "app.scopeReport_guide_paragraph_1_1_a",
    defaultMessage:
      "Ce rapport contient les résultats de l’exploration de votre potentiel personnel à l’aide de SCOPE, un logiciel sophistiqué d’évaluation basé sur la recherche scientifique. Comme ce rapport fournit des informations très riches, veuillez lire attentivement les explications suivantes avant de passer aux résultats.",
  },
  SCOPEREPORT_GUIDE_PARAGRAPH_1_1_B: {
    id: "app.scopeReport_guide_paragraph_1_1_b",
    defaultMessage:
      "Ce rapport contient les résultats de l’exploration de votre potentiel personnel à l’aide de SCOPE, un logiciel sophistiqué d’évaluation basé sur la recherche scientifique. Comme ce rapport fournit des informations très riches, veuillez lire attentivement les explications suivantes avant de passer aux résultats.",
  },
  SCOPEREPORT_GUIDE_TITLE_2: {
    id: "app.scopeReport_guide_title_2",
    defaultMessage: "Deux formes d’évaluation ",
  },
  SCOPEREPORT_GUIDE_PARAGRAPH_2_1: {
    id: "app.scopeReport_guide_paragraph_2_1",
    defaultMessage:
      "Il existe deux grandes formes d’évaluation : l’auto-évaluation et la mesure objective des performances. Alors que d’autres progiciels d’évaluation actuellement utilisés reposent exclusivement sur l’auto-exploration, SCOPE utilise les deux formes d’évaluation. ",
  },
  SCOPEREPORT_GUIDE_PARAGRAPH_2_2: {
    id: "app.scopeReport_guide_paragraph_2_2",
    defaultMessage:
      "1) L’auto-évaluation : Dans un instrument d’auto-évaluation, vous fournissez les informations essentielles en indiquant vos besoins et vos objectifs, vos attitudes et opinions, vos tendances comportementales habituelles, etc. Les nouvelles informations que vous tirez de ces résultats sont basées soit sur l’analyse des configurations, soit sur la comparaison avec des groupes de référence.",
  },
  SCOPEREPORT_GUIDE_PARAGRAPH_2_3: {
    id: "app.scopeReport_guide_paragraph_2_3",
    defaultMessage:
      "Configuration : En utilisant des règles complexes basées sur les connaissances accumulées en psychologie scientifique, vos réponses sont combinées et analysées d’une manière à laquelle vous n’aviez peut-être pas pensé auparavant. Il y a de fortes chances que les résultats de ces instruments vous apportent de nouvelles connaissances sur vous-même.",
  },
  SCOPEREPORT_GUIDE_PARAGRAPH_2_4: {
    id: "app.scopeReport_guide_paragraph_2_4",
    defaultMessage:
      "Comparaison : Dans le cas de SCOPE, il existe un large choix de groupes de comparaison différents servant de normes de référence réalistes. Dans ce rapport, vos réponses seront comparées à l’un des groupes de comparaison suivants : ",
  },
  SCOPEREPORT_GUIDE_PARAGRAPH_2_5: {
    id: "app.scopeReport_guide_paragraph_2_5",
    defaultMessage:
      "Hommes Cadres supérieurs - Hommes Cadres moyens - Hommes Commerciaux/Administratifs/techniques",
  },
  SCOPEREPORT_GUIDE_PARAGRAPH_2_6: {
    id: "app.scopeReport_guide_paragraph_2_6",
    defaultMessage:
      "Femmes Cadres supérieurs - Femmes Cadres moyens - Femmes Personnel commercial/administratif/technique ",
  },
  SCOPEREPORT_GUIDE_PARAGRAPH_2_7: {
    id: "app.scopeReport_guide_paragraph_2_7",
    defaultMessage:
      '2) L’évaluation objective des performances : Les tests de ce type permettent d’établir votre véritable compétence, indépendamment de l’idée que vous vous faites de vous-même, par exemple en matière de "Style cognitif".',
  },
  SCOPEREPORT_GUIDE_TITLE_3: {
    id: "app.scopeReport_guide_title_3",
    defaultMessage: "Comment interpréter vos résultats ?",
  },
  SCOPEREPORT_GUIDE_PARAGRAPH_3_1: {
    id: "app.scopeReport_guide_paragraph_3_1",
    defaultMessage:
      "Les résultats sont exprimés en scores relatifs, indiquant votre position par rapport à tous les individus du groupe de comparaison, comme le montre la figure ci-dessous.",
  },
  SCOPEREPORT_GUIDE_PARAGRAPH_3_2: {
    id: "app.scopeReport_guide_paragraph_3_2",
    defaultMessage:
      "Les graphiques de ce rapport montrent, pour chacun des traits et compétences mesurés par SCOPE, une barre divisée en trois sections marquées par trois intensités de couleur qui représentent l’étendue de chaque tiers de la distribution des scores du groupe de comparaison sur l’échelle respective. Le cercle vert (ou la zone) représente vos propres scores relatifs sur ces différents traits et compétences. ",
  },
  SCOPEREPORT_GUIDE_PARAGRAPH_3_3: {
    id: "app.scopeReport_guide_paragraph_3_3",
    defaultMessage:
      'Vous trouverez ci-après un graphique montrant vos traits de personnalité et votre Style cognitif sur la base de tests objectifs, un autre pour les stratégies d’adaptation, un troisième pour les dispositions émotionnelles et deux autres pour les facteurs de motivation sous forme de préférences de valeurs. Après le deuxième et le cinquième graphique, vous trouverez un tableau qui explique plus en détail les étiquettes des traits ou compétences des graphiques précédents. Pour ce qui est de l’interprétation de votre position dans une distribution, veuillez noter que le haut n’est pas "meilleur" que le bas - la signification du score varie selon les différentes dimensions. En outre, il n’y a jamais de "bon" ou de "mauvais" score. Ce qui compte, c’est votre profil ou la configuration des traits, ainsi que l’idéal que vous recherchez.',
  },
  SCOPEREPORT_GUIDE_PARAGRAPH_3_4: {
    id: "app.scopeReport_guide_paragraph_3_4",
    defaultMessage:
      'Un dernier mot sur les "types". De nombreuses personnes s’attendent à être décrites comme un "type" spécifique de personne sur la base d’un test psychologique, un peu comme les signes du zodiaque utilisés pour les horoscopes. SCOPE est basé sur un siècle de recherche scientifique sur l’évaluation individuelle, qui n’a pas démontré l’existence de "types" spécifiques et rigidement caractérisés de personnes, mais plutôt la variation continue sur une multitude de dimensions. Il est peu probable que le fait de classer les gens dans des "types" rende justice à l’unicité de chaque individu. Par conséquent, le rapport ci-dessous présente votre profil unique des traits et des compétences mesurés, permettant une évaluation personnalisée de votre potentiel et de votre SCOPE de développement.',
  },
  SCOPEREPORT_GUIDE_PARAGRAPH_3_5: {
    id: "app.scopeReport_guide_paragraph_3_5",
    defaultMessage:
      "Nous nous excusons pour ces longues instructions, mais nous pensons qu’elles sont nécessaires pour vous permettre de tirer un maximum d’informations des résultats que vous trouverez dans ce rapport. Nous vous remercions de votre attention.",
  },

  //SCOPE REPORT
  SCOPEREPORT_DEAR: {
    id: "app.scopeReport_dear",
    defaultMessage: "Cher(ère) Candidat(e),",
  },
  SCOPEREPORT_RESULTSINFO: {
    id: "app.scopeReport_resultsinfo",
    defaultMessage:
      "Les cinq écrans suivants présentent vos résultats sous forme de diagrammes. Pour des raisons de place, seuls les termes psychologiques correspondants peuvent y figurer. Si vous cliquez sur le point d’interrogation dans le coin supérieur droit , vous trouverez les informations détaillées nécessaires.",
  },
  SCOPEREPORT_SEE_RESULTS: {
    id: "app.scopeReport_see_results",
    defaultMessage: "Scrollez vers le bas pour voir vos résultats",
  },
  SCOPEREPORT_PRESENTATION: {
    id: "app.scopeReport_presentation",
    defaultMessage:
      "Ce rapport contient les résultats de l’exploration de votre potentiel personnel effectué avec SIGMA│SCOPE. Ce système est un instrument d’évaluation bref et sophistiqué basé sur la recherche scientifique. Le rapport fournit des informations très riches ; par conséquent, lisez les explications suivantes attentivement avant de lire vos propres résultats.",
  },
  SCOPEREPORT_TWOFORMS_TITLE: {
    id: "app.scopeReport_twoforms_title",
    defaultMessage: "Deux méthodes d’évaluation",
  },
  SCOPEREPORT_TWOFORMS_1: {
    id: "app.scopeReport_twoforms_1",
    defaultMessage:
      "Il existe deux méthodes principales d’évaluation : l’auto-évaluation et l’évaluation objective de la performance. La majorité des instruments d’évaluation personnelle utilisés se basent exclusivement sur l’auto-évaluation, alors que SIGMA│SCOPE utilise les deux méthodes d’évaluation.",
  },
  SCOPEREPORT_TWOFORMS_2: {
    id: "app.scopeReport_twoforms_2",
    defaultMessage:
      "1) Auto-évaluation : pour l’auto-évaluation, vous donnez vous-même les informations essentielles en répondant aux questions concernant notamment vos besoins, vos désirs, et vos tendances comportementales habituelles. De nouvelles informations émaneront d’une part de l’analyse de configurations et d’autre part de la comparaison de vos données avec celles d’un groupe de référence.",
  },
  SCOPEREPORT_TWOFORMS_3: {
    id: "app.scopeReport_twoforms_3",
    defaultMessage:
      "Configuration : en utilisant des règles complexes basées sur les découvertes scientifiques en psychologie, vos réponses sont combinées et analysées d’une manière à laquelle vous n’aviez peut-être jamais pensé auparavant. Il est probable que les résultats de ces instruments présentent une nouvelle image de vous-même. Si vous trouvez que votre profil esquissé par SIGMA│SCOPE est correct, cela signifie que l’image que vous avez de vous-même est exacte. Si vous êtes surpris par les résultats, il serait nécessaire d’examiner attentivement les points de divergence et, après une réflexion poussée, vous pourriez réviser dans une certaine mesure l’image que vous avez de vous-même. Si les résultats sont très divergents, il se peut que, pour une raison ou une autre, vos réponses aux questions de SIGMA│SCOPE n’aient pas reflété vos dispositions comportementales telles qu’elles l’auraient dû. Évidemment, la précision des résultats de l’auto-évaluation dépend de la précision des réponses que vous avez fournies. Bien entendu, il est inutile de ne serait-ce que regarder vos résultats si vous n’avez pas été attentif et totalement honnête dans vos réponses à SIGMA│SCOPE.",
  },
  SCOPEREPORT_TWOFORMS_4: {
    id: "app.scopeReport_twoforms_4",
    defaultMessage:
      "Comparaison : SIGMA│SCOPE dispose d’un vaste éventail de groupes de comparaison servant de standards de référence réalistes. Dans ce rapport, vos réponses seront comparées au groupe de référence suivant :",
  },
  SCOPEREPORT_TWOFORMS_UPPER_MANA_MALE: {
    id: "app.scopeReport_twoforms_upper_mana_male",
    defaultMessage: "Cadres supérieurs - Hommes",
  },
  SCOPEREPORT_TWOFORMS_MIDDLE_MANA_MALE: {
    id: "app.scopeReport_twoforms_middle_mana_male",
    defaultMessage: "Cadres moyens - Hommes",
  },
  SCOPEREPORT_TWOFORMS_SALES_MALE: {
    id: "app.scopeReport_twoforms_sales_male",
    defaultMessage: "Personnel vente/admin/techn - Hommes",
  },
  SCOPEREPORT_TWOFORMS_UPPER_MANA_FEMALE: {
    id: "app.scopeReport_twoforms_upper_mana_female",
    defaultMessage: "Cadres supérieurs - Femmes",
  },
  SCOPEREPORT_TWOFORMS_MIDDLE_MANA_FEMALE: {
    id: "app.scopeReport_twoforms_middle_mana_female",
    defaultMessage: "Cadres moyens - Femmes",
  },
  SCOPEREPORT_TWOFORMS_SALES_FEMALE: {
    id: "app.scopeReport_twoforms_sales_female",
    defaultMessage: "Personnel vente/admin/techn - Femmes",
  },
  SCOPEREPORT_TWOFORMS_5: {
    id: "app.scopeReport_twoforms_5",
    defaultMessage:
      "2) Evaluation objective de la performance : les tests de ce type établissent votre compétence réelle indépendamment de l’image que vous avez de vous-même ; c’est par exemple le cas pour la « Style cognitif ». Bien que l’évaluation soit dite « objective », cela ne signifie pas qu’il existe des standards absolus pour l’évaluation ou l’interprétation des résultats. Il n’existe pas de « bons » ou de « mauvais » résultats. La recherche en psychologie a démontré que les talents humains et les personnalités ont des facettes multiples : chaque individu a des points forts et des points faibles, il n’y a pas de « super-hommes » ou de « super-femmes ». Les valeurs du groupe de comparaison aideront à situer votre performance pour un domaine particulier par rapport à un niveau de performance « typique ».",
  },
  SCOPEREPORT_RESULTSINTERPRET_TITLE: {
    id: "app.scopeReport_resultsInterpret_title",
    defaultMessage: "Comment interpréter vos résultats ?",
  },
  SCOPEREPORT_RESULTSINTERPRET_1: {
    id: "app.scopeReport_resultsInterpret_1",
    defaultMessage:
      "Vos résultats sont exprimés en scores relatifs qui indiquent votre position par rapport à tous les individus du groupe de comparaison, comme cela est présenté dans le graphique suivant.",
  },
  SCOPEREPORT_RESULTSINTERPRET_2: {
    id: "app.scopeReport_resultsInterpret_2",
    defaultMessage:
      "Les graphiques de ce rapport contiennent pour chaque trait ou compétence mesuré par SIGMA│SCOPE, une barre divisée en trois sections par différentes intensités d’une couleur. Ces dernières représentent les tiers de la distribution des valeurs du groupe de comparaison sur l’échelle respective. Les triangles rouges correspondent à vos propres scores sur ces différents traits et compétences. Par conséquent, lorsque votre score, pour une caractéristique particulière, se situe dans la section au milieu d’une barre, cela signifie que votre score est comparable à celui des individus du groupe de comparaison qui n’ont ni un score très élevé ni un score très bas pour la caractéristique correspondante. Si votre score se trouve dans la section à gauche, votre score est similaire à celui des individus appartenant au tiers inférieur du groupe de comparaison et si votre score se trouve dans la section à droite, votre score est plutôt similaire a celui des individus appartenant au tiers supérieur.",
  },
  SCOPEREPORT_RESULTSINTERPRET_3: {
    id: "app.scopeReport_resultsInterpret_3",
    defaultMessage:
      "L’information qui vous est donnée concernant les positions de vos scores en termes de répartition en tiers des valeurs du groupe de comparaison est fiable et significative. En revanche, la position du triangle rouge à l’intérieur d’une section est partiellement déterminée par des fluctuations dues au hasard, et on ne peut donc pas leur conférer une signification. C’est pourquoi nous vous prions de ne pas interpréter la position du triangle dans une section particulière.",
  },
  SCOPEREPORT_RESULTSINTERPRET_4: {
    id: "app.scopeReport_resultsInterpret_4",
    defaultMessage:
      "Vous allez trouver dans les pages suivantes un graphique présentant le profil de vos traits de personnalité (comprenant les compétences basées sur les tests objectifs comme, par exemple, la capacité à raisonner), un autre présentant vos capacités à gérer des situations stressantes, un troisième présentant vos dispositions émotionnelles et encore deux présentant votre motivation en forme de préférences de valeurs. A la suite du deuxième et cinquième graphique se trouve un tableau qui détaille les termes relatifs aux traits ou compétences dans les graphiques précédentes. Pour interpréter votre position dans la distribution, veuillez noter que supérieur n’est pas « mieux » qu’inférieur ; en effet, la signification du score varie selon les dimensions. De plus, comme expliqué ci-dessus, il n’y a jamais de « bon » ou de « mauvais » score ; ce qui est important c’est votre profil ou la configuration de vos traits, ainsi que l’idéal auquel vous aspirez. ",
  },
  SCOPEREPORT_RESULTSINTERPRET_5: {
    id: "app.scopeReport_resultsInterpret_5",
    defaultMessage:
      "En ce qui concerne les soi-disant « types » : beaucoup de gens s’attendent à être décrits sous la forme d’un « type » spécifique de personne, par exemple comme les signes du zodiaque utilisés pour établir l’horoscope. SIGMA│SCOPE est basé sur un siècle de recherche scientifique portant sur l’évaluation individuelle. Celle-ci n’a montré aucune preuve de l’existence de « types » spécifiques de personnes, mais a plutôt démontré l’existence d’une variation continue sur une multitude de dimensions. Caractériser les gens par des « types » ne rend pas justice à l’unicité de chaque individu. Par conséquent, le rapport ci-dessous montre votre profil unique de traits et compétences mesurées, permettant ainsi une évaluation personnalisée de votre potentiel et de votre marge de développement.",
  },
  SCOPEREPORT_RESULTSINTERPRET_6: {
    id: "app.scopeReport_resultsInterpret_6",
    defaultMessage:
      "Nous vous prions de nous excuser pour la longueur de ces instructions, mais nous les estimons nécessaires afin de vous permettre d’obtenir le plus grand bénéfice des données que vous retrouverez dans ce rapport. Nous vous remercions de votre attention.",
  },
  SCOPEREPORT_PERSONALITY: {
    id: "app.scopeReport_personality",
    defaultMessage: "Personnalité ",
  },
  SCOPEREPORT_PERSONALITY_DESC: {
    id: "app.scope_report_personality_desc",
    defaultMessage:
      'La "personnalité" désigne une disposition à agir de manière cohérente et prévisible dans une grande variété de situations. Par exemple, une personne "extravertie" est susceptible d’être généralement sociable et de se sentir très à l’aise dans les interactions sociales.',
  },
  SCOPEREPORT_COPING: {
    id: "app.scopeReport_coping",
    defaultMessage: "Strategies d’adaptation (Coping)",
  },
  SCOPEREPORT_COPING_DESC: {
    id: "app.scopeReport_coping_desc",
    defaultMessage:
      'Le terme "coping" est utilisé pour désigner la capacité d’une personne à faire face de manière appropriée à des événements qui ont des conséquences importantes pour la réalisation de ses objectifs et son bien-être général. Il existe de nombreuses stratégies de coping ("styles de coping") qui peuvent être plus ou moins fonctionnelles selon les situations.',
  },
  SCOPEREPORT_PERSONALITY_COPING: {
    id: "app.scopeReport_personality_coping",
    defaultMessage: "Personnalité et Coping",
  },
  SCOPEREPORT_PERSONALITY_COPING_DESC: {
    id: "app.scopeReport_personality_coping_desc",
    defaultMessage:
      "Le terme « personnalité » fait référence aux capacités et aux dispositions d’un individu à agir de manière cohérente et prévisible dans une grande variété de situations. La personnalité, constituée de traits, attitudes ou opinions et de capacités intellectuelles (par exemple la pensée logique) est considérée comme un puissant déterminant du comportement humain. Le processus par lequel nous faisons face aux événements stressants est nommé « coping ». Les individus diffèrent quant aux stratégies de « coping » qu’ils utilisent. SIGMA│SCOPE mesure 19 traits de personnalité, compétences et stratégies de « coping », fréquemment évalués dans le domaine des ressources humaines, peuvent être considérés comme des indicateurs du potentiel de développement. Ces derniers sont décrits dans le tableau ci-dessous. Gardez à l’esprit que des exemples extrêmes sont choisis pour illustrer chaque trait : les personnes qui correspondent complètement à ces descriptions sont extrêmement rares dans la vie de tous les jours.",
  },
  SCOPEREPORT_EXTRAVERSION: {
    id: "app.scopeReport_extraversion",
    defaultMessage: "Extraversion",
  },
  SCOPEREPORT_EXTRAVERSION_DESC: {
    id: "app.scopeReport_extraversion_desc",
    defaultMessage:
      "une personne extravertie a tendance à rechercher la compagnie d’autres personnes ; elle est sociable, ouverte et communicative.",
  },
  SCOPEREPORT_EXCITEMENTSEEK: {
    id: "app.scopeReport_excitementSeek",
    defaultMessage: "Besoin de sensations fortes",
  },
  SCOPEREPORT_EXCITEMENTSEEK_DESC: {
    id: "app.scopeReport_excitementSeek_desc",
    defaultMessage:
      "Une personne avec un besoin de sensations fortes aime les activités qui exigent de prendre des risques ; elle est aventurière et recherche les sensations de frissons.",
  },
  SCOPEREPORT_IMPULSIVITY: {
    id: "app.scopeReport_impulsivity",
    defaultMessage: "Impulsivité",
  },
  SCOPEREPORT_IMPULSIVITY_DESC: {
    id: "app.scopeReport_impulsivity_desc",
    defaultMessage:
      "Une personne impulsive réfléchit rarement sur ses plans et ses décisions, agit la plupart du temps selon ses désirs et ses idées spontanés et peut parfois paraître émotive, désinhibée et imprévisible.",
  },
  SCOPEREPORT_PESSIMISM: {
    id: "app.scopeReport_pessimism",
    defaultMessage: "Pessimisme",
  },
  SCOPEREPORT_PESSIMISM_DESC: {
    id: "app.scopeReport_pessimism_desc",
    defaultMessage:
      "Une personne pessimiste à tendance à adopter une vision résignée de la vie. Elle est malheureuse, triste, abattue et dénuée d’espoir.",
  },
  SCOPEREPORT_SELFASSURANCE: {
    id: "app.scopeReport_selfAssurance",
    defaultMessage: "Confiance en soi",
  },
  SCOPEREPORT_SELFASSURANCE_DESC: {
    id: "app.scopeReport_selfAssurance_desc",
    defaultMessage:
      "Une personne avec une forte confiance en soi est consciente de ses capacités personnelles, parfois même au point d’être égocentrique et arrogante.",
  },
  SCOPEREPORT_DOMINANCE: {
    id: "app.scopeReport_dominance",
    defaultMessage: "Esprit dominant",
  },
  SCOPEREPORT_DOMINANCE_DESC: {
    id: "app.scopeReport_dominance_desc",
    defaultMessage:
      "Une personne dominante cherche à contrôler les autres et aime assumer des rôles de leader ; elle est autoritaire et directive.",
  },
  SCOPEREPORT_AGGRESSIVENESS: {
    id: "app.scopeReport_aggressiveness",
    defaultMessage: "Agressivité",
  },
  SCOPEREPORT_AGGRESSIVENESS_DESC: {
    id: "app.scopeReport_aggressiveness_desc",
    defaultMessage:
      "Une personne agressive a tendance à agir envers les autres d’une manière osée, directe, voire sèche ; elle peut être critique, hostile ou querelleuse.",
  },
  SCOPEREPORT_CONSCIENTIOUSNESS: {
    id: "app.scopeReport_conscientiousness",
    defaultMessage: "Caractère consciencieux",
  },
  SCOPEREPORT_CONSCIENTIOUSNESS_DESC: {
    id: "app.scopeReport_conscientiousness_desc",
    defaultMessage:
      "Une personne consciencieuse à tendance à prendre ses responsabilités très au sérieux et à valoriser la performance. Elle est méticuleuse, soigneuse et ordonnée.",
  },
  SCOPEREPORT_COMMONSENSE: {
    id: "app.scopeReport_commonSense",
    defaultMessage: "Pragmatisme",
  },
  SCOPEREPORT_COMMONSENSE_DESC: {
    id: "app.scopeReport_commonSense_desc",
    defaultMessage:
      "Une personne pragmatique a tendance à évaluer les événements avec du bon sens, et manifeste des opinions généralement considérées comme raisonnables et appropriées.",
  },
  SCOPEREPORT_CAPACITIYREASONING: {
    id: "app.scopeReport_capacitiyReasoning",
    defaultMessage: "Capacités de raisonnement",
  },
  SCOPEREPORT_CAPACITIYREASONING_DESC: {
    id: "app.scopeReport_capacitiyReasoning_desc",
    defaultMessage:
      "Capacité à résoudre rapidement et correctement des tâches impliquant des raisonnements logiques, ainsi qu’une facilité à déduire des conclusions à partir de présupposés et à résoudre des problèmes abstraits indépendamment de ses connaissances et expériences antérieures.",
  },
  SCOPEREPORT_SELF_CONCEPT_MODIFICATION: {
    id: "app.scopeReport_self_concept_modification",
    defaultMessage: "Ajustement de soi",
  },
  SCOPEREPORT_SELF_CONCEPT_MODIFICATION_DESC: {
    id: "app.scopeReport_self_concept_modification_desc",
    defaultMessage:
      "Évaluation réaliste de ses propres capacités et besoins, ajustement aux situations de stress ou de crise en changeant ses propres buts, si nécessaire.",
  },
  SCOPEREPORT_PROBLEMSOLVING: {
    id: "app.scopeReport_problemSolving",
    defaultMessage: "Résolution de problèmes",
  },
  SCOPEREPORT_PROBLEMSOLVING_DESC: {
    id: "app.scopeReport_problemSolving_desc",
    defaultMessage:
      "S’engager dans une pensée et une action constructives pour faire face aux problèmes et à leurs conséquences, identifier des alternatives et trouver des solutions.",
  },
  SCOPEREPORT_EMOTIONREPRESSION: {
    id: "app.scopeReport_emotionRepression",
    defaultMessage: "Suppression de l’émotion",
  },
  SCOPEREPORT_EMOTIONREPRESSION_DESC: {
    id: "app.scopeReport_emotionRepression_desc",
    defaultMessage:
      "Tenter d’inhiber ou de bloquer les sentiments négatifs associés aux situations de crise.",
  },
  SCOPEREPORT_SEEKINGEMPATHY: {
    id: "app.scopeReport_seekingEmpathy",
    defaultMessage: "Recherche d’empathie",
  },
  SCOPEREPORT_SEEKINGEMPATHY_DESC: {
    id: "app.scopeReport_seekingEmpathy_desc",
    defaultMessage:
      "Trouver du soulagement dans le partage des sentiments négatifs avec autrui.",
  },
  SCOPEREPORT_RUMINATION: {
    id: "app.scopeReport_rumination",
    defaultMessage: "Rumination",
  },
  SCOPEREPORT_RUMINATION_DESC: {
    id: "app.scopeReport_rumination_desc",
    defaultMessage:
      "Penser constamment au même problème, à ses causes et conséquences (sans pour autant chercher à le résoudre), souvent au point de négliger tout ce qui ne concerne pas ce problème.",
  },
  SCOPEREPORT_INTERNALATTRIBUTION: {
    id: "app.scopeReport_internalAttribution",
    defaultMessage: "Appropriation",
  },
  SCOPEREPORT_INTERNALATTRIBUTION_DESC: {
    id: "app.scopeReport_internalAttribution_desc",
    defaultMessage:
      "Identifier le degré de responsabilité que l’on porte dans l’origine d’un problème ou d’une crise.",
  },
  SCOPEREPORT_SEEKINGSOCIALSUPPORT: {
    id: "app.scopeReport_seekingSocialSupport",
    defaultMessage: "Recherche de support social",
  },
  SCOPEREPORT_SEEKINGSOCIALSUPPORT_DESC: {
    id: "app.scopeReport_seekingSocialSupport_desc",
    defaultMessage:
      "Trouver une aide constructive de la part de la famille, des amis ou des professionnels pour résoudre le problème ou en atténuer les conséquences.",
  },
  SCOPEREPORT_WISHFULTHINKING: {
    id: "app.scopeReport_wishfulThinking",
    defaultMessage: "Pensée magique",
  },
  SCOPEREPORT_WISHFULTHINKING_DESC: {
    id: "app.scopeReport_wishfulThinking_desc",
    defaultMessage:
      "Espérer que le problème se résoudra d’une manière ou d’une autre de lui-même, sans sa propre intervention.",
  },
  SCOPEREPORT_SELFCONCEPTBOLSTERING: {
    id: "app.scopeReport_selfConceptBolstering",
    defaultMessage: "Renforcement de l’estime de soi",
  },
  SCOPEREPORT_SELFCONCEPTBOLSTERING_DESC: {
    id: "app.scopeReport_selfConceptBolstering_desc",
    defaultMessage:
      "Adopter diverses stratégies cognitives pour renforcer ou construire l’estime de soi et pour se protéger des conséquences du problème.",
  },

  SCOPEREPORT_EMOTIONALITY: {
    id: "app.scopeReport_emotionality",
    defaultMessage: "Emotionnalité",
  },
  SCOPEREPORT_EMOTIONALITY_DESC: {
    id: "app.scopeReport_emotionality_desc",
    defaultMessage:
      'Bien que les réactions émotionnelles soient généralement déclenchées par des situations spécifiques, il existe des différences individuelles dans le type de réaction. Celles-ci sont des signes du "style" interpersonnel d’une personne, comme le calme, la mauvaise humeur ou l’hostilité, qui peuvent avoir un impact important sur ses partenaires d’interaction et sur les résultats de travail respectifs.',
  },


  SCOPEREPORT_ACTIONORIENTATION: {
    id: "app.scopeReport_actionOrientation",
    defaultMessage: "Tendance à l’action",
  },
  SCOPEREPORT_ACTIONORIENTATION_DESC: {
    id: "app.scopeReport_actionOrientation_desc",
    defaultMessage:
      'Bien que le passage à l’action soit souvent conditionné par le contexte ou les contraintes externes, il existe des différences individuelles dans la propension à initier des comportements concrets. Celles-ci reflètent le « style » comportemental d’une personne, comme la rapidité à se mobiliser, la tendance à l’initiative ou l’inertie, et peuvent influencer de manière significative l’efficacité personnelle ainsi que la dynamique au sein d’une équipe.',
  },
  
  SCOPEREPORT_VALUEPREFERENCES: {
    id: "app.scopeReport_valuePreferences",
    defaultMessage: "Valeurs préférées au travail",
  },
  SCOPEREPORT_VALUEPREFERENCES_DESC: {
    id: "app.scopeReport_valuePreferences_desc",
    defaultMessage:
      "Les informations sur la hiérarchie des préférences concernant les aspects d’un poste de travail peuvent aider à placer la bonne personne au bon poste, à choisir correctement les objectifs de carrière et à planifier le développement personnel de manière réaliste et efficace. De graves problèmes peuvent survenir si les caractéristiques d’un poste ne correspondent pas aux propres valeurs ou préférences de la personne concernée.",
  },

  SCOPEREPORT_VALUEPREFERENCES2: {
    id: "app.scopeReport_valuePreferences2",
    defaultMessage: "Hiérarchie de valeurs",
  },
  SCOPEREPORT_VALUEPREFERENCES2_DESC: {
    id: "app.scopeReport_valuePreferences2_desc",
    defaultMessage:
      "Chacun de nous accorde plus ou moins d’importance à certaines valeurs. Cette hiérarchie personnelle influence nos choix, nos réactions et parfois nos désaccords — surtout lorsqu’il y a un conflit de valeurs ou un dilemme moral. Dans une équipe, des différences de priorités liées aux parcours ou à la culture peuvent parfois créer des malentendus. Prendre conscience de ses propres valeurs, et comprendre celles des autres, permet de mieux collaborer, de gérer les tensions, et de renforcer la confiance.",
  },

  SCOPEREPORT_EMOTIONALITY_VALUESPREF: {
    id: "app.scopeReport_emotionality_valuesPref",
    defaultMessage: "Emotionnalité et valeurs",
  },
  SCOPEREPORT_EMOTIONALITY_VALUESPREF_DESC: {
    id: "app.scopeReport_emotionality_valuesPref_desc",
    defaultMessage:
      "Les individus diffèrent selon le type d’émotion qu’ils ressentiront dans une situation donnée, selon les réactions qu’ils vont exprimer et selon leur capacité à contrôler leurs sentiments et expressions. Ces différences de sensibilité ou de dispositions émotionnelles affectent une grande partie de nos comportements, en particulier lors de nos contacts avec les autres. En même temps, les valeurs personnelles et les préférences sont à la base de la motivation pour le travail et de beaucoup de décisions importantes dans la vie. C’est pourquoi il est important d’avoir une idée des priorités que nous accordons à des valeurs particulières. SIGMA│SCOPE mesure 8 dispositions émotionnelles et 12 valeurs, qui sont décrites ci-dessous.",
  },

  SCOPE_REPORT_EXPRESSIVENESS: {
    id: "app.scope_report_expressiveness",
    defaultMessage: "Expressivité",
  },
  SCOPE_REPORT_EXPRESSIVENESS_DESC: {
    id: "app.scope_report_expressiveness_desc",
    defaultMessage:
      "Tendance à exprimer ses sentiments et attitudes de façon prononcée, grande capacité de communiquer ses émotions.",
  },
  SCOPE_REPORT_AFFECTIVEREGULATION: {
    id: "app.scope_report_affectiveRegulation",
    defaultMessage: "Régulation affective",
  },
  SCOPE_REPORT_AFFECTIVEREGULATION_DESC: {
    id: "app.scope_report_affectiveRegulation_desc",
    defaultMessage:
      "Capacité à réguler et contrôler l’intensité de ses émotions de façon optimale, en évitant d’être « submergé » par ses émotions.",
  },
  SCOPE_REPORT_EMOTIONALRESILIENCE: {
    id: "app.scope_report_emotionalResilience",
    defaultMessage: "Résilience",
  },
  SCOPE_REPORT_EMOTIONALRESILIENCE_DESC: {
    id: "app.scope_report_emotionalResilience_desc",
    defaultMessage:
      "Capacité à résister aux expériences stressantes à garder sa bonne humeur, en particulier dans des contextes sociaux.",
  },
  SCOPE_REPORT_NEGATIVEAFFECT: {
    id: "app.scope_report_negativeAffect",
    defaultMessage: "Negativité",
  },
  SCOPE_REPORT_NEGATIVEAFFECT_DESC: {
    id: "app.scope_report_negativeAffect_desc",
    defaultMessage:
      "Se sentir généralement malheureux, résigné, voire même triste, particulièrement lorsque les choses ne vont pas bien.",
  },
  SCOPE_REPORT_IRRITABILITY: {
    id: "app.scope_report_irritability",
    defaultMessage: "Irritabilité",
  },
  SCOPE_REPORT_IRRITABILITY_DESC: {
    id: "app.scope_report_irritability_desc",
    defaultMessage:
      "Tendance à réagir avec irritation ou même avec colère dans des situations de frustration.",
  },
  SCOPE_REPORT_SERENITY: {
    id: "app.scope_report_serenity",
    defaultMessage: "Sérénité",
  },
  SCOPE_REPORT_SERENITY_DESC: {
    id: "app.scope_report_serenity_desc",
    defaultMessage:
      "Propension à rester calme et décontracté, même face à l’adversité.",
  },
  SCOPE_REPORT_ANXIETY: {
    id: "app.scope_report_anxiety",
    defaultMessage: "Anxiété",
  },
  SCOPE_REPORT_ANXIETY_DESC: {
    id: "app.scope_report_anxiety_desc",
    defaultMessage:
      "Propension à s’inquiéter de futurs problèmes potentiels, même s’il est peu probable qu’ils surviennent.",
  },
  SCOPE_REPORT_SELFCONSCIOUSNESS: {
    id: "app.scope_report_selfConsciousness",
    defaultMessage: "Doute de soi",
  },
  SCOPE_REPORT_SELFCONSCIOUSNESS_DESC: {
    id: "app.scope_report_selfConsciousness_desc",
    defaultMessage:
      "Se sentir facilement gêné/e ou même honteux/se quand quelque chose tourne mal, présumant automatiquement que l’on est pris en faute.",
  },

  SCOPE_REPORT_ENJOY_WORK_PLEASURE: {
    id: "app.scope_report_enjoyWork",
    defaultMessage: "Aimer son travail/Avoir du plaisir au travail",
  },
  SCOPE_REPORT_EXERCISE_LEADERSHIP: {
    id: "app.scope_report_leadership",
    defaultMessage: "Exercer du leadership",
  },
  SCOPE_REPORT_SECURITY: {
    id: "app.scope_report_security",
    defaultMessage: "Sécurité de l’emploi/Engagement de longue durée.",
  },
  SCOPE_REPORT_SECURITY_DESC: {
    id: "app.scope_report_security_desc",
    defaultMessage:
      "Sentiments de sécurité basés sur la stabilité de son emploi et anticipation de bénéfices à long terme",
  },
  SCOPE_REPORT_INTELLECTUALSTIMULATION: {
    id: "app.scope_report_intellectualStimulation",
    defaultMessage: "Stimulation intellectuelle/Potentiel de créativité",
  },
  SCOPE_REPORT_INTELLECTUALSTIMULATION_DESC: {
    id: "app.scope_report_intellectualStimulation_desc",
    defaultMessage:
      "Se sentir stimulé par des défis intellectuels et créatifs.",
  },
  SCOPE_REPORT_SALARY_PROMOTION: {
    id: "app.scope_report_salary",
    defaultMessage: "Salaire élevé/Promotion rapide",
  },
  SCOPE_REPORT_TASK_VARIABILITY_FLEXIBILITY: {
    id: "app.scope_report_taskvariability",
    defaultMessage: "Tâches très variées/Grande flexibilité",
  },
  SCOPE_REPORT_POWER_INFLUENCE: {
    id: "app.scope_report_power",
    defaultMessage: "Pouvoir/Influence",
  },
  SCOPE_REPORT_HONOR: {
    id: "app.scope_report_honor",
    defaultMessage: "Honneur/Intégrité / Honneur",
  },
  SCOPE_REPORT_HONOR_DESC: {
    id: "app.scope_report_honor_desc",
    defaultMessage:
      "Valoriser la réputation et oeuvrer continuellement pour l’honnêteté.",
  },


  SCOPE_REPORT_PERCENTILE_25_TITLE: {
    id: "app.scope_report_percentile_25_title",
    defaultMessage: "25e percentil",
  },
  SCOPE_REPORT_PERCENTILE_100_TITLE: {
    id: "app.scope_report_percentile_100_title",
    defaultMessage: "100e percentil",
  },


  SCOPE_REPORT_EXTRAVERSION_AXIS_HIGH: {
    id: "app.scope_report_extraversion_axis_high",
    defaultMessage: "Extraversion",
  },
  SCOPE_REPORT_EXTRAVERSION_AXIS_LOW: {
    id: "app.scope_report_extraversion_axis_low",
    defaultMessage: "Introversion",
  },
  SCOPE_REPORT_EXTRAVERSION_AXIS_HIGH_DESC: {
    id: "app.scope_report_extraversion_axis_high_desc",
    defaultMessage:
      "Une personne extravertie est spontanément attirée par les échanges et la vie en groupe. Elle est sociable, expressive et tire son énergie des interactions.",
  },
  SCOPE_REPORT_EXTRAVERSION_AXIS_LOW_DESC: {
    id: "app.scope_report_extraversion_axis_low_desc",
    defaultMessage:
      "Une personne introvertie se ressource dans des environnements calmes. Réfléchie et réservée, elle privilégie la profondeur des relations et le temps pour elle-même.",
  },
  SCOPE_REPORT_EXTRAVERSION_PERCENTILE_25_TITLE: {
    id: "app.scope_report_extraversion_percentile_25_title",
    defaultMessage: "25e percentil (faible extraversion → plutôt introverti·e)",
  },
  SCOPE_REPORT_EXTRAVERSION_PERCENTILE_25_STRENGTHS_INTRO: { id: "app.scope_report_extraversion_percentile_25_strengths_intro", defaultMessage: "Ce que la personne apporte :" },
  SCOPE_REPORT_EXTRAVERSION_PERCENTILE_25_STRENGTHS_1: { id: "app.scope_report_extraversion_percentile_25_strengths_1", defaultMessage: "Écoute attentive, calme, capacité à réfléchir en profondeur." },
  SCOPE_REPORT_EXTRAVERSION_PERCENTILE_25_STRENGTHS_2: { id: "app.scope_report_extraversion_percentile_25_strengths_2", defaultMessage: "Préfère les interactions en petit comité, ce qui favorise des échanges posés." },
  SCOPE_REPORT_EXTRAVERSION_PERCENTILE_25_STRENGTHS_3: { id: "app.scope_report_extraversion_percentile_25_strengths_3", defaultMessage: "Peut exceller dans les tâches nécessitant de la concentration, de l’autonomie ou de l’analyse." },


  SCOPE_REPORT_EXTRAVERSION_PERCENTILE_25_DEVELOPMENT_INTRO: { id: "app.scope_report_extraversion_percentile_25_development_intro", defaultMessage: "Points de développement :" },
  SCOPE_REPORT_EXTRAVERSION_PERCENTILE_25_DEVELOPMENT_1: { id: "app.scope_report_extraversion_percentile_25_development_1", defaultMessage: "Gagner en aisance pour s’exprimer davantage en groupe et faire entendre sa voix." },
  SCOPE_REPORT_EXTRAVERSION_PERCENTILE_25_DEVELOPMENT_2: { id: "app.scope_report_extraversion_percentile_25_development_2", defaultMessage: "Rendre sa présence plus visible dans les échanges collectifs pour mieux refléter son implication réelle." },
  SCOPE_REPORT_EXTRAVERSION_PERCENTILE_25_DEVELOPMENT_3: { id: "app.scope_report_extraversion_percentile_25_development_3", defaultMessage: "Développer sa capacité à évoluer plus confortablement dans des contextes sociaux intenses ou bruyants." },


  SCOPE_REPORT_EXTRAVERSION_PERCENTILE_25_OPTIMIZE: {
    id: "app.scope_report_extraversion_percentile_25_optimize",
    defaultMessage:
      "Comment optimiser ma performance : Me laisser du temps calme pour intégrer les informations et préparer mes interventions.",
  },
  SCOPE_REPORT_EXTRAVERSION_PERCENTILE_25_MOTIVATION: {
    id: "app.scope_report_extraversion_percentile_25_motivation",
    defaultMessage:
      "Un environnement serein, respectueux, avec des relations profondes mais choisies.",
  },
  SCOPE_REPORT_EXTRAVERSION_PERCENTILE_25_TEAM_ADVICE: {
    id: "app.scope_report_extraversion_percentile_25_team_advice",
    defaultMessage:
      "Conseil d’équipe : Donnez-moi un espace d’expression calme et structuré, je suis plus à l’aise quand je peux préparer.",
  },
  SCOPE_REPORT_EXTRAVERSION_PERCENTILE_100_TITLE: {
    id: "app.scope_report_extraversion_percentile_100_title",
    defaultMessage: "100e percentil (extraversion très élevée)",
  },
  SCOPE_REPORT_EXTRAVERSION_PERCENTILE_100_STRENGTHS_INTRO: { id: "app.scope_report_extraversion_percentile_100_strengths_intro", defaultMessage: "Ce que la personne apporte :" },
  SCOPE_REPORT_EXTRAVERSION_PERCENTILE_100_STRENGTHS_1: { id: "app.scope_report_extraversion_percentile_100_strengths_1", defaultMessage: "Très forte énergie sociale, moteur pour la dynamique d’équipe." },
  SCOPE_REPORT_EXTRAVERSION_PERCENTILE_100_STRENGTHS_2: { id: "app.scope_report_extraversion_percentile_100_strengths_2", defaultMessage: "Excellent·e pour mobiliser, fédérer, gérer les interactions externes (clients, partenaires…)." },
  SCOPE_REPORT_EXTRAVERSION_PERCENTILE_100_STRENGTHS_3: { id: "app.scope_report_extraversion_percentile_100_strengths_3", defaultMessage: "Peut devenir un ambassadeur ou une figure charismatique du groupe." },


  SCOPE_REPORT_EXTRAVERSION_PERCENTILE_100_DEVELOPMENT_INTRO: { id: "app.scope_report_extraversion_percentile_100_development_intro", defaultMessage: "Points de développement :" },
  SCOPE_REPORT_EXTRAVERSION_PERCENTILE_100_DEVELOPMENT_1: { id: "app.scope_report_extraversion_percentile_100_development_1", defaultMessage: "S’assurer que tout le monde a un espace pour s’exprimer." },
  SCOPE_REPORT_EXTRAVERSION_PERCENTILE_100_DEVELOPMENT_2: { id: "app.scope_report_extraversion_percentile_100_development_2", defaultMessage: "Canaliser son énergie dans des objectifs précis." },
  SCOPE_REPORT_EXTRAVERSION_PERCENTILE_100_DEVELOPMENT_3: { id: "app.scope_report_extraversion_percentile_100_development_3", defaultMessage: "Apprendre à se ressourcer dans des temps de calme ou de retrait." },


  SCOPE_REPORT_EXTRAVERSION_PERCENTILE_100_OPTIMIZE: {
    id: "app.scope_report_extraversion_percentile_100_optimize",
    defaultMessage:
      "Comment optimiser ma performance : Me placer au cœur des interactions, avec une fonction de représentation ou de mobilisation.",
  },
  SCOPE_REPORT_EXTRAVERSION_PERCENTILE_100_MOTIVATION: {
    id: "app.scope_report_extraversion_percentile_100_motivation",
    defaultMessage:
      "La reconnaissance sociale, les contacts humains fréquents et l’influence positive sur le collectif.",
  },
  SCOPE_REPORT_EXTRAVERSION_PERCENTILE_100_TEAM_ADVICE: {
    id: "app.scope_report_extraversion_percentile_100_team_advice",
    defaultMessage:
      "Conseil d’équipe : Appuyez-vous sur mon énergie pour créer du lien, mais rappelez-moi aussi de laisser de la place aux autres.",
  },

  SCOPE_REPORT_EXCITEMENT_SEEKING_AXIS_HIGH: {
    id: "app.scope_report_excitementseek_axis_high",
    defaultMessage: "Besoin de sensations fortes",
  },
  SCOPE_REPORT_EXCITEMENT_SEEKING_AXIS_LOW: {
    id: "app.scope_report_excitementseek_axis_low",
    defaultMessage: "Prudence",
  },
  SCOPE_REPORT_EXCITEMENT_SEEKING_AXIS_HIGH_DESC: {
    id: "app.scope_report_excitementseek_axis_high_desc",
    defaultMessage:
      "Une personne avec un fort besoin de sensations fortes est stimulée par la nouveauté, l’intensité et les défis. Elle aime explorer, sortir des sentiers battus et vivre des expériences marquantes.",
  },
  SCOPE_REPORT_EXCITEMENT_SEEKING_AXIS_LOW_DESC: {
    id: "app.scope_report_excitementseek_axis_low_desc",
    defaultMessage:
      "Une personne prudente trouve son équilibre dans la stabilité et la prévisibilité. Elle cultive la prudence, la profondeur et le goût des plaisirs simples.",
  },
  SCOPE_REPORT_EXCITEMENT_SEEKING_PERCENTILE_25_TITLE: {
    id: "app.scope_report_excitementseek_percentile_25_title",
    defaultMessage: "25e percentil (faible besoin de sensations)",
  },
  SCOPE_REPORT_EXCITEMENT_SEEKING_PERCENTILE_25_STRENGTHS_INTRO: { id: "app.scope_report_excitementseek_percentile_25_strengths_intro", defaultMessage: "Ce que la personne apporte :" },
  SCOPE_REPORT_EXCITEMENT_SEEKING_PERCENTILE_25_STRENGTHS_1: { id: "app.scope_report_excitementseek_percentile_25_strengths_1", defaultMessage: "Approche réfléchie et sécurisante dans la prise de décision." },
  SCOPE_REPORT_EXCITEMENT_SEEKING_PERCENTILE_25_STRENGTHS_2: { id: "app.scope_report_excitementseek_percentile_25_strengths_2", defaultMessage: "Capacité à anticiper les risques et éviter les imprudences." },
  SCOPE_REPORT_EXCITEMENT_SEEKING_PERCENTILE_25_STRENGTHS_3: { id: "app.scope_report_excitementseek_percentile_25_strengths_3", defaultMessage: "Préférence pour la régularité, la fiabilité et les environnements stables." },

  SCOPE_REPORT_EXCITEMENT_SEEKING_PERCENTILE_25_DEVELOPMENT_INTRO: { id: "app.scope_report_excitementseek_percentile_25_development_intro", defaultMessage: "Points de développement :" },
  SCOPE_REPORT_EXCITEMENT_SEEKING_PERCENTILE_25_DEVELOPMENT_1: { id: "app.scope_report_excitementseek_percentile_25_development_1", defaultMessage: "Renforcer sa capacité à accueillir le changement et s’ouvrir à de nouvelles idées." },
  SCOPE_REPORT_EXCITEMENT_SEEKING_PERCENTILE_25_DEVELOPMENT_2: { id: "app.scope_report_excitementseek_percentile_25_development_2", defaultMessage: "Gagner en confort dans les environnements plus incertains ou en mouvement." },
  SCOPE_REPORT_EXCITEMENT_SEEKING_PERCENTILE_25_DEVELOPMENT_3: { id: "app.scope_report_excitementseek_percentile_25_development_3", defaultMessage: "Encourager davantage la créativité et les démarches expérimentales dans son environnement." },

  SCOPE_REPORT_EXCITEMENT_SEEKING_PERCENTILE_25_OPTIMIZE: {
    id: "app.scope_report_excitementseek_percentile_25_optimize",
    defaultMessage:
      "Comment optimiser ma performance : Me proposer des projets cadrés, clairs, avec des marges d’exploration progressives.",
  },
  SCOPE_REPORT_EXCITEMENT_SEEKING_PERCENTILE_25_MOTIVATION: {
    id: "app.scope_report_excitementseek_percentile_25_motivation",
    defaultMessage:
      "La sécurité, la stabilité, la maîtrise de mon environnement.",
  },
  SCOPE_REPORT_EXCITEMENT_SEEKING_PERCENTILE_25_TEAM_ADVICE: {
    id: "app.scope_report_excitementseek_percentile_25_team_advice",
    defaultMessage:
      "Conseil d’équipe : Offrez-moi un cadre rassurant, mais encouragez-moi à tester des choses nouvelles par petites touches.",
  },
  SCOPE_REPORT_EXCITEMENT_SEEKING_PERCENTILE_100_TITLE: {
    id: "app.scope_report_excitementseek_percentile_100_title",
    defaultMessage: "100e percentil (très fort besoin de sensations)",
  },
  SCOPE_REPORT_EXCITEMENT_SEEKING_PERCENTILE_100_STRENGTHS_INTRO: { id: "app.scope_report_excitementseek_percentile_100_strengths_intro", defaultMessage: "Ce que la personne apporte :" },
  SCOPE_REPORT_EXCITEMENT_SEEKING_PERCENTILE_100_STRENGTHS_1: { id: "app.scope_report_excitementseek_percentile_100_strengths_1", defaultMessage: "Forte capacité à gérer l’imprévu, à prendre des risques et à rebondir." },
  SCOPE_REPORT_EXCITEMENT_SEEKING_PERCENTILE_100_STRENGTHS_2: { id: "app.scope_report_excitementseek_percentile_100_strengths_2", defaultMessage: "Énergie d’exploration, moteur de transformation ou d’innovation." },
  SCOPE_REPORT_EXCITEMENT_SEEKING_PERCENTILE_100_STRENGTHS_3: { id: "app.scope_report_excitementseek_percentile_100_strengths_3", defaultMessage: "Aime les défis extrêmes, sort facilement des sentiers battus." },

  SCOPE_REPORT_EXCITEMENT_SEEKING_PERCENTILE_100_DEVELOPMENT_INTRO: { id: "app.scope_report_excitementseek_percentile_100_development_intro", defaultMessage: "Points de développement :" },
  SCOPE_REPORT_EXCITEMENT_SEEKING_PERCENTILE_100_DEVELOPMENT_1: { id: "app.scope_report_excitementseek_percentile_100_development_1", defaultMessage: "Apprendre à évaluer plus finement les conséquences de ses choix." },
  SCOPE_REPORT_EXCITEMENT_SEEKING_PERCENTILE_100_DEVELOPMENT_2: { id: "app.scope_report_excitementseek_percentile_100_development_2", defaultMessage: "Intégrer les contraintes de l’équipe avant d’agir." },
  SCOPE_REPORT_EXCITEMENT_SEEKING_PERCENTILE_100_DEVELOPMENT_3: { id: "app.scope_report_excitementseek_percentile_100_development_3", defaultMessage: "Accepter des temps calmes comme nécessaires à la performance durable." },

  SCOPE_REPORT_EXCITEMENT_SEEKING_PERCENTILE_100_OPTIMIZE: {
    id: "app.scope_report_excitementseek_percentile_100_optimize",
    defaultMessage:
      "Comment optimiser ma performance : Me mettre sur des projets à fort enjeu, à fort rythme ou nécessitant du courage décisionnel.",
  },
  SCOPE_REPORT_EXCITEMENT_SEEKING_PERCENTILE_100_MOTIVATION: {
    id: "app.scope_report_excitementseek_percentile_100_motivation",
    defaultMessage:
      "L’adrénaline, la liberté d’action, le sentiment de vivre intensément ce que je fais.",
  },
  SCOPE_REPORT_EXCITEMENT_SEEKING_PERCENTILE_100_TEAM_ADVICE: {
    id: "app.scope_report_excitementseek_percentile_100_team_advice",
    defaultMessage:
      "Conseil d’équipe : Encadrez mon élan pour qu’il serve le collectif, sans le brider — je peux ouvrir la voie si on me fait confiance.",
  },

  SCOPE_REPORT_IMPULSIVITY_AXIS_HIGH: {
    id: "app.scope_report_impulsivity_axis_high",
    defaultMessage: "Impulsivité",
  },
  SCOPE_REPORT_IMPULSIVITY_AXIS_LOW: {
    id: "app.scope_report_impulsivity_axis_low",
    defaultMessage: "Maîtrise de soi",
  },
  SCOPE_REPORT_IMPULSIVITY_AXIS_HIGH_DESC: {
    id: "app.scope_report_impulsivity_axis_high_desc",
    defaultMessage:
      "Une personne impulsive est spontanée, réactive et pleine de vie. Elle agit avec naturel, suit ses intuitions et peut insuffler de l’élan et de l’audace dans un groupe.",
  },
  SCOPE_REPORT_IMPULSIVITY_AXIS_LOW_DESC: {
    id: "app.scope_report_impulsivity_axis_low_desc",
    defaultMessage:
      "Une personne peu impulsive fait preuve d’un grand sang-froid : elle réfléchit avant d’agir, sait se tempérer, se contenir et apporte de la stabilité et de la rigueur dans ses choix.",
  },
  SCOPE_REPORT_IMPULSIVITY_PERCENTILE_25_TITLE: {
    id: "app.scope_report_impulsivity_percentile_25_title",
    defaultMessage:
      "25e percentil (faible impulsivité → comportement très réfléchi)",
  },
  SCOPE_REPORT_IMPULSIVITY_PERCENTILE_25_STRENGTHS_INTRO: { id: "app.scope_report_impulsivity_percentile_25_strengths_intro", defaultMessage: "Ce que la personne apporte :" },
  SCOPE_REPORT_IMPULSIVITY_PERCENTILE_25_STRENGTHS_1: { id: "app.scope_report_impulsivity_percentile_25_strengths_1", defaultMessage: "Calme, posée, prend le temps d’analyser avant d’agir." },
  SCOPE_REPORT_IMPULSIVITY_PERCENTILE_25_STRENGTHS_2: { id: "app.scope_report_impulsivity_percentile_25_strengths_2", defaultMessage: "Réagit avec maîtrise, garde la tête froide en situation de stress." },
  SCOPE_REPORT_IMPULSIVITY_PERCENTILE_25_STRENGTHS_3: { id: "app.scope_report_impulsivity_percentile_25_strengths_3", defaultMessage: "Bon·ne dans la gestion de conflits, prise de décision structurée." },

  SCOPE_REPORT_IMPULSIVITY_PERCENTILE_25_DEVELOPMENT_INTRO: { id: "app.scope_report_impulsivity_percentile_25_development_intro", defaultMessage: "Points de développement :" },
  SCOPE_REPORT_IMPULSIVITY_PERCENTILE_25_DEVELOPMENT_1: { id: "app.scope_report_impulsivity_percentile_25_development_1", defaultMessage: "Gagner en réactivité pour mieux s’adapter aux environnements rapides ou changeants." },
  SCOPE_REPORT_IMPULSIVITY_PERCENTILE_25_DEVELOPMENT_2: { id: "app.scope_report_impulsivity_percentile_25_development_2", defaultMessage: "Développer sa spontanéité pour saisir davantage les opportunités au fil de l’action." },
  SCOPE_REPORT_IMPULSIVITY_PERCENTILE_25_DEVELOPMENT_3: { id: "app.scope_report_impulsivity_percentile_25_development_3", defaultMessage: "Renforcer sa capacité à prendre des décisions rapides en situation d’urgence ou sous pression." },

  SCOPE_REPORT_IMPULSIVITY_PERCENTILE_25_OPTIMIZE: {
    id: "app.scope_report_impulsivity_percentile_25_optimize",
    defaultMessage:
      "Comment optimiser ma performance : Me laisser le temps de traiter les informations et de peser les décisions.",
  },
  SCOPE_REPORT_IMPULSIVITY_PERCENTILE_25_MOTIVATION: {
    id: "app.scope_report_impulsivity_percentile_25_motivation",
    defaultMessage:
      "La stabilité, les environnements calmes et les contextes structurés.",
  },
  SCOPE_REPORT_IMPULSIVITY_PERCENTILE_25_TEAM_ADVICE: {
    id: "app.scope_report_impulsivity_percentile_25_team_advice",
    defaultMessage:
      "Conseil d’équipe : Ne me pressez pas dans l’urgence : j’apporte de la fiabilité, pas de la précipitation.",
  },
  SCOPE_REPORT_IMPULSIVITY_PERCENTILE_100_TITLE: {
    id: "app.scope_report_impulsivity_percentile_100_title",
    defaultMessage: "100e percentil (impulsivité très forte)",
  },
  SCOPE_REPORT_IMPULSIVITY_PERCENTILE_100_STRENGTHS_INTRO: { id: "app.scope_report_impulsivity_percentile_100_strengths_intro", defaultMessage: "Ce que la personne apporte :" },
  SCOPE_REPORT_IMPULSIVITY_PERCENTILE_100_STRENGTHS_1: { id: "app.scope_report_impulsivity_percentile_100_strengths_1", defaultMessage: 'Capacité à foncer, déclencher des actions immédiates, "allumer l’étincelle".'},
  SCOPE_REPORT_IMPULSIVITY_PERCENTILE_100_STRENGTHS_2: { id: "app.scope_report_impulsivity_percentile_100_strengths_2", defaultMessage: "Peut créer une dynamique vive, casser les blocages, oser là où d’autres hésitent." },
  SCOPE_REPORT_IMPULSIVITY_PERCENTILE_100_STRENGTHS_3: { id: "app.scope_report_impulsivity_percentile_100_strengths_3", defaultMessage: "Apporte de la spontanéité, de l’intensité dans les échanges." },

  SCOPE_REPORT_IMPULSIVITY_PERCENTILE_100_DEVELOPMENT_INTRO: { id: "app.scope_report_impulsivity_percentile_100_development_intro", defaultMessage: "Points de développement :" },
  SCOPE_REPORT_IMPULSIVITY_PERCENTILE_100_DEVELOPMENT_1: { id: "app.scope_report_impulsivity_percentile_100_development_1", defaultMessage: "Mieux canaliser ses émotions pour réagir de manière plus posée et réfléchie." },
  SCOPE_REPORT_IMPULSIVITY_PERCENTILE_100_DEVELOPMENT_2: { id: "app.scope_report_impulsivity_percentile_100_development_2", defaultMessage: "Travailler sur la gestion des désaccords et des situations tendues pour favoriser des échanges plus sereins." },
  SCOPE_REPORT_IMPULSIVITY_PERCENTILE_100_DEVELOPMENT_3: { id: "app.scope_report_impulsivity_percentile_100_development_3", defaultMessage: "Renforcer sa tolérance à la frustration et sa capacité à composer avec les contraintes ou les délais." },

  SCOPE_REPORT_IMPULSIVITY_PERCENTILE_100_OPTIMIZE: {
    id: "app.scope_report_impulsivity_percentile_100_optimize",
    defaultMessage:
      "Comment optimiser ma performance : Me positionner sur des projets dynamiques, courts ou urgents, avec peu de lourdeurs.",
  },
  SCOPE_REPORT_IMPULSIVITY_PERCENTILE_100_MOTIVATION: {
    id: "app.scope_report_impulsivity_percentile_100_motivation",
    defaultMessage:
      "L’intensité, la liberté, l’adrénaline et l’action immédiate.",
  },
  SCOPE_REPORT_IMPULSIVITY_PERCENTILE_100_TEAM_ADVICE: {
    id: "app.scope_report_impulsivity_percentile_100_team_advice",
    defaultMessage:
      "Conseil d’équipe : Encadrez mes élans sans les brider : je peux créer beaucoup de mouvement… si je suis bien orienté·e.",
  },

  SCOPE_REPORT_PESSIMISM_AXIS_HIGH: {
    id: "app.scope_report_pessimism_axis_high",
    defaultMessage: "Pessimisme",
  },
  SCOPE_REPORT_PESSIMISM_AXIS_LOW: {
    id: "app.scope_report_pessimism_axis_low",
    defaultMessage: "Optimisme",
  },
  SCOPE_REPORT_PESSIMISM_AXIS_HIGH_DESC: {
    id: "app.scope_report_pessimism_axis_high_desc",
    defaultMessage:
      "Une personne pessimiste a une sensibilité particulière aux difficultés de la vie. Elle perçoit plus facilement ce qui peut mal tourner, ce qui la rend souvent prudente et réaliste.",
  },
  SCOPE_REPORT_PESSIMISM_AXIS_LOW_DESC: {
    id: "app.scope_report_pessimism_axis_low_desc",
    defaultMessage:
      "Une personne peu pessimiste aborde les situations avec confiance et entrain ; elle conserve une attitude positive et pleine d’espoir, même face aux obstacles.",
  },
  SCOPE_REPORT_PESSIMISM_PERCENTILE_25_TITLE: {
    id: "app.scope_report_pessimism_percentile_25_title",
    defaultMessage:
      "25e percentil (faible pessimisme → optimiste / confiant·e)",
  },
  SCOPE_REPORT_PESSIMISM_PERCENTILE_25_STRENGTHS_INTRO: { id: "app.scope_report_pessimism_percentile_25_strengths_intro", defaultMessage: "Ce que la personne apporte :" },
  SCOPE_REPORT_PESSIMISM_PERCENTILE_25_STRENGTHS_1: { id: "app.scope_report_pessimism_percentile_25_strengths_1", defaultMessage: "Attitude positive, motivante, voit les opportunités avant les risques." },
  SCOPE_REPORT_PESSIMISM_PERCENTILE_25_STRENGTHS_2: { id: "app.scope_report_pessimism_percentile_25_strengths_2", defaultMessage: "Encourage l'équipe à avancer, à croire en la réussite." },
  SCOPE_REPORT_PESSIMISM_PERCENTILE_25_STRENGTHS_3: { id: "app.scope_report_pessimism_percentile_25_strengths_3", defaultMessage: "Aide à maintenir le moral en période de doute ou d’échec." },

  SCOPE_REPORT_PESSIMISM_PERCENTILE_25_DEVELOPMENT_INTRO: { id: "app.scope_report_pessimism_percentile_25_development_intro", defaultMessage: "Points de développement :" },
  SCOPE_REPORT_PESSIMISM_PERCENTILE_25_DEVELOPMENT_1: { id: "app.scope_report_pessimism_percentile_25_development_1", defaultMessage: "Renforcer sa vigilance face aux risques et apprendre à identifier les signaux d’alerte." },
  SCOPE_REPORT_PESSIMISM_PERCENTILE_25_DEVELOPMENT_2: { id: "app.scope_report_pessimism_percentile_25_development_2", defaultMessage: "Ne pas minimiser les difficultés vécues par les autres." },
  SCOPE_REPORT_PESSIMISM_PERCENTILE_25_DEVELOPMENT_3: { id: "app.scope_report_pessimism_percentile_25_development_3", defaultMessage: "Prendre en compte les objections réalistes sans les balayer." },

  SCOPE_REPORT_PESSIMISM_PERCENTILE_25_OPTIMIZE: {
    id: "app.scope_report_pessimism_percentile_25_optimize",
    defaultMessage:
      "Comment optimiser ma performance : Me faire contribuer dans des phases de relance, de transformation ou de gestion du changement.",
  },
  SCOPE_REPORT_PESSIMISM_PERCENTILE_25_MOTIVATION: {
    id: "app.scope_report_pessimism_percentile_25_motivation",
    defaultMessage:
      "L’espoir d’un avenir meilleur, les défis à relever, les projets porteurs de sens.",
  },
  SCOPE_REPORT_PESSIMISM_PERCENTILE_25_TEAM_ADVICE: {
    id: "app.scope_report_pessimism_percentile_25_team_advice",
    defaultMessage:
      "Conseil d’équipe : Appuyez-vous sur mon énergie positive, mais aidez-moi à garder un ancrage réaliste.",
  },
  SCOPE_REPORT_PESSIMISM_PERCENTILE_100_TITLE: {
    id: "app.scope_report_pessimism_percentile_100_title",
    defaultMessage: "100e percentil (pessimisme très fort)",
  },
  SCOPE_REPORT_PESSIMISM_PERCENTILE_100_STRENGTHS_INTRO: { id: "app.scope_report_pessimism_percentile_100_strengths_intro", defaultMessage: "Ce que la personne apporte :" },
  SCOPE_REPORT_PESSIMISM_PERCENTILE_100_STRENGTHS_1: { id: "app.scope_report_pessimism_percentile_100_strengths_1", defaultMessage: "Repère les failles, les risques ou les angles morts que d’autres ne voient pas." },
  SCOPE_REPORT_PESSIMISM_PERCENTILE_100_STRENGTHS_2: { id: "app.scope_report_pessimism_percentile_100_strengths_2", defaultMessage: "Sert d’alerte dans les situations de surconfiance collective." },
  SCOPE_REPORT_PESSIMISM_PERCENTILE_100_STRENGTHS_3: { id: "app.scope_report_pessimism_percentile_100_strengths_3", defaultMessage: "Porte un regard lucide et sans complaisance sur la réalité." },

  SCOPE_REPORT_PESSIMISM_PERCENTILE_100_DEVELOPMENT_INTRO: { id: "app.scope_report_pessimism_percentile_100_development_intro", defaultMessage: "Points de développement :" },
  SCOPE_REPORT_PESSIMISM_PERCENTILE_100_DEVELOPMENT_1: { id: "app.scope_report_pessimism_percentile_100_development_1", defaultMessage: "Apprendre à reformuler ses craintes de manière constructive." },
  SCOPE_REPORT_PESSIMISM_PERCENTILE_100_DEVELOPMENT_2: { id: "app.scope_report_pessimism_percentile_100_development_2", defaultMessage: "Ne pas se laisser enfermer dans une vision fataliste." },
  SCOPE_REPORT_PESSIMISM_PERCENTILE_100_DEVELOPMENT_3: { id: "app.scope_report_pessimism_percentile_100_development_3", defaultMessage: "Se reconnecter à ce qui donne envie d’avancer, individuellement ou collectivement." },

  SCOPE_REPORT_PESSIMISM_PERCENTILE_100_OPTIMIZE: {
    id: "app.scope_report_pessimism_percentile_100_optimize",
    defaultMessage:
      "Comment optimiser ma performance : Me positionner comme vigie ou garde-fou dans des projets à fort enjeu, tout en m’associant à des profils plus porteurs.",
  },
  SCOPE_REPORT_PESSIMISM_PERCENTILE_100_MOTIVATION: {
    id: "app.scope_report_pessimism_percentile_100_motivation",
    defaultMessage:
      "Être écouté·e, pouvoir prévenir les erreurs, ne pas être contraint·e à l’enthousiasme forcé.",
  },
  SCOPE_REPORT_PESSIMISM_PERCENTILE_100_TEAM_ADVICE: {
    id: "app.scope_report_pessimism_percentile_100_team_advice",
    defaultMessage:
      "Conseil d’équipe : Laissez-moi exprimer mes doutes, mais accompagnez-moi pour transformer mon regard en action utile.",
  },

  SCOPE_REPORT_SELFASSURANCE_AXIS_HIGH: {
    id: "app.scope_report_selfassurance_axis_high",
    defaultMessage: "Confiance en soi",
  },
  SCOPE_REPORT_SELFASSURANCE_AXIS_LOW: {
    id: "app.scope_report_selfassurance_axis_low",
    defaultMessage: "Doute de soi",
  },
  SCOPE_REPORT_SELFASSURANCE_AXIS_HIGH_DESC: {
    id: "app.scope_report_selfassurance_axis_high_desc",
    defaultMessage:
      "Une personne ayant une bonne confiance en elle s’appuie sur ses ressources, se sent capable et avance avec assurance. Elle affirme ses idées, prend des décisions avec autonomie et peut donner une impression de grande maîtrise d’elle-même.",
  },
  SCOPE_REPORT_SELFASSURANCE_AXIS_LOW_DESC: {
    id: "app.scope_report_selfassurance_axis_low_desc",
    defaultMessage:
      "Une personne avec une confiance en soi plus modeste fait preuve d’humilité, reste à l’écoute des autres, et prend le temps de réfléchir avant d’agir. Elle cherche souvent à progresser et à se remettre en question avec sincérité.",
  },
  SCOPE_REPORT_SELFASSURANCE_PERCENTILE_25_TITLE: {
    id: "app.scope_report_selfassurance_percentile_25_title",
    defaultMessage: "25e percentil (faible confiance en soi)",
  },
  SCOPE_REPORT_SELFASSURANCE_PERCENTILE_25_STRENGTHS_INTRO: { id: "app.scope_report_selfassurance_percentile_25_strengths_intro", defaultMessage: "Ce que la personne apporte :" },
  SCOPE_REPORT_SELFASSURANCE_PERCENTILE_25_STRENGTHS_1: { id: "app.scope_report_selfassurance_percentile_25_strengths_1", defaultMessage: "Attitude humble, réaliste sur ses limites." },
  SCOPE_REPORT_SELFASSURANCE_PERCENTILE_25_STRENGTHS_2: { id: "app.scope_report_selfassurance_percentile_25_strengths_2", defaultMessage: "Prudente dans ses décisions, évite les excès de confiance." },
  SCOPE_REPORT_SELFASSURANCE_PERCENTILE_25_STRENGTHS_3: { id: "app.scope_report_selfassurance_percentile_25_strengths_3", defaultMessage: "Capable de bien écouter et de demander de l’aide." },

  SCOPE_REPORT_SELFASSURANCE_PERCENTILE_25_DEVELOPMENT_INTRO: { id: "app.scope_report_selfassurance_percentile_25_development_intro", defaultMessage: "Points de développement :" },
  SCOPE_REPORT_SELFASSURANCE_PERCENTILE_25_DEVELOPMENT_1: { id: "app.scope_report_selfassurance_percentile_25_development_1", defaultMessage: "Croire davantage en ses compétences et oser les mettre en avant." },
  SCOPE_REPORT_SELFASSURANCE_PERCENTILE_25_DEVELOPMENT_2: { id: "app.scope_report_selfassurance_percentile_25_development_2", defaultMessage: "Prendre la parole sans attendre d’être “parfait·e” ou totalement prêt·e." },
  SCOPE_REPORT_SELFASSURANCE_PERCENTILE_25_DEVELOPMENT_3: { id: "app.scope_report_selfassurance_percentile_25_development_3", defaultMessage: "Apprendre à assumer ses idées sans s’excuser ou se comparer." },

  SCOPE_REPORT_SELFASSURANCE_PERCENTILE_25_OPTIMIZE: {
    id: "app.scope_report_selfassurance_percentile_25_optimize",
    defaultMessage:
      "Comment optimiser ma performance : Me donner des responsabilités progressives, avec des encouragements visibles.",
  },
  SCOPE_REPORT_SELFASSURANCE_PERCENTILE_25_MOTIVATION: {
    id: "app.scope_report_selfassurance_percentile_25_motivation",
    defaultMessage:
      "La reconnaissance bienveillante, les petits succès concrets, le sentiment d’avoir progressé.",
  },
  SCOPE_REPORT_SELFASSURANCE_PERCENTILE_25_TEAM_ADVICE: {
    id: "app.scope_report_selfassurance_percentile_25_team_advice",
    defaultMessage:
      "Conseil d’équipe : Encouragez-moi, valorisez mes avancées, même modestes : j’ai besoin de sentir que je peux y arriver.",
  },
  SCOPE_REPORT_SELFASSURANCE_PERCENTILE_100_TITLE: {
    id: "app.scope_report_selfassurance_percentile_100_title",
    defaultMessage: "100e percentil (très forte confiance en soi)",
  },
  SCOPE_REPORT_SELFASSURANCE_PERCENTILE_100_STRENGTHS_INTRO: { id: "app.scope_report_selfassurance_percentile_100_strengths_intro", defaultMessage: "Ce que la personne apporte :" },
  SCOPE_REPORT_SELFASSURANCE_PERCENTILE_100_STRENGTHS_1: { id: "app.scope_report_selfassurance_percentile_100_strengths_1", defaultMessage: "Forte autonomie et capacité à prendre des décisions même sous pression." },
  SCOPE_REPORT_SELFASSURANCE_PERCENTILE_100_STRENGTHS_2: { id: "app.scope_report_selfassurance_percentile_100_strengths_2", defaultMessage: "Présence affirmée, inspire et entraîne les autres par sa conviction." },
  SCOPE_REPORT_SELFASSURANCE_PERCENTILE_100_STRENGTHS_3: { id: "app.scope_report_selfassurance_percentile_100_strengths_3", defaultMessage: "Très à l’aise dans des contextes à haute visibilité ou à fort enjeu." },

  SCOPE_REPORT_SELFASSURANCE_PERCENTILE_100_DEVELOPMENT_INTRO: { id: "app.scope_report_selfassurance_percentile_100_development_intro", defaultMessage: "Points de développement :" },
  SCOPE_REPORT_SELFASSURANCE_PERCENTILE_100_DEVELOPMENT_1: { id: "app.scope_report_selfassurance_percentile_100_development_1", defaultMessage: "Éviter de paraître trop sûr·e de soi ou de minimiser les apports des autres." },
  SCOPE_REPORT_SELFASSURANCE_PERCENTILE_100_DEVELOPMENT_2: { id: "app.scope_report_selfassurance_percentile_100_development_2", defaultMessage: "Travailler l’empathie et l’humilité dans les échanges." },
  SCOPE_REPORT_SELFASSURANCE_PERCENTILE_100_DEVELOPMENT_3: { id: "app.scope_report_selfassurance_percentile_100_development_3", defaultMessage: "Apprendre à reconnaître ses zones de doute ou ses limites." },

  SCOPE_REPORT_SELFASSURANCE_PERCENTILE_100_OPTIMIZE: {
    id: "app.scope_report_selfassurance_percentile_100_optimize",
    defaultMessage:
      "Comment optimiser ma performance : Me confier des rôles de pilotage ou de prise de décision, surtout dans des contextes ambitieux.",
  },
  SCOPE_REPORT_SELFASSURANCE_PERCENTILE_100_MOTIVATION: {
    id: "app.scope_report_selfassurance_percentile_100_motivation",
    defaultMessage:
      "La reconnaissance de mes compétences, la possibilité de mener, d’impacter, d’être écouté·e.",
  },
  SCOPE_REPORT_SELFASSURANCE_PERCENTILE_100_TEAM_ADVICE: {
    id: "app.scope_report_selfassurance_percentile_100_team_advice",
    defaultMessage:
      "Conseil d’équipe : Laissez-moi prendre des initiatives, mais osez me recadrer si je vais trop loin : je respecte les avis clairs.",
  },

  SCOPE_REPORT_DOMINANCE_AXIS_HIGH: {
    id: "app.scope_report_dominance_axis_high",
    defaultMessage: "Esprit dominant",
  },
  SCOPE_REPORT_DOMINANCE_AXIS_LOW: {
    id: "app.scope_report_dominance_axis_low",
    defaultMessage: "Esprit coopératif",
  },
  SCOPE_REPORT_DOMINANCE_AXIS_HIGH_DESC: {
    id: "app.scope_report_dominance_axis_high_desc",
    defaultMessage:
      "Une personne à l’esprit dominant aime prendre l’initiative, guider les autres et assumer un rôle de leadership. Elle s’exprime avec assurance et sait affirmer ses positions.",
  },
  SCOPE_REPORT_DOMINANCE_AXIS_LOW_DESC: {
    id: "app.scope_report_dominance_axis_low_desc",
    defaultMessage:
      "Une personne moins portée sur la domination privilégie la coopération, l’écoute et la mise en valeur du collectif. Elle adopte une posture humble, souvent appréciée pour sa capacité à travailler dans un esprit d’égalité et de respect mutuel.",
  },
  SCOPE_REPORT_DOMINANCE_PERCENTILE_25_TITLE: {
    id: "app.scope_report_dominance_percentile_25_title",
    defaultMessage: "25e percentil (faible dominance)",
  },
  SCOPE_REPORT_DOMINANCE_PERCENTILE_25_STRENGTHS_INTRO: { id: "app.scope_report_dominance_percentile_25_strengths_intro", defaultMessage: "Ce que la personne apporte :" },
  SCOPE_REPORT_DOMINANCE_PERCENTILE_25_STRENGTHS_1: { id: "app.scope_report_dominance_percentile_25_strengths_1", defaultMessage: "Attitude conciliante, respectueuse des avis et du rythme des autres." },
  SCOPE_REPORT_DOMINANCE_PERCENTILE_25_STRENGTHS_2: { id: "app.scope_report_dominance_percentile_25_strengths_2", defaultMessage: "Favorise la coopération, la diplomatie et le consensus." },
  SCOPE_REPORT_DOMINANCE_PERCENTILE_25_STRENGTHS_3: { id: "app.scope_report_dominance_percentile_25_strengths_3", defaultMessage: "Bon·ne médiateur·trice, évite les conflits et les rapports de force." },

  SCOPE_REPORT_DOMINANCE_PERCENTILE_25_DEVELOPMENT_INTRO: { id: "app.scope_report_dominance_percentile_25_development_intro", defaultMessage: "Points de développement :" },
  SCOPE_REPORT_DOMINANCE_PERCENTILE_25_DEVELOPMENT_1: { id: "app.scope_report_dominance_percentile_25_development_1", defaultMessage: "Renforcer sa capacité à affirmer son point de vue avec assurance, même face à l’opposition." },
  SCOPE_REPORT_DOMINANCE_PERCENTILE_25_DEVELOPMENT_2: { id: "app.scope_report_dominance_percentile_25_development_2", defaultMessage: "Travailler sa posture d’influence pour occuper pleinement sa place dans le collectif." },
  SCOPE_REPORT_DOMINANCE_PERCENTILE_25_DEVELOPMENT_3: { id: "app.scope_report_dominance_percentile_25_development_3", defaultMessage: "Développer sa confiance dans la prise de décision, notamment en contexte complexe ou sous pression." },

  SCOPE_REPORT_DOMINANCE_PERCENTILE_25_OPTIMIZE: {
    id: "app.scope_report_dominance_percentile_25_optimize",
    defaultMessage:
      "Comment optimiser ma performance : Me placer dans des environnements collaboratifs où la hiérarchie est peu marquée.",
  },
  SCOPE_REPORT_DOMINANCE_PERCENTILE_25_MOTIVATION: {
    id: "app.scope_report_dominance_percentile_25_motivation",
    defaultMessage:
      "La coopération, l’égalité, un climat sans jeux de pouvoir.",
  },
  SCOPE_REPORT_DOMINANCE_PERCENTILE_25_TEAM_ADVICE: {
    id: "app.scope_report_dominance_percentile_25_team_advice",
    defaultMessage:
      "Conseil d’équipe : Laissez-moi contribuer à mon rythme, dans un cadre non compétitif et respectueux.",
  },
  SCOPE_REPORT_DOMINANCE_PERCENTILE_100_TITLE: {
    id: "app.scope_report_dominance_percentile_100_title",
    defaultMessage: "100e percentil (dominance très forte)",
  },
  SCOPE_REPORT_DOMINANCE_PERCENTILE_100_STRENGTHS_INTRO: { id: "app.scope_report_dominance_percentile_100_strengths_intro", defaultMessage: "Ce que la personne apporte :" },
  SCOPE_REPORT_DOMINANCE_PERCENTILE_100_STRENGTHS_1: { id: "app.scope_report_dominance_percentile_100_strengths_1", defaultMessage: "Grande force de décision, de conviction et de direction." },
  SCOPE_REPORT_DOMINANCE_PERCENTILE_100_STRENGTHS_2: { id: "app.scope_report_dominance_percentile_100_strengths_2", defaultMessage: "Peut porter l’équipe dans des moments de crise ou de compétition." },
  SCOPE_REPORT_DOMINANCE_PERCENTILE_100_STRENGTHS_3: { id: "app.scope_report_dominance_percentile_100_strengths_3", defaultMessage: "Excellent·e dans les contextes où il faut trancher vite, prendre les rênes." },

  SCOPE_REPORT_DOMINANCE_PERCENTILE_100_DEVELOPMENT_INTRO: { id: "app.scope_report_dominance_percentile_100_development_intro", defaultMessage: "Points de développement :" },
  SCOPE_REPORT_DOMINANCE_PERCENTILE_100_DEVELOPMENT_1: { id: "app.scope_report_dominance_percentile_100_development_1", defaultMessage: "Prendre soin de ne pas écraser les autres par excès d’assurance." },
  SCOPE_REPORT_DOMINANCE_PERCENTILE_100_DEVELOPMENT_2: { id: "app.scope_report_dominance_percentile_100_development_2", defaultMessage: "Intégrer des temps d’écoute pour favoriser l’engagement collectif." },
  SCOPE_REPORT_DOMINANCE_PERCENTILE_100_DEVELOPMENT_3: { id: "app.scope_report_dominance_percentile_100_development_3", defaultMessage: "Apprendre à tempérer l’autorité par la coopération." },

  SCOPE_REPORT_DOMINANCE_PERCENTILE_100_OPTIMIZE: {
    id: "app.scope_report_dominance_percentile_100_optimize",
    defaultMessage:
      "Comment optimiser ma performance : Me placer en position de leader sur des projets stratégiques ou à fort enjeu.",
  },
  SCOPE_REPORT_DOMINANCE_PERCENTILE_100_MOTIVATION: {
    id: "app.scope_report_dominance_percentile_100_motivation",
    defaultMessage:
      "L’autorité reconnue, les responsabilités claires et la capacité à orienter les choses.",
  },
  SCOPE_REPORT_DOMINANCE_PERCENTILE_100_TEAM_ADVICE: {
    id: "app.scope_report_dominance_percentile_100_team_advice",
    defaultMessage:
      "Conseil d’équipe : Laissez-moi piloter, mais accompagnez-moi pour équilibrer pouvoir et écoute.",
  },

  SCOPE_REPORT_AGGRESSIVENESS_AXIS_HIGH: {
    id: "app.scope_report_aggressiveness_axis_high",
    defaultMessage: "Agressivité",
  },
  SCOPE_REPORT_AGGRESSIVENESS_AXIS_LOW: {
    id: "app.scope_report_aggressiveness_axis_low",
    defaultMessage: "Agréabilité",
  },
  SCOPE_REPORT_AGGRESSIVENESS_AXIS_HIGH_DESC: {
    id: "app.scope_report_aggressiveness_axis_high_desc",
    defaultMessage:
      "Une personne à tendance agressive s’exprime avec assurance, prend position facilement et n’hésite pas à défendre ses idées avec fermeté, parfois de manière directe ou tranchée. Elle peut se montrer critique ou confrontante, ce qui peut faire avancer les débats.",
  },
  SCOPE_REPORT_AGGRESSIVENESS_AXIS_LOW_DESC: {
    id: "app.scope_report_aggressiveness_axis_low_desc",
    defaultMessage:
      "Une personne peu agressive privilégie la diplomatie et la bienveillance, même dans les situations tendues. Elle cherche à préserver l’harmonie, se montre patiente, tolérante et conciliante.",
  },
  SCOPE_REPORT_AGGRESSIVENESS_PERCENTILE_25_TITLE: {
    id: "app.scope_report_aggressiveness_percentile_25_title",
    defaultMessage: "25e percentil (faible agressivité → calme / diplomate)",
  },
  SCOPE_REPORT_AGGRESSIVENESS_PERCENTILE_25_STRENGTHS_INTRO: { id: "app.scope_report_aggressiveness_percentile_25_strengths_intro", defaultMessage: "Ce que la personne apporte :" },
  SCOPE_REPORT_AGGRESSIVENESS_PERCENTILE_25_STRENGTHS_1: { id: "app.scope_report_aggressiveness_percentile_25_strengths_1", defaultMessage: "Apaisante, patiente, très bonne dans la gestion des conflits." },
  SCOPE_REPORT_AGGRESSIVENESS_PERCENTILE_25_STRENGTHS_2: { id: "app.scope_report_aggressiveness_percentile_25_strengths_2", defaultMessage: "Favorise un climat de travail serein et respectueux." },
  SCOPE_REPORT_AGGRESSIVENESS_PERCENTILE_25_STRENGTHS_3: { id: "app.scope_report_aggressiveness_percentile_25_strengths_3", defaultMessage: "Réagit rarement à chaud, fait preuve de retenue." },

  SCOPE_REPORT_AGGRESSIVENESS_PERCENTILE_25_DEVELOPMENT_INTRO: { id: "app.scope_report_aggressiveness_percentile_25_development_intro", defaultMessage: "Points de développement :" },
  SCOPE_REPORT_AGGRESSIVENESS_PERCENTILE_25_DEVELOPMENT_1: { id: "app.scope_report_aggressiveness_percentile_25_development_1", defaultMessage: "Renforcer sa capacité à poser des limites claires et à exprimer un désaccord de manière posée." },
  SCOPE_REPORT_AGGRESSIVENESS_PERCENTILE_25_DEVELOPMENT_2: { id: "app.scope_report_aggressiveness_percentile_25_development_2", defaultMessage: "Apprendre à se préserver en affirmant ses besoins sans culpabilité." },
  SCOPE_REPORT_AGGRESSIVENESS_PERCENTILE_25_DEVELOPMENT_3: { id: "app.scope_report_aggressiveness_percentile_25_development_3", defaultMessage: "Développer des stratégies pour faire face aux conflits plutôt que de les éviter." },

  SCOPE_REPORT_AGGRESSIVENESS_PERCENTILE_25_OPTIMIZE: {
    id: "app.scope_report_aggressiveness_percentile_25_optimize",
    defaultMessage:
      "Comment optimiser ma performance : Me donner un espace sécurisé pour exprimer mes opinions, même si elles sont divergentes.",
  },
  SCOPE_REPORT_AGGRESSIVENESS_PERCENTILE_25_MOTIVATION: {
    id: "app.scope_report_aggressiveness_percentile_25_motivation",
    defaultMessage:
      "Un environnement harmonieux, respectueux, où les conflits sont gérés de façon constructive.",
  },
  SCOPE_REPORT_AGGRESSIVENESS_PERCENTILE_25_TEAM_ADVICE: {
    id: "app.scope_report_aggressiveness_percentile_25_team_advice",
    defaultMessage:
      "Conseil d’équipe : Laissez-moi du temps pour exprimer mes désaccords avec calme — j’ose plus facilement dans un climat apaisé.",
  },
  SCOPE_REPORT_AGGRESSIVENESS_PERCENTILE_100_TITLE: {
    id: "app.scope_report_aggressiveness_percentile_100_title",
    defaultMessage: "100e percentil (agressivité très forte)",
  },
  SCOPE_REPORT_AGGRESSIVENESS_PERCENTILE_100_STRENGTHS_INTRO: { id: "app.scope_report_aggressiveness_percentile_100_strengths_intro", defaultMessage: "Ce que la personne apporte :" },
  SCOPE_REPORT_AGGRESSIVENESS_PERCENTILE_100_STRENGTHS_1: { id: "app.scope_report_aggressiveness_percentile_100_strengths_1", defaultMessage: "Force de conviction et capacité à défendre fermement les idées." },
  SCOPE_REPORT_AGGRESSIVENESS_PERCENTILE_100_STRENGTHS_2: { id: "app.scope_report_aggressiveness_percentile_100_strengths_2", defaultMessage: "Pousse le groupe à se positionner, à sortir des faux-semblants." },
  SCOPE_REPORT_AGGRESSIVENESS_PERCENTILE_100_STRENGTHS_3: { id: "app.scope_report_aggressiveness_percentile_100_strengths_3", defaultMessage: "Prend rapidement position, ce qui évite les zones grises ou l’indécision." },

  SCOPE_REPORT_AGGRESSIVENESS_PERCENTILE_100_DEVELOPMENT_INTRO: { id: "app.scope_report_aggressiveness_percentile_100_development_intro", defaultMessage: "Points de développement :" },
  SCOPE_REPORT_AGGRESSIVENESS_PERCENTILE_100_DEVELOPMENT_1: { id: "app.scope_report_aggressiveness_percentile_100_development_1", defaultMessage: "Apprendre à écouter les autres sans les couper ou les juger." },
  SCOPE_REPORT_AGGRESSIVENESS_PERCENTILE_100_DEVELOPMENT_2: { id: "app.scope_report_aggressiveness_percentile_100_development_2", defaultMessage: "Canaliser son intensité pour éviter les rapports de force inutiles." },
  SCOPE_REPORT_AGGRESSIVENESS_PERCENTILE_100_DEVELOPMENT_3: { id: "app.scope_report_aggressiveness_percentile_100_development_3", defaultMessage: "Transformer l’opposition en construction plutôt qu’en confrontation." },

  SCOPE_REPORT_AGGRESSIVENESS_PERCENTILE_100_OPTIMIZE: {
    id: "app.scope_report_aggressiveness_percentile_100_optimize",
    defaultMessage:
      "Comment optimiser ma performance : Me responsabiliser sur des sujets stratégiques ou conflictuels où il faut trancher et assumer.",
  },
  SCOPE_REPORT_AGGRESSIVENESS_PERCENTILE_100_MOTIVATION: {
    id: "app.scope_report_aggressiveness_percentile_100_motivation",
    defaultMessage:
      "Les débats d’idées, les confrontations saines, et les environnements où la franchise est valorisée.",
  },
  SCOPE_REPORT_AGGRESSIVENESS_PERCENTILE_100_TEAM_ADVICE: {
    id: "app.scope_report_aggressiveness_percentile_100_team_advice",
    defaultMessage:
      "Conseil d’équipe : Ne prenez pas mes propos à titre personnel : je veux que ça avance, pas blesser — mais n’hésitez pas à me dire si je vais trop loin.",
  },

  SCOPE_REPORT_CONSCIENTIOUSNESS_AXIS_HIGH: {
    id: "app.scope_report_conscientiousness_axis_high",
    defaultMessage: "Caractère consciencieux",
  },
  SCOPE_REPORT_CONSCIENTIOUSNESS_AXIS_LOW: {
    id: "app.scope_report_conscientiousness_axis_low",
    defaultMessage: "Désinvolture",
  },
  SCOPE_REPORT_CONSCIENTIOUSNESS_AXIS_HIGH_DESC: {
    id: "app.scope_report_conscientiousness_axis_high_desc",
    defaultMessage:
      "Une personne consciencieuse est fiable, appliquée et attachée à bien faire les choses. Elle aime aller au bout de ses engagements et accorde de l’importance à l’organisation et à la qualité du travail.",
  },
  SCOPE_REPORT_CONSCIENTIOUSNESS_AXIS_LOW_DESC: {
    id: "app.scope_report_conscientiousness_axis_low_desc",
    defaultMessage:
      "Une personne moins consciencieuse fonctionne de manière plus spontanée, flexible, et se laisse davantage guider par l’instant présent que par un cadre structuré.",
  },
  SCOPE_REPORT_CONSCIENTIOUSNESS_PERCENTILE_25_TITLE: {
    id: "app.scope_report_conscientiousness_percentile_25_title",
    defaultMessage: "25e percentil (faible caractère consciencieux)",
  },
  SCOPE_REPORT_CONSCIENTIOUSNESS_PERCENTILE_25_STRENGTHS_INTRO: { id: "app.scope_report_conscientiousness_percentile_25_strengths_intro", defaultMessage: "Ce que la personne apporte :" },
  SCOPE_REPORT_CONSCIENTIOUSNESS_PERCENTILE_25_STRENGTHS_1: { id: "app.scope_report_conscientiousness_percentile_25_strengths_1", defaultMessage: "Flexibilité, spontanéité, capacité à s’adapter rapidement aux imprévus." },
  SCOPE_REPORT_CONSCIENTIOUSNESS_PERCENTILE_25_STRENGTHS_2: { id: "app.scope_report_conscientiousness_percentile_25_strengths_2", defaultMessage: "Moins rigide, souvent créatif·ve ou orienté·e vers l’exploration." },
  SCOPE_REPORT_CONSCIENTIOUSNESS_PERCENTILE_25_STRENGTHS_3: { id: "app.scope_report_conscientiousness_percentile_25_strengths_3", defaultMessage: "Peut remettre en question les routines ou procédures figées." },

  SCOPE_REPORT_CONSCIENTIOUSNESS_PERCENTILE_25_DEVELOPMENT_INTRO: { id: "app.scope_report_conscientiousness_percentile_25_development_intro", defaultMessage: "Points de développement :" },
  SCOPE_REPORT_CONSCIENTIOUSNESS_PERCENTILE_25_DEVELOPMENT_1: { id: "app.scope_report_conscientiousness_percentile_25_development_1", defaultMessage: "Renforcer ses habitudes d’organisation et de suivi pour mieux structurer son travail." },
  SCOPE_REPORT_CONSCIENTIOUSNESS_PERCENTILE_25_DEVELOPMENT_2: { id: "app.scope_report_conscientiousness_percentile_25_development_2", defaultMessage: "Mettre en place des outils ou routines pour limiter les oublis, erreurs ou retards." },
  SCOPE_REPORT_CONSCIENTIOUSNESS_PERCENTILE_25_DEVELOPMENT_3: { id: "app.scope_report_conscientiousness_percentile_25_development_3", defaultMessage: "Travailler sur sa fiabilité perçue en consolidant la régularité dans les livrables." },

  SCOPE_REPORT_CONSCIENTIOUSNESS_PERCENTILE_25_OPTIMIZE: {
    id: "app.scope_report_conscientiousness_percentile_25_optimize",
    defaultMessage:
      "Comment optimiser ma performance : Me donner des objectifs souples mais clairs, avec un cadre léger et évolutif.",
  },
  SCOPE_REPORT_CONSCIENTIOUSNESS_PERCENTILE_25_MOTIVATION: {
    id: "app.scope_report_conscientiousness_percentile_25_motivation",
    defaultMessage:
      "La liberté d’agir à ma façon, la nouveauté, et les environnements non contraignants.",
  },
  SCOPE_REPORT_CONSCIENTIOUSNESS_PERCENTILE_25_TEAM_ADVICE: {
    id: "app.scope_report_conscientiousness_percentile_25_team_advice",
    defaultMessage:
      "Conseil d’équipe : Encadrez sans rigidité, laissez-moi de l’espace, mais rappelez-moi les échéances essentielles.",
  },
  SCOPE_REPORT_CONSCIENTIOUSNESS_PERCENTILE_100_TITLE: {
    id: "app.scope_report_conscientiousness_percentile_100_title",
    defaultMessage: "100e percentil (très haute conscience)",
  },
  SCOPE_REPORT_CONSCIENTIOUSNESS_PERCENTILE_100_STRENGTHS_INTRO: { id: "app.scope_report_conscientiousness_percentile_100_strengths_intro", defaultMessage: "Ce que la personne apporte :" },
  SCOPE_REPORT_CONSCIENTIOUSNESS_PERCENTILE_100_STRENGTHS_1: { id: "app.scope_report_conscientiousness_percentile_100_strengths_1", defaultMessage: "Discipline et rigueur exceptionnelles, moteur d’exécution dans l’équipe." },
  SCOPE_REPORT_CONSCIENTIOUSNESS_PERCENTILE_100_STRENGTHS_2: { id: "app.scope_report_conscientiousness_percentile_100_strengths_2", defaultMessage: "Excellente capacité à planifier, suivre, et finaliser les tâches complexes." },
  SCOPE_REPORT_CONSCIENTIOUSNESS_PERCENTILE_100_STRENGTHS_3: { id: "app.scope_report_conscientiousness_percentile_100_strengths_3", defaultMessage: "Peut incarner un standard élevé de qualité et de fiabilité." },

  SCOPE_REPORT_CONSCIENTIOUSNESS_PERCENTILE_100_DEVELOPMENT_INTRO: { id: "app.scope_report_conscientiousness_percentile_100_development_intro", defaultMessage: "Points de développement :" },
  SCOPE_REPORT_CONSCIENTIOUSNESS_PERCENTILE_100_DEVELOPMENT_1: { id: "app.scope_report_conscientiousness_percentile_100_development_1", defaultMessage: "Accepter que “suffisamment bien” peut parfois suffire." },
  SCOPE_REPORT_CONSCIENTIOUSNESS_PERCENTILE_100_DEVELOPMENT_2: { id: "app.scope_report_conscientiousness_percentile_100_development_2", defaultMessage: "Cultiver davantage de souplesse et de lâcher-prise dans des contextes imprévus ou moins cadrés." },
  SCOPE_REPORT_CONSCIENTIOUSNESS_PERCENTILE_100_DEVELOPMENT_3: { id: "app.scope_report_conscientiousness_percentile_100_development_3", defaultMessage: "Travailler une communication bienveillante pour maintenir l’exigence sans générer de pression." },

  SCOPE_REPORT_CONSCIENTIOUSNESS_PERCENTILE_100_OPTIMIZE: {
    id: "app.scope_report_conscientiousness_percentile_100_optimize",
    defaultMessage:
      "Comment optimiser ma performance : Me donner des missions de confiance où la qualité est critique et l’autonomie respectée.",
  },
  SCOPE_REPORT_CONSCIENTIOUSNESS_PERCENTILE_100_MOTIVATION: {
    id: "app.scope_report_conscientiousness_percentile_100_motivation",
    defaultMessage:
      "Le sentiment d’être utile, d’avoir bien fait mon travail, et qu’on peut compter sur moi.",
  },
  SCOPE_REPORT_CONSCIENTIOUSNESS_PERCENTILE_100_TEAM_ADVICE: {
    id: "app.scope_report_conscientiousness_percentile_100_team_advice",
    defaultMessage:
      "Conseil d’équipe : Montrez que vous valorisez ma rigueur, mais aidez-moi à garder une vision plus souple quand c’est possible.",
  },


  CANDIDATE: {
    id: "app.candidate",
    defaultMessage: "Candidat",
  },
  PAGE: {
    id: "app.page",
    defaultMessage: "Page",
  },
  TEST_DATE: {
    id: "app.test_date",
    defaultMessage: "Date de passage du test",
  },
  TEST_TIME_TAKEN: {
    id: "app.test_duration",
    defaultMessage: "Durée du test",
  },
  REPORT_TITLE: {
    id: "app.scope_report_title",
    defaultMessage: "Votre Rapport SCOPE",
  },
  REPORT_ATTITUDES_SUBTITLE: {
    id: "app.scope_report_attitudes_subtitle",
    defaultMessage: "PATEK PHILIPPE",
  },
  SCOPE_REPORT_INTRO_TITLE: {
    id: "app.scope_report_intro_title",
    defaultMessage: "Découvrez votre profil avec SCOPE",
  },
  SCOPE_REPORT_INTRO_WELCOME: {
    id: "app.scope_report_intro_welcome",
    defaultMessage:
      "Bienvenue dans votre rapport SCOPE, un outil psychométrique innovant fondé sur les dernières avancées de la recherche scientifique. SCOPE a été conçu pour vous offrir une vision précise, nuancée et utile de votre fonctionnement personnel et professionnel.",
  },
  SCOPE_ATTITUDES_REPORT_INTRO_WELCOME: {
    id: "app.scope_attitudes_report_intro_welcome",
    defaultMessage:
      "Welcome and happy reading! Before diving into your SCOPE report, an innovative psychometric tool based on the latest advances in scientific research, here is some general information that will facilitate your interpretation of your results. SCOPE was designed to provide you with a precise, nuanced, and useful vision of your personal and professional functioning. Based on your SCOPE results, we have measured which fundamental Patek Philippe attitudes best match your natural behavior.",
  },
  SCOPE_REPORT_INTRO_DISTINCTION: {
    id: "app.scope_report_intro_distinction",
    defaultMessage: "Ce qui distingue SCOPE, c’est sa double approche :",
  },
  SCOPE_REPORT_INTRO_SELF_EVAL_SUBTITLE: {
    id: "app.scope_report_intro_self_eval_subtitle",
    defaultMessage:
      "L’auto-évaluation : ",
  },
  SCOPE_REPORT_INTRO_SELF_EVAL: {
    id: "app.scope_report_intro_self_eval",
    defaultMessage:
      "vous répondez à des questions sur vos besoins, comportements, opinions et attitudes. Ces réponses sont analysées à l’aide de modèles scientifiques éprouvés, puis comparées à des groupes de référence adaptés à votre contexte (par exemple : métiers, niveaux de responsabilité, genre, etc.).",
  },
  SCOPE_REPORT_INTRO_OBJECTIVE_EVAL_SUBTITLE: {
    id: "app.scope_report_intro_objective_eval_subtitle",
    defaultMessage:
      "L’évaluation objective : ",
  },
  SCOPE_REPORT_INTRO_OBJECTIVE_EVAL: {
    id: "app.scope_report_intro_objective_eval",
    defaultMessage:
      "certains tests mesurent directement vos capacités (comme le raisonnement logique), de manière indépendante de votre perception de vous-même.",
  },
  SCOPE_REPORT_INTRO_HOW_TO_READ_TITLE: {
    id: "app.scope_report_intro_how_to_read_title",
    defaultMessage: "Comment interpréter vos résultats ?",
  },
  SCOPE_REPORT_INTRO_HOW_TO_READ_DESC: {
    id: "app.scope_report_intro_how_to_read_desc",
    defaultMessage:
      "Vos résultats sont présentés sous forme de scores relatifs, illustrant votre position par rapport à un groupe de comparaison. Des graphiques facilitent la lecture : vous saurez si vous vous situez plutôt dans le tiers inférieur, moyen ou supérieur pour chaque dimension évaluée.",
  },
  SCOPE_REPORT_INTRO_SECTIONS_TITLE: {
    id: "app.scope_report_intro_sections_title",
    defaultMessage: "Les différentes sections de votre rapport vous donneront un aperçu de :",
  },
  SCOPE_REPORT_INTRO_SECTION_PERSONALITY: {
    id: "app.scope_report_intro_section_personality",
    defaultMessage: "Vos traits de personnalité p. ",
  },
  SCOPE_REPORT_INTRO_SECTION_CAPACITIYREASONING: {
    id: "app.scope_report_intro_section_capacity_for_reasoning",
    defaultMessage: "Votre Style cognitif p. ",
  },
  SCOPE_REPORT_INTRO_SECTION_COGNITIVE: {
    id: "app.scope_report_intro_section_cognitive",
    defaultMessage: "Vos capacités cognitives p. ",
  },
  SCOPE_REPORT_INTRO_SECTION_EMOTION: {
    id: "app.scope_report_intro_section_emotion",
    defaultMessage: "Vos stratégies émotionnelles p. ",
  },
    SCOPE_REPORT_INTRO_SECTION_ACTION: {
    id: "app.scope_report_intro_section_action",
    defaultMessage: "Vos tendances à l'action p. ",
  },
  SCOPE_REPORT_INTRO_SECTION_MOTIVATION: {
    id: "app.scope_report_intro_section_motivation",
    defaultMessage: "Vos sources de motivation p. ",
  },
  SCOPE_REPORT_INTRO_SECTION_VALUES: {
    id: "app.scope_report_intro_section_values",
    defaultMessage: "Vos valeurs préférées p. ",
  },
  SCOPE_REPORT_INTRO_SECTION_ATTITUDES: {
    id: "app.scope_report_intro_section_attitudes",
    defaultMessage: "Your fundamental attitudes p. ",
  },
  SCOPE_REPORT_INTRO_KEEP_IN_MIND_TITLE: {
    id: "app.scope_report_intro_keep_in_mind_title",
    defaultMessage: "Ce qu’il faut garder en tête",
  },
  SCOPE_REPORT_INTRO_KEEP_IN_MIND_1: {
    id: "app.scope_report_intro_keep_in_mind_1",
    defaultMessage:
      "Il n’y a pas de bon ou de mauvais score en soi. L’essentiel est de comprendre ce que cela signifie pour vous, selon vos objectifs et votre environnement.",
  },
  SCOPE_REPORT_INTRO_KEEP_IN_MIND_2: {
    id: "app.scope_report_intro_keep_in_mind_2",
    defaultMessage:
      "SCOPE ne cherche pas à vous « mettre dans une case » : chaque profil est unique et multidimensionnel.",
  },
   LOWERTHIRD: {
    id: "app.lowerThird",
    defaultMessage: "tiers inférieur",
  },
  MIDDLETHIRD: {
    id: "app.middleThird",
    defaultMessage: "tiers moyen",
  },
  UPPERTHIRD: {
    id: "app.upperThird",
    defaultMessage: "tiers supérieur",
  },
  SCOPE_REPORT_TOP_THREE: {
    id: "app.scope_report_top_three",
    defaultMessage: "Vos 3 traits les plus marquants",
  },
    SCOPE_REPORT_PERSONAL_NOTES_TITLE: {
    id: "app.scope_report_personal_notes_title",
    defaultMessage: "Ce que je retiens de mon profil",
  },
  SCOPE_REPORT_PERSONAL_NOTES_STRENGTHS: {
    id: "app.scope_report_personal_notes_strengths",
    defaultMessage: "Mes forces clés :",
  },
  SCOPE_REPORT_PERSONAL_NOTES_STRENGTHS_EXAMPLE: {
    id: "app.scope_report_personal_notes_strengths_example",
    defaultMessage: "→ Ex. : raisonnement rapide, motivation intrinsèque, gestion émotionnelle stable...",
  },
  SCOPE_REPORT_PERSONAL_NOTES_STRENGTHS_CONTEXTS: {
    id: "app.scope_report_personal_notes_strengths_contexts",
    defaultMessage: "Les situations où mes forces sont utiles",
  },
  SCOPE_REPORT_PERSONAL_NOTES_STRENGTHS_CONTEXTS_EXAMPLE: {
    id: "app.scope_report_personal_notes_strengths_contexts_example",
    defaultMessage: "Dans quels contextes ou projets ai-je déjà utilisé mes forces avec succès ?",
  },
  SCOPE_REPORT_PERSONAL_NOTES_DEVELOPMENT: {
    id: "app.scope_report_personal_notes_development",
    defaultMessage: "Mes axes de vigilance ou de développement :",
  },
  SCOPE_REPORT_PERSONAL_NOTES_DEVELOPMENT_EXAMPLE: {
    id: "app.scope_report_personal_notes_development_example",
    defaultMessage: "→ Ex. : faible tolérance au stress, valeurs peu alignées avec mon environnement, manque de clarté sur mes objectifs...",
  },
  SCOPE_REPORT_PERSONAL_NOTES_OBSTACLES: {
    id: "app.scope_report_personal_notes_obstacles",
    defaultMessage: "Ce qui peut me freiner",
  },
  SCOPE_REPORT_PERSONAL_NOTES_OBSTACLES_EXAMPLE: {
    id: "app.scope_report_personal_notes_obstacles_example",
    defaultMessage: "Quels sont mes principaux obstacles actuels ? Internes ou externes ?",
  },
  SCOPE_REPORT_PERSONAL_NOTES_MOTIVATION: {
    id: "app.scope_report_personal_notes_motivation",
    defaultMessage: "Ce qui me motive vraiment",
  },
  SCOPE_REPORT_PERSONAL_NOTES_MOTIVATION_EXAMPLE: {
    id: "app.scope_report_personal_notes_motivation_example",
    defaultMessage: "Qu’est-ce qui me donne de l’énergie ? Dans quelles situations je me sens pleinement engagé(e) ?",
  },

  SCOPE_REPORT_VALUEPREF_TITLE: {
    id: "app.scope_report_valuepref_title",
    defaultMessage: "Valeurs au travail",
  },
  SCOPE_REPORT_VALUEPREF_DESC: {
    id: "app.scope_report_valuepref_desc",
    defaultMessage: "Les valeurs professionnelles correspondent à ce qu’une personne recherche ou valorise dans son travail. Mieux connaître ces préférences permet de mieux orienter un collaborateur vers un poste, des missions ou des objectifs qui lui conviennent. Quand les attentes de la personne ne correspondent pas à la réalité de son poste, cela peut entraîner une baisse d’engagement, de motivation, voire des conflits ou des départs. C’est donc un levier clé pour bien positionner les talents et favoriser le développement individuel.",
  },

  // PLAISIR AU TRAVAIL
  SCOPE_REPORT_ENJOY_WORK: {
    id: "app.scope_report_valuepref_enjoywork",
    defaultMessage: "Plaisir au travail",
  },
  SCOPE_REPORT_ENJOY_WORK_DESC: {
    id: "app.scope_report_valuepref_enjoywork_desc",
    defaultMessage: "C’est le fait de prendre du plaisir dans ce qu’on fait, de se sentir bien dans ses missions, dans l’équipe et dans l’environnement de travail. Cela se manifeste souvent par de l’enthousiasme, de l’énergie positive, et une envie naturelle de s’impliquer.",
  },
  SCOPE_REPORT_ENJOY_WORK_MANAGER_DESC: {
  id: "app.scope_report_valuepref_enjoywork_manager_desc",
  defaultMessage: "un collaborateur motivé par le plaisir a besoin de stimulation, reconnaissance et d'une ambiance positive.",
},
SCOPE_REPORT_ENJOY_WORK_DESC_LOW: {
  id: "app.scope_report_valuepref_enjoywork_desc_low",
  defaultMessage: "Besoin de faire un travail utile, structuré, sans rechercher le fun ou l'ambiance. On s'engage avec sérieux, sans attendre une dimension ludique.",
},
SCOPE_REPORT_ENJOY_WORK_MANAGER_DESC_LOW: {
  id: "app.scope_report_valuepref_enjoywork_manager_desc_low",
  defaultMessage: "proposer des tâches concrètes, bien définies, et reconnaître l'efficacité.",
},
  SCOPE_REPORT_ENJOY_WORK_PERCENTILE_25_STRENGTHS_INTRO: { id: "app.scope_report_valuepref_enjoywork_25_strengths_intro", defaultMessage: "Ce que la personne apporte :" },
  SCOPE_REPORT_ENJOY_WORK_PERCENTILE_25_STRENGTHS_1: { id: "app.scope_report_valuepref_enjoywork_25_strengths_1", defaultMessage: "Très orienté·e sur les résultats, le devoir, ou la stabilité plutôt que sur l’émotion ou l’ambiance." },
  SCOPE_REPORT_ENJOY_WORK_PERCENTILE_25_STRENGTHS_2: { id: "app.scope_report_valuepref_enjoywork_25_strengths_2", defaultMessage: "Peut accepter des tâches peu motivantes tant qu’elles sont utiles ou nécessaires." },
  SCOPE_REPORT_ENJOY_WORK_PERCENTILE_25_STRENGTHS_3: { id: "app.scope_report_valuepref_enjoywork_25_strengths_3", defaultMessage: "Souvent perçu·e comme sérieux·se, fiable et persévérant·e." },

  SCOPE_REPORT_ENJOY_WORK_PERCENTILE_25_DEVELOPMENT_INTRO: { id: "app.scope_report_valuepref_enjoywork_25_development_intro", defaultMessage: "Ce que la personne apporte :" },
  SCOPE_REPORT_ENJOY_WORK_PERCENTILE_25_DEVELOPMENT_1: { id: "app.scope_report_valuepref_enjoywork_25_development_1", defaultMessage: "Gagner en équilibre en intégrant davantage le bien-être (le sien et celui des autres) dans la recherche d’efficacité." },
  SCOPE_REPORT_ENJOY_WORK_PERCENTILE_25_DEVELOPMENT_2: { id: "app.scope_report_valuepref_enjoywork_25_development_2", defaultMessage: "Cultiver son engagement même dans des missions qui font moins sens a priori, en identifiant les leviers de motivation." },
  SCOPE_REPORT_ENJOY_WORK_PERCENTILE_25_DEVELOPMENT_3: { id: "app.scope_report_valuepref_enjoywork_25_development_3", defaultMessage: "Développer une attention plus fine à la dynamique d’équipe et à la convivialité, pour renforcer la proximité et la cohésion." },

  SCOPE_REPORT_ENJOY_WORK_PERCENTILE_25_COLLABORATION: {
    id: "app.scope_report_valuepref_enjoywork_25_collaboration",
    defaultMessage: "Me confier des tâches claires, utiles et bien structurées.",
  },
  SCOPE_REPORT_ENJOY_WORK_PERCENTILE_25_MANAGEMENT: {
    id: "app.scope_report_valuepref_enjoywork_25_management",
    defaultMessage: "Donner des repères précis et valoriser la rigueur plutôt que la convivialité.",
  },
  SCOPE_REPORT_ENJOY_WORK_PERCENTILE_25_RECOGNITION: {
    id: "app.scope_report_valuepref_enjoywork_25_recognition",
    defaultMessage: "Montrer que ce que je fais est utile et contribue concrètement aux objectifs.",
  },
  SCOPE_REPORT_ENJOY_WORK_PERCENTILE_25_TEAM_ADVICE: {
    id: "app.scope_report_valuepref_enjoywork_25_team_advice",
    defaultMessage: "Conseil d’équipe : Veiller à reconnaître l’effort, introduire un peu de légèreté ou de motivation intrinsèque dans ses missions.",
  },
  SCOPE_REPORT_ENJOY_WORK_PERCENTILE_25_TEAM_KNOW: {
    id: "app.scope_report_valuepref_enjoywork_25_team_know",
    defaultMessage: "Je suis ici pour faire le job, pas forcément pour m’amuser — l’ambiance, c’est secondaire pour moi.",
  },
  SCOPE_REPORT_ENJOY_WORK_PERCENTILE_100_STRENGTHS_INTRO: { id: "app.scope_report_valuepref_enjoywork_100_strengths_intro", defaultMessage: "Ce que la personne apporte :" },
  SCOPE_REPORT_ENJOY_WORK_PERCENTILE_100_STRENGTHS_1: { id: "app.scope_report_valuepref_enjoywork_100_strengths_1", defaultMessage: "Moteur d’ambiance, créateur·rice de liens, souvent très engagé·e dans une dynamique de groupe." },
  SCOPE_REPORT_ENJOY_WORK_PERCENTILE_100_STRENGTHS_2: { id: "app.scope_report_valuepref_enjoywork_100_strengths_2", defaultMessage: "Capable d’enchanter les routines, de rendre les tâches plus vivantes." },
  SCOPE_REPORT_ENJOY_WORK_PERCENTILE_100_STRENGTHS_3: { id: "app.scope_report_valuepref_enjoywork_100_strengths_3", defaultMessage: "Peut contribuer à faire de l’équipe un véritable “lieu de vie” où il fait bon travailler." },

  SCOPE_REPORT_ENJOY_WORK_PERCENTILE_100_DEVELOPMENT_INTRO: { id: "app.scope_report_valuepref_enjoywork_100_development_intro", defaultMessage: "Ce que la personne apporte :" },
  SCOPE_REPORT_ENJOY_WORK_PERCENTILE_100_DEVELOPMENT_1: { id: "app.scope_report_valuepref_enjoywork_100_development_1", defaultMessage: "Gagner en aisance face aux tâches contraignantes ou techniques, en travaillant sur leur utilité ou en les abordant autrement." },
  SCOPE_REPORT_ENJOY_WORK_PERCENTILE_100_DEVELOPMENT_2: { id: "app.scope_report_valuepref_enjoywork_100_development_2", defaultMessage: "Trouver un meilleur équilibre entre la dimension sociale et les exigences de résultat." },
  SCOPE_REPORT_ENJOY_WORK_PERCENTILE_100_DEVELOPMENT_3: { id: "app.scope_report_valuepref_enjoywork_100_development_3", defaultMessage: "Travailler sa capacité à rester engagé·e même lorsque le plaisir immédiat s’estompe." },

  SCOPE_REPORT_ENJOY_WORK_PERCENTILE_100_COLLABORATION: {
    id: "app.scope_report_valuepref_enjoywork_100_collaboration",
    defaultMessage: "Créer un environnement vivant, fun et engageant, où je peux m’épanouir.",
  },
  SCOPE_REPORT_ENJOY_WORK_PERCENTILE_100_MANAGEMENT: {
    id: "app.scope_report_valuepref_enjoywork_100_management",
    defaultMessage: "Me laisser co-créer, m’exprimer librement, et encourager l’expérimentation.",
  },
  SCOPE_REPORT_ENJOY_WORK_PERCENTILE_100_RECOGNITION: {
    id: "app.scope_report_valuepref_enjoywork_100_recognition",
    defaultMessage: "Mettre en lumière l’énergie et la joie que j’apporte à l’équipe autant que mes résultats.",
  },
  SCOPE_REPORT_ENJOY_WORK_PERCENTILE_100_TEAM_ADVICE: {
    id: "app.scope_report_valuepref_enjoywork_100_team_advice",
    defaultMessage: "Conseil d’équipe : Offrir de la variété, solliciter sa créativité, mais poser un cadre clair sur les attentes de performance.",
  },
  SCOPE_REPORT_ENJOY_WORK_PERCENTILE_100_TEAM_KNOW: {
    id: "app.scope_report_valuepref_enjoywork_100_team_know",
    defaultMessage: "Si le plaisir disparaît, je décroche vite — j’ai besoin de rire, de lien et d’enthousiasme pour donner le meilleur.",
  },

  // LEADERSHIP
  SCOPE_REPORT_LEADERSHIP: {
    id: "app.scope_report_valuepref_leadership",
    defaultMessage: "Leadership",
  },
  SCOPE_REPORT_LEADERSHIP_DESC: {
    id: "app.scope_report_valuepref_leadership_desc",
    defaultMessage: "Le fait d’aimer guider, influencer et prendre des responsabilités. Ce type de personne cherche à faire avancer les choses et à mobiliser les autres.",
  },
  SCOPE_REPORT_LEADERSHIP_MANAGER_DESC: {
  id: "app.scope_report_valuepref_leadership_manager_desc",
  defaultMessage: "un collaborateur attiré par le leadership veut prendre le lead, être écouté, influent, reconnu.",
},
SCOPE_REPORT_LEADERSHIP_DESC_LOW: {
  id: "app.scope_report_valuepref_leadership_desc_low",
  defaultMessage: "Besoin de contribuer sans diriger. On préfère suivre, exécuter, et avancer dans un cadre clair, sans chercher à influencer.",
},
SCOPE_REPORT_LEADERSHIP_MANAGER_DESC_LOW: {
  id: "app.scope_report_valuepref_leadership_manager_desc_low",
  defaultMessage: "donner un rôle précis, sans attendre d'initiative d'encadrement.",
},
  SCOPE_REPORT_LEADERSHIP_PERCENTILE_25_STRENGTHS_INTRO: { id: "app.scope_report_valuepref_leadership_25_strengths_intro", defaultMessage: "Ce que la personne apporte :" },
  SCOPE_REPORT_LEADERSHIP_PERCENTILE_25_STRENGTHS_1: { id: "app.scope_report_valuepref_leadership_25_strengths_1", defaultMessage: "Préfère les rôles de soutien ou d’exécution plutôt que la direction." },
  SCOPE_REPORT_LEADERSHIP_PERCENTILE_25_STRENGTHS_2: { id: "app.scope_report_valuepref_leadership_25_strengths_2", defaultMessage: "Favorise le collectif, accepte d’être guidé·e, et fonctionne bien dans des rôles non exposés." },
  SCOPE_REPORT_LEADERSHIP_PERCENTILE_25_STRENGTHS_3: { id: "app.scope_report_valuepref_leadership_25_strengths_3", defaultMessage: "Apporte de la stabilité sans chercher à dominer." },

  SCOPE_REPORT_LEADERSHIP_PERCENTILE_25_DEVELOPMENT_INTRO: { id: "app.scope_report_valuepref_leadership_25_development_intro", defaultMessage: "Points de développement :" },
  SCOPE_REPORT_LEADERSHIP_PERCENTILE_25_DEVELOPMENT_1: { id: "app.scope_report_valuepref_leadership_25_development_1", defaultMessage: "Gagner en assurance face aux responsabilités et aux décisions difficiles, en les abordant comme des opportunités d’apprentissage." },
  SCOPE_REPORT_LEADERSHIP_PERCENTILE_25_DEVELOPMENT_2: { id: "app.scope_report_valuepref_leadership_25_development_2", defaultMessage: "Développer sa capacité à prendre des initiatives, notamment dans les situations nécessitant un leadership informel." },
  SCOPE_REPORT_LEADERSHIP_PERCENTILE_25_DEVELOPMENT_3: { id: "app.scope_report_valuepref_leadership_25_development_3", defaultMessage: "Affirmer davantage ses idées pour ne pas laisser les autres décider à sa place." },

  SCOPE_REPORT_LEADERSHIP_PERCENTILE_25_COLLABORATION: {
    id: "app.scope_report_valuepref_leadership_25_collaboration",
    defaultMessage: "Donne-moi un cadre clair et un rôle bien défini dans l’équipe.",
  },
  SCOPE_REPORT_LEADERSHIP_PERCENTILE_25_MANAGEMENT: {
    id: "app.scope_report_valuepref_leadership_25_management",
    defaultMessage: "Sois présent·e pour orienter, sans attendre que je prenne les devants.",
  },
  SCOPE_REPORT_LEADERSHIP_PERCENTILE_25_RECOGNITION: {
    id: "app.scope_report_valuepref_leadership_25_recognition",
    defaultMessage: "Souligne ma fiabilité et la qualité de ma contribution discrète.",
  },
  SCOPE_REPORT_LEADERSHIP_PERCENTILE_25_TEAM_ADVICE: {
    id: "app.scope_report_valuepref_leadership_25_team_advice",
    defaultMessage: "Conseil d’équipe : Encourager la prise d’initiative progressive, valoriser la contribution sans imposer de rôle de chef.",
  },
  SCOPE_REPORT_LEADERSHIP_PERCENTILE_25_TEAM_KNOW: {
    id: "app.scope_report_valuepref_leadership_25_team_know",
    defaultMessage: "Je préfère suivre ou contribuer plutôt que diriger — je suis plus à l’aise sans rôle de chef.",
  },
  SCOPE_REPORT_LEADERSHIP_PERCENTILE_100_STRENGTHS_INTRO: { id: "app.scope_report_valuepref_leadership_100_strengths_intro", defaultMessage: "Ce que la personne apporte :" },
  SCOPE_REPORT_LEADERSHIP_PERCENTILE_100_STRENGTHS_1: { id: "app.scope_report_valuepref_leadership_100_strengths_1", defaultMessage: "Leader naturel·le, souvent charismatique, cherche activement à influencer et orienter les autres." },
  SCOPE_REPORT_LEADERSHIP_PERCENTILE_100_STRENGTHS_2: { id: "app.scope_report_valuepref_leadership_100_strengths_2", defaultMessage: "Tire beaucoup de sens et d’énergie du fait de diriger." },
  SCOPE_REPORT_LEADERSHIP_PERCENTILE_100_STRENGTHS_3: { id: "app.scope_report_valuepref_leadership_100_strengths_3", defaultMessage: "Capable de prendre des décisions fortes et d’assumer les responsabilités majeures." },

  SCOPE_REPORT_LEADERSHIP_PERCENTILE_100_DEVELOPMENT_INTRO: { id: "app.scope_report_valuepref_intellectual_100_development_intro", defaultMessage: "Points de développement :" },
  SCOPE_REPORT_LEADERSHIP_PERCENTILE_100_DEVELOPMENT_1: { id: "app.scope_report_valuepref_leadership_100_development_1", defaultMessage: "Développer sa capacité à collaborer et à suivre avec engagement lorsqu’elle n’est pas en position de leader." },
  SCOPE_REPORT_LEADERSHIP_PERCENTILE_100_DEVELOPMENT_2: { id: "app.scope_report_valuepref_leadership_100_development_2", defaultMessage: "Apprendre à coexister de manière constructive avec d’autres personnes au leadership affirmé." },
  SCOPE_REPORT_LEADERSHIP_PERCENTILE_100_DEVELOPMENT_3: { id: "app.scope_report_valuepref_leadership_100_development_3", defaultMessage: "Cultiver une posture plus collaborative en intégrant davantage la concertation dans ses prises de position." },

  SCOPE_REPORT_LEADERSHIP_PERCENTILE_100_COLLABORATION: {
    id: "app.scope_report_valuepref_leadership_100_collaboration",
    defaultMessage: "Confie-moi un rôle de pilotage ou d’influence dans le projet.",
  },
  SCOPE_REPORT_LEADERSHIP_PERCENTILE_100_MANAGEMENT: {
    id: "app.scope_report_valuepref_leadership_100_management",
    defaultMessage: "Sois un·e partenaire stratégique, pas un·e superviseur·e classique.",
  },
  SCOPE_REPORT_LEADERSHIP_PERCENTILE_100_RECOGNITION: {
    id: "app.scope_report_valuepref_leadership_100_recognition",
    defaultMessage: "Valorise mon impact, ma capacité à fédérer et à faire avancer les choses.",
  },
  SCOPE_REPORT_LEADERSHIP_PERCENTILE_100_TEAM_ADVICE: {
    id: "app.scope_report_valuepref_leadership_100_team_advice",
    defaultMessage: "Conseil d’équipe : Clarifier les rôles, favoriser le co-leadership, encourager l’écoute et l’ouverture à la diversité des styles.",
  },
  SCOPE_REPORT_LEADERSHIP_PERCENTILE_100_TEAM_KNOW: {
    id: "app.scope_report_valuepref_leadership_100_team_know",
    defaultMessage: "Je suis un·e leader né·e — j’ai besoin d’avoir un rôle moteur dans ce qu’on fait, c’est là que je donne le meilleur.",
  },

  // SECURITE DE L’EMPLOI
  SCOPE_REPORT_JOB_SECURITY: {
    id: "app.scope_report_valuepref_security",
    defaultMessage: "Sécurité de l'emploi",
  },
  SCOPE_REPORT_JOB_SECURITY_DESC: {
    id: "app.scope_report_valuepref_security_desc",
    defaultMessage: "Besoin de stabilité, de prévisibilité et de cadre sécurisant pour s’engager pleinement.",
  },
  SCOPE_REPORT_JOB_SECURITY_MANAGER_DESC: {
  id: "app.scope_report_valuepref_security_manager_desc",
  defaultMessage: "un profil motivé par la sécurité aura besoin d'un cadre clair, d'un poste stable, de règles bien définies.",
},
SCOPE_REPORT_JOB_SECURITY_DESC_LOW: {
  id: "app.scope_report_valuepref_security_desc_low",
  defaultMessage: "Besoin de liberté plutôt que de stabilité. On est à l'aise dans l'incertitude, les environnements mouvants, les projets à durée variable.",
},
SCOPE_REPORT_JOB_SECURITY_MANAGER_DESC_LOW: {
  id: "app.scope_report_valuepref_security_manager_desc_low",
  defaultMessage: "offrir de la souplesse, éviter les cadres trop figés.",
},
  SCOPE_REPORT_JOB_SECURITY_PERCENTILE_25_STRENGTHS_INTRO: { id: "app.scope_report_valuepref_security_25_strengths_intro", defaultMessage: "Ce que la personne apporte :" },
  SCOPE_REPORT_JOB_SECURITY_PERCENTILE_25_STRENGTHS_1: { id: "app.scope_report_valuepref_security_25_strengths_1", defaultMessage: "Ouvert·e au changement, au risque, aux défis." },
  SCOPE_REPORT_JOB_SECURITY_PERCENTILE_25_STRENGTHS_2: { id: "app.scope_report_valuepref_security_25_strengths_2", defaultMessage: "À l’aise dans des environnements instables ou en évolution rapide." },
  SCOPE_REPORT_JOB_SECURITY_PERCENTILE_25_STRENGTHS_3: { id: "app.scope_report_valuepref_security_25_strengths_3", defaultMessage: "Apprécie la liberté, l’aventure professionnelle." },

  SCOPE_REPORT_JOB_SECURITY_PERCENTILE_25_DEVELOPMENT_INTRO: { id: "app.scope_report_valuepref_security_25_development_intro", defaultMessage: "Ce que la personne apporte :" },
  SCOPE_REPORT_JOB_SECURITY_PERCENTILE_25_DEVELOPMENT_1: { id: "app.scope_report_valuepref_security_25_development_1", defaultMessage: "Cultiver une meilleure évaluation des risques et des impacts avant de changer de cap." },
  SCOPE_REPORT_JOB_SECURITY_PERCENTILE_25_DEVELOPMENT_2: { id: "app.scope_report_valuepref_security_25_development_2", defaultMessage: "S’inscrire davantage dans la continuité pour rassurer et stabiliser l’équipe." },
  SCOPE_REPORT_JOB_SECURITY_PERCENTILE_25_DEVELOPMENT_3: { id: "app.scope_report_valuepref_security_25_development_3", defaultMessage: "Travailler sa constance pour renforcer sa fiabilité et son ancrage dans les projets." },

  SCOPE_REPORT_JOB_SECURITY_PERCENTILE_25_COLLABORATION: {
    id: "app.scope_report_valuepref_security_25_collaboration",
    defaultMessage: "Laissez-moi expérimenter sans contraintes durables.",
  },
  SCOPE_REPORT_JOB_SECURITY_PERCENTILE_25_MANAGEMENT: {
    id: "app.scope_report_valuepref_security_25_management",
    defaultMessage: "Proposez un cadre souple, évolutif, non verrouillé.",
  },
  SCOPE_REPORT_JOB_SECURITY_PERCENTILE_25_RECOGNITION: {
    id: "app.scope_report_valuepref_security_25_recognition",
    defaultMessage: "Valorisez mon autonomie et ma capacité à aller vers l’inconnu.",
  },
  SCOPE_REPORT_JOB_SECURITY_PERCENTILE_25_TEAM_ADVICE: {
    id: "app.scope_report_valuepref_security_25_team_advice",
    defaultMessage: "Conseil d’équipe : Laisser une marge de liberté, et proposer des missions exploratoires.",
  },
  SCOPE_REPORT_JOB_SECURITY_PERCENTILE_25_TEAM_KNOW: {
    id: "app.scope_report_valuepref_security_25_team_know",
    defaultMessage: "J’aime bouger et je ne suis pas forcément là pour longtemps, mais je m’investis à fond pendant que j’y suis.",
  },
  SCOPE_REPORT_JOB_SECURITY_PERCENTILE_100_STRENGTHS_INTRO: { id: "app.scope_report_valuepref_security_100_strengths_intro", defaultMessage: "Ce que la personne apporte :" },
  SCOPE_REPORT_JOB_SECURITY_PERCENTILE_100_STRENGTHS_1: { id: "app.scope_report_valuepref_security_100_strengths_1", defaultMessage: "Extrêmement fiable, cherche la pérennité et contribue à la stabilité du groupe." },
  SCOPE_REPORT_JOB_SECURITY_PERCENTILE_100_STRENGTHS_2: { id: "app.scope_report_valuepref_security_100_strengths_2", defaultMessage: "Renforce la solidité d’équipe, évite les décisions précipitées." },
  SCOPE_REPORT_JOB_SECURITY_PERCENTILE_100_STRENGTHS_3: { id: "app.scope_report_valuepref_security_100_strengths_3", defaultMessage: "Excellent·e dans des structures long terme ou très encadrées." },

  SCOPE_REPORT_JOB_SECURITY_PERCENTILE_100_DEVELOPMENT_INTRO: { id: "app.scope_report_valuepref_security_100_development_intro", defaultMessage: "Ce que la personne apporte :" },
  SCOPE_REPORT_JOB_SECURITY_PERCENTILE_100_DEVELOPMENT_1: { id: "app.scope_report_valuepref_security_100_development_1", defaultMessage: "Apprendre à considérer les opportunités même lorsqu’elles comportent une part d’incertitude." },
  SCOPE_REPORT_JOB_SECURITY_PERCENTILE_100_DEVELOPMENT_2: { id: "app.scope_report_valuepref_security_100_development_2", defaultMessage: "Développer une plus grande souplesse face au changement, y compris lorsqu’il est porteur." },
  SCOPE_REPORT_JOB_SECURITY_PERCENTILE_100_DEVELOPMENT_3: { id: "app.scope_report_valuepref_security_100_development_3", defaultMessage: "Cultiver la confiance nécessaire pour sortir de situations insatisfaisantes malgré l’inconnu." },

  SCOPE_REPORT_JOB_SECURITY_PERCENTILE_100_COLLABORATION: {
    id: "app.scope_report_valuepref_security_100_collaboration",
    defaultMessage: "Sécurisez mon environnement et mes responsabilités.",
  },
  SCOPE_REPORT_JOB_SECURITY_PERCENTILE_100_MANAGEMENT: {
    id: "app.scope_report_valuepref_security_100_management",
    defaultMessage: "Garantissez la stabilité et évitez les changements brusques.",
  },
  SCOPE_REPORT_JOB_SECURITY_PERCENTILE_100_RECOGNITION: {
    id: "app.scope_report_valuepref_security_100_recognition",
    defaultMessage: "Rassurez-moi sur mon avenir et exprimez votre confiance durable.",
  },
  SCOPE_REPORT_JOB_SECURITY_PERCENTILE_100_TEAM_ADVICE: {
    id: "app.scope_report_valuepref_security_100_team_advice",
    defaultMessage: "Conseil d’équipe : Réassurer régulièrement, formaliser les engagements et les garanties.",
  },
  SCOPE_REPORT_JOB_SECURITY_PERCENTILE_100_TEAM_KNOW: {
    id: "app.scope_report_valuepref_security_100_team_know",
    defaultMessage: "J’ai besoin de sentir que mon poste est solide et que je peux me projeter, sinon je perds pied.",
  },

  // STIMULATION INTELLECTUELLE
  SCOPE_REPORT_INTELLECTUAL_STIMULATION: {
    id: "app.scope_report_valuepref_intellectual",
    defaultMessage: "Stimulation intellectuelle",
  },
  SCOPE_REPORT_INTELLECTUAL_STIMULATION_DESC: {
    id: "app.scope_report_valuepref_intellectual_desc",
    defaultMessage: "Besoin de réflexion, d’apprentissage, de complexité et de nouveauté mentale.",
  },
  SCOPE_REPORT_INTELLECTUAL_STIMULATION_MANAGER_DESC: {
  id: "app.scope_report_valuepref_intellectual_manager_desc",
  defaultMessage: "une personne motivée par la stimulation intellectuelle attend des problèmes à résoudre, de l'autonomie cognitive, de la nouveauté.",
},
SCOPE_REPORT_INTELLECTUAL_STIMULATION_DESC_LOW: {
  id: "app.scope_report_valuepref_intellectual_desc_low",
  defaultMessage: "Besoin de concret, pas de réflexion abstraite. On privilégie l'efficacité, les tâches simples et claires, sans besoin d'analyse poussée.",
},
SCOPE_REPORT_INTELLECTUAL_STIMULATION_MANAGER_DESC_LOW: {
  id: "app.scope_report_valuepref_intellectual_manager_desc_low",
  defaultMessage: "aller droit au but, éviter les discours complexes.",
},
  SCOPE_REPORT_INTELLECTUAL_STIMULATION_PERCENTILE_25_STRENGTHS_INTRO: { id: "app.scope_report_valuepref_intellectual_25_strengths_intro", defaultMessage: "Ce que la personne apporte :" },
  SCOPE_REPORT_INTELLECTUAL_STIMULATION_PERCENTILE_25_STRENGTHS_1: { id: "app.scope_report_valuepref_intellectual_25_strengths_1", defaultMessage: "Pratique, efficace, orienté·e résultat sans chercher la complexité." },
  SCOPE_REPORT_INTELLECTUAL_STIMULATION_PERCENTILE_25_STRENGTHS_2: { id: "app.scope_report_valuepref_intellectual_25_strengths_2", defaultMessage: "À l’aise avec des tâches simples, concrètes ou répétitives." },
  SCOPE_REPORT_INTELLECTUAL_STIMULATION_PERCENTILE_25_STRENGTHS_3: { id: "app.scope_report_valuepref_intellectual_25_strengths_3", defaultMessage: "Fait avancer les projets sans “intellectualiser”." },

  SCOPE_REPORT_INTELLECTUAL_STIMULATION_PERCENTILE_25_DEVELOPMENT_INTRO: { id: "app.scope_report_valuepref_intellectual_25_development_intro", defaultMessage: "Points de développement :" },
  SCOPE_REPORT_INTELLECTUAL_STIMULATION_PERCENTILE_25_DEVELOPMENT_1: { id: "app.scope_report_valuepref_intellectual_25_development_1", defaultMessage: "Travailler son appétence pour les environnements analytiques en y trouvant des leviers d’intérêt ou de progression." },
  SCOPE_REPORT_INTELLECTUAL_STIMULATION_PERCENTILE_25_DEVELOPMENT_2: { id: "app.scope_report_valuepref_intellectual_25_development_2", defaultMessage: "Gagner en aisance dans les fonctions mobilisant innovation, recherche ou vision stratégique." },

  SCOPE_REPORT_INTELLECTUAL_STIMULATION_PERCENTILE_25_COLLABORATION: {
    id: "app.scope_report_valuepref_intellectual_25_collaboration",
    defaultMessage: "Proposez-moi des tâches concrètes et bien définies.",
  },
  SCOPE_REPORT_INTELLECTUAL_STIMULATION_PERCENTILE_25_MANAGEMENT: {
    id: "app.scope_report_valuepref_intellectual_25_management",
    defaultMessage: "Évitez les missions trop abstraites ou théoriques.",
  },
  SCOPE_REPORT_INTELLECTUAL_STIMULATION_PERCENTILE_25_RECOGNITION: {
    id: "app.scope_report_valuepref_intellectual_25_recognition",
    defaultMessage: "Soulignez ma rigueur et mon efficacité dans l’action.",
  },
  SCOPE_REPORT_INTELLECTUAL_STIMULATION_PERCENTILE_25_TEAM_ADVICE: {
    id: "app.scope_report_valuepref_intellectual_25_team_advice",
    defaultMessage: "Conseil d’équipe : Éviter la surcharge conceptuelle, valoriser les tâches concrètes.",
  },
  SCOPE_REPORT_INTELLECTUAL_STIMULATION_PERCENTILE_25_TEAM_KNOW: {
    id: "app.scope_report_valuepref_intellectual_25_team_know",
    defaultMessage: "Je préfère l’action au « bla-bla », donc allez droit au but avec moi.",
  },
  SCOPE_REPORT_INTELLECTUAL_STIMULATION_PERCENTILE_100_STRENGTHS_INTRO: { id: "app.scope_report_valuepref_intellectual_100_strengths_intro", defaultMessage: "Ce que la personne apporte :" },
  SCOPE_REPORT_INTELLECTUAL_STIMULATION_PERCENTILE_100_STRENGTHS_1: { id: "app.scope_report_valuepref_intellectual_100_strengths_1", defaultMessage: "Très curieux·se, pense vite et en profondeur." },
  SCOPE_REPORT_INTELLECTUAL_STIMULATION_PERCENTILE_100_STRENGTHS_2: { id: "app.scope_report_valuepref_intellectual_100_strengths_2", defaultMessage: "Apporte innovation, idées, angles nouveaux." },
  SCOPE_REPORT_INTELLECTUAL_STIMULATION_PERCENTILE_100_STRENGTHS_3: { id: "app.scope_report_valuepref_intellectual_100_strengths_3", defaultMessage: "Peut exceller en stratégie, conseil, recherche ou design." },

  SCOPE_REPORT_INTELLECTUAL_STIMULATION_PERCENTILE_100_DEVELOPMENT_INTRO: { id: "app.scope_report_valuepref_intellectual_100_development_intro", defaultMessage: "Ce que la personne apporte :" },
  SCOPE_REPORT_INTELLECTUAL_STIMULATION_PERCENTILE_100_DEVELOPMENT_1: { id: "app.scope_report_valuepref_intellectual_100_development_1", defaultMessage: "Cultiver son engagement même dans des contextes moins stimulants, en identifiant des leviers d’intérêt." },
  SCOPE_REPORT_INTELLECTUAL_STIMULATION_PERCENTILE_100_DEVELOPMENT_2: { id: "app.scope_report_valuepref_intellectual_100_development_2", defaultMessage: "Adapter sa posture et son discours pour mieux connecter avec des interlocuteurs orientés terrain." },

  SCOPE_REPORT_INTELLECTUAL_STIMULATION_PERCENTILE_100_COLLABORATION: {
    id: "app.scope_report_valuepref_intellectual_100_collaboration",
    defaultMessage: "Nourrissez ma curiosité intellectuelle au quotidien.",
  },
  SCOPE_REPORT_INTELLECTUAL_STIMULATION_PERCENTILE_100_MANAGEMENT: {
    id: "app.scope_report_valuepref_intellectual_100_management",
    defaultMessage: "Offrez-moi un espace de réflexion libre et soutenant.",
  },
  SCOPE_REPORT_INTELLECTUAL_STIMULATION_PERCENTILE_100_RECOGNITION: {
    id: "app.scope_report_valuepref_intellectual_100_recognition",
    defaultMessage: "Valorisez mes capacités de synthèse, ma vision et mon intelligence critique.",
  },
  SCOPE_REPORT_INTELLECTUAL_STIMULATION_PERCENTILE_100_TEAM_ADVICE: {
    id: "app.scope_report_valuepref_intellectual_100_team_advice",
    defaultMessage: "Conseil d’équipe : Offrir un terrain d’exploration intellectuelle constant, tout en veillant à l’aboutissement.",
  },
  SCOPE_REPORT_INTELLECTUAL_STIMULATION_PERCENTILE_100_TEAM_KNOW: {
    id: "app.scope_report_valuepref_intellectual_100_team_know",
    defaultMessage: "J’ai besoin de stimulation intellectuelle permanente, sinon je décroche vite.",
  },

  // SALAIRE
  SCOPE_REPORT_SALARY: {
    id: "app.scope_report_valuepref_salary",
    defaultMessage: "Salaire",
  },
  SCOPE_REPORT_SALARY_DESC: {
    id: "app.scope_report_valuepref_salary_desc",
    defaultMessage: "La motivation financière est centrale. Importance accordée à la rémunération, aux avantages matériels.",
  },
  SCOPE_REPORT_SALARY_MANAGER_DESC: {
  id: "app.scope_report_valuepref_salary_manager_desc",
  defaultMessage: "un profil motivé par le salaire sera très sensible aux primes, augmentations, bonus, reconnaissance tangible.",
},
SCOPE_REPORT_SALARY_DESC_LOW: {
  id: "app.scope_report_valuepref_salary_desc_low",
  defaultMessage: "Besoin de sens plus que d'argent. On s'engage pour la mission, l'impact ou l'ambiance, pas pour les primes.",
},
SCOPE_REPORT_SALARY_MANAGER_DESC_LOW: {
  id: "app.scope_report_valuepref_salary_manager_desc_low",
  defaultMessage: "valoriser l'utilité du travail, sans miser sur la rémunération.",
},
  SCOPE_REPORT_SALARY_PERCENTILE_25_STRENGTHS_INTRO: { id: "app.scope_report_valuepref_salary_25_strengths_intro", defaultMessage: "Ce que la personne apporte :" },
  SCOPE_REPORT_SALARY_PERCENTILE_25_STRENGTHS_1: { id: "app.scope_report_valuepref_salary_25_strengths_1", defaultMessage: "Motivé·e par autre chose que l’argent (mission, ambiance, impact…)." },
  SCOPE_REPORT_SALARY_PERCENTILE_25_STRENGTHS_2: { id: "app.scope_report_valuepref_salary_25_strengths_2", defaultMessage: "Peu sensible aux primes ou avantages." },
  SCOPE_REPORT_SALARY_PERCENTILE_25_STRENGTHS_3: { id: "app.scope_report_valuepref_salary_25_strengths_3", defaultMessage: "Idéal dans les structures à budget limité." },

  SCOPE_REPORT_SALARY_PERCENTILE_25_DEVELOPMENT_INTRO: { id: "app.scope_report_valuepref_salary_25_development_intro", defaultMessage: "Ce que la personne apporte :" },
  SCOPE_REPORT_SALARY_PERCENTILE_25_DEVELOPMENT_1: { id: "app.scope_report_valuepref_salary_25_development_1", defaultMessage: "Apprendre à mieux prendre en compte ses propres intérêts et à négocier ses conditions lorsque c’est nécessaire." },
  SCOPE_REPORT_SALARY_PERCENTILE_25_DEVELOPMENT_2: { id: "app.scope_report_valuepref_salary_25_development_2", defaultMessage: "Cultiver une posture plus affirmée dans les environnements compétitifs, sans renier ses valeurs." },

  SCOPE_REPORT_SALARY_PERCENTILE_25_COLLABORATION: {
    id: "app.scope_report_valuepref_salary_25_collaboration",
    defaultMessage: "Parlez-moi d’impact et de mission plus que d’argent.",
  },
  SCOPE_REPORT_SALARY_PERCENTILE_25_MANAGEMENT: {
    id: "app.scope_report_valuepref_salary_25_management",
    defaultMessage: "Donnez du sens à mes tâches sans insister sur la rémunération.",
  },
  SCOPE_REPORT_SALARY_PERCENTILE_25_RECOGNITION: {
    id: "app.scope_report_valuepref_salary_25_recognition",
    defaultMessage: "Soulignez mon engagement désintéressé.",
  },
  SCOPE_REPORT_SALARY_PERCENTILE_25_TEAM_ADVICE: {
    id: "app.scope_report_valuepref_salary_25_team_advice",
    defaultMessage: "Conseil d’équipe : Reconnaître autrement que par l’argent (valeurs, sens, autonomie).",
  },
  SCOPE_REPORT_SALARY_PERCENTILE_25_TEAM_KNOW: {
    id: "app.scope_report_valuepref_salary_25_team_know",
    defaultMessage: "L’argent ne me motive pas vraiment, je suis là pour d’autres raisons.",
  },
  SCOPE_REPORT_SALARY_PERCENTILE_50_TITLE: {
  id: "app.scope_report_valuepref_salary_50_title",
  defaultMessage: "50e percentil (valeur modérée du salaire)",
},
SCOPE_REPORT_SALARY_PERCENTILE_50_STRENGTHS_1: {
  id: "app.scope_report_valuepref_salary_50_strengths_1",
  defaultMessage: "Recherche un équilibre : veut être payé·e correctement mais pas à tout prix.",
},
SCOPE_REPORT_SALARY_PERCENTILE_50_STRENGTHS_2: {
  id: "app.scope_report_valuepref_salary_50_strengths_2",
  defaultMessage: "Peut arbitrer entre mission, ambiance et rémunération.",
},
SCOPE_REPORT_SALARY_PERCENTILE_50_STRENGTHS_3: {
  id: "app.scope_report_valuepref_salary_50_strengths_3",
  defaultMessage: "Bonne capacité d'adaptation salariale selon les projets.",
},
SCOPE_REPORT_SALARY_PERCENTILE_50_DEVELOPMENT_INTRO: {
  id: "app.scope_report_valuepref_salary_50_development_intro",
  defaultMessage: "Points de développement :",
},
SCOPE_REPORT_SALARY_PERCENTILE_50_DEVELOPMENT_1: {
  id: "app.scope_report_valuepref_salary_50_development_1",
  defaultMessage: "Travailler son rapport à l'argent pour prendre des décisions plus équilibrées entre passion et reconnaissance financière.",
},
SCOPE_REPORT_SALARY_PERCENTILE_50_COLLABORATION: {
  id: "app.scope_report_valuepref_salary_50_collaboration",
  defaultMessage: "Proposez un équilibre juste entre contribution et rémunération.",
},
SCOPE_REPORT_SALARY_PERCENTILE_50_MANAGEMENT: {
  id: "app.scope_report_valuepref_salary_50_management",
  defaultMessage: "Soyez transparent·e sur les critères d'évolution.",
},
SCOPE_REPORT_SALARY_PERCENTILE_50_RECOGNITION: {
  id: "app.scope_report_valuepref_salary_50_recognition",
  defaultMessage: "Mettez en avant à la fois mes résultats et ma valeur ajoutée.",
},
SCOPE_REPORT_SALARY_PERCENTILE_50_TEAM_ADVICE: {
  id: "app.scope_report_valuepref_salary_50_team_advice",
  defaultMessage: "Offrir un package correct et parler aussi du sens du travail. Être clair·e sur l'évolution possible.",
},
SCOPE_REPORT_SALARY_PERCENTILE_50_TEAM_KNOW: {
  id: "app.scope_report_valuepref_salary_50_team_know",
  defaultMessage: "J'apprécie d'être payé·e à ma juste valeur, mais ce n'est pas mon moteur principal.",
},

SCOPE_REPORT_SALARY_PERCENTILE_75_TITLE: {
  id: "app.scope_report_valuepref_salary_75_title",
  defaultMessage: "75e percentil (forte valeur du salaire)",
},
SCOPE_REPORT_SALARY_PERCENTILE_75_STRENGTHS_1: {
  id: "app.scope_report_valuepref_salary_75_strengths_1",
  defaultMessage: "Très conscient·e de sa valeur et de sa contribution.",
},
SCOPE_REPORT_SALARY_PERCENTILE_75_STRENGTHS_2: {
  id: "app.scope_report_valuepref_salary_75_strengths_2",
  defaultMessage: "Aime les environnements où la performance est reconnue financièrement.",
},
SCOPE_REPORT_SALARY_PERCENTILE_75_STRENGTHS_3: {
  id: "app.scope_report_valuepref_salary_75_strengths_3",
  defaultMessage: "Peut être moteur de négociation ou de stratégie de rémunération.",
},
SCOPE_REPORT_SALARY_PERCENTILE_75_DEVELOPMENT_INTRO: {
  id: "app.scope_report_valuepref_salary_75_development_intro",
  defaultMessage: "Points de développement :",
},
SCOPE_REPORT_SALARY_PERCENTILE_75_DEVELOPMENT_1: {
  id: "app.scope_report_valuepref_salary_75_development_1",
  defaultMessage: "Apprendre à mieux gérer la frustration lorsque la reconnaissance financière ne suit pas immédiatement.",
},
SCOPE_REPORT_SALARY_PERCENTILE_75_DEVELOPMENT_2: {
  id: "app.scope_report_valuepref_salary_75_development_2",
  defaultMessage: "Développer une posture plus détachée face aux comparaisons, pour rester centré·e sur son propre parcours.",
},
SCOPE_REPORT_SALARY_PERCENTILE_75_COLLABORATION: {
  id: "app.scope_report_valuepref_salary_75_collaboration",
  defaultMessage: "Offrez une reconnaissance financière visible et proportionnée.",
},
SCOPE_REPORT_SALARY_PERCENTILE_75_MANAGEMENT: {
  id: "app.scope_report_valuepref_salary_75_management",
  defaultMessage: "Donnez des repères clairs sur les attentes et les récompenses.",
},
SCOPE_REPORT_SALARY_PERCENTILE_75_RECOGNITION: {
  id: "app.scope_report_valuepref_salary_75_recognition",
  defaultMessage: "Récompensez ma performance de façon concrète.",
},
SCOPE_REPORT_SALARY_PERCENTILE_75_TEAM_ADVICE: {
  id: "app.scope_report_valuepref_salary_75_team_advice",
  defaultMessage: "Offrir une reconnaissance financière juste et visible.",
},
SCOPE_REPORT_SALARY_PERCENTILE_75_TEAM_KNOW: {
  id: "app.scope_report_valuepref_salary_75_team_know",
  defaultMessage: "J'attends une reconnaissance claire de mes efforts, y compris sur le plan financier.",
},
  SCOPE_REPORT_SALARY_PERCENTILE_100_STRENGTHS_INTRO: { id: "app.scope_report_valuepref_salary_100_strengths_intro", defaultMessage: "Ce que la personne apporte :" },
  SCOPE_REPORT_SALARY_PERCENTILE_100_STRENGTHS_1: { id: "app.scope_report_valuepref_salary_100_strengths_1", defaultMessage: "Très motivé·e par la performance, les résultats, la reconnaissance matérielle." },
  SCOPE_REPORT_SALARY_PERCENTILE_100_STRENGTHS_2: { id: "app.scope_report_valuepref_salary_100_strengths_2", defaultMessage: "Fait preuve d’ambition, peut être très compétitif·ve." },
  SCOPE_REPORT_SALARY_PERCENTILE_100_STRENGTHS_3: { id: "app.scope_report_valuepref_salary_100_strengths_3", defaultMessage: "Aime les postes à responsabilité avec fortes contreparties." },

  SCOPE_REPORT_SALARY_PERCENTILE_100_DEVELOPMENT_INTRO: { id: "app.scope_report_valuepref_salary_100_development_intro", defaultMessage: "Ce que la personne apporte :" },
  SCOPE_REPORT_SALARY_PERCENTILE_100_DEVELOPMENT_1: { id: "app.scope_report_valuepref_salary_100_development_1", defaultMessage: "Travailler sa capacité à rester engagé·e même lorsque la rémunération n’est pas immédiatement à la hauteur des attentes." },
  SCOPE_REPORT_SALARY_PERCENTILE_100_DEVELOPMENT_2: { id: "app.scope_report_valuepref_salary_100_development_2", defaultMessage: "Trouver un équilibre plus durable entre motivation financière, sens du travail et dynamique collective." },

  SCOPE_REPORT_SALARY_PERCENTILE_100_COLLABORATION: {
    id: "app.scope_report_valuepref_salary_100_collaboration",
    defaultMessage: "Montrez que mon engagement est valorisé financièrement.",
  },
  SCOPE_REPORT_SALARY_PERCENTILE_100_MANAGEMENT: {
    id: "app.scope_report_valuepref_salary_100_management",
    defaultMessage: "Soyez exigeant·e mais juste, avec une reconnaissance tangible.",
  },
  SCOPE_REPORT_SALARY_PERCENTILE_100_RECOGNITION: {
    id: "app.scope_report_valuepref_salary_100_recognition",
    defaultMessage: "Augmentation, prime ou promotion claire et méritée.",
  },
  SCOPE_REPORT_SALARY_PERCENTILE_100_TEAM_ADVICE: {
    id: "app.scope_report_valuepref_salary_100_team_advice",
    defaultMessage: "Conseil d’équipe : Encadrer les attentes avec des règles claires, offrir des perspectives de progression motivantes.",
  },
  SCOPE_REPORT_SALARY_PERCENTILE_100_TEAM_KNOW: {
    id: "app.scope_report_valuepref_salary_100_team_know",
    defaultMessage: "Je me donne à fond, mais j’ai besoin que ça se voie aussi sur ma fiche de paie.",
  },

  // TACHES VARIEES
  SCOPE_REPORT_TASK_VARIABILITY: {
    id: "app.scope_report_valuepref_variety",
    defaultMessage: "Tâches variées",
  },
  SCOPE_REPORT_TASK_VARIABILITY_DESC: {
    id: "app.scope_report_valuepref_variety_desc",
    defaultMessage: "Besoin de changement, diversité, missions multiples, et de renouvellement régulier pour rester engagé·e.",
  },
  SCOPE_REPORT_TASK_VARIABILITY_MANAGER_DESC: {
  id: "app.scope_report_valuepref_variety_manager_desc",
  defaultMessage: "un profil motivé par la variété sera plus engagé dans les environnements dynamiques, multi-projets ou transverses.",
},
SCOPE_REPORT_TASK_VARIABILITY_DESC_LOW: {
  id: "app.scope_report_valuepref_variety_desc_low",
  defaultMessage: "Besoin de stabilité et de routine. On fonctionne bien dans un environnement prévisible, avec des missions récurrentes.",
},
SCOPE_REPORT_TASK_VARIABILITY_MANAGER_DESC_LOW: {
  id: "app.scope_report_valuepref_variety_manager_desc_low",
  defaultMessage: "structurer les tâches, limiter les changements fréquents.",
},
  SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_25_STRENGTHS_INTRO: { id: "app.scope_report_valuepref_variety_25_strengths_intro", defaultMessage: "Ce que la personne apporte :" },
  SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_25_STRENGTHS_1: { id: "app.scope_report_valuepref_variety_25_strengths_1", defaultMessage: "Apprécie les missions stables, routinières, avec des repères fixes." },
  SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_25_STRENGTHS_2: { id: "app.scope_report_valuepref_variety_25_strengths_2", defaultMessage: "À l’aise dans la répétition, ce qui garantit régularité et maîtrise." },
  SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_25_STRENGTHS_3: { id: "app.scope_report_valuepref_variety_25_strengths_3", defaultMessage: "Idéal pour les postes opérationnels avec peu de changement." },

  SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_25_DEVELOPMENT_INTRO: { id: "app.scope_report_valuepref_variety_25_development_intro", defaultMessage: "Ce que la personne apporte :" },
  SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_25_DEVELOPMENT_1: { id: "app.scope_report_valuepref_variety_25_development_1", defaultMessage: "Développer sa capacité d’adaptation face aux changements fréquents, pour éviter l’ennui ou la surcharge." },
  SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_25_DEVELOPMENT_2: { id: "app.scope_report_valuepref_variety_25_development_2", defaultMessage: "Gagner en confort dans les environnements mouvants en travaillant sa flexibilité et sa tolérance à l’imprévu." },

  SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_25_COLLABORATION: {
    id: "app.scope_report_valuepref_variety_25_collaboration",
    defaultMessage: "Donnez-moi une routine claire avec peu de surprises.",
  },
  SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_25_MANAGEMENT: {
    id: "app.scope_report_valuepref_variety_25_management",
    defaultMessage: "Organisez les missions de manière régulière et prévisible.",
  },
  SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_25_RECOGNITION: {
    id: "app.scope_report_valuepref_variety_25_recognition",
    defaultMessage: "Soulignez ma constance et ma fiabilité.",
  },
  SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_25_TEAM_ADVICE: {
    id: "app.scope_report_valuepref_variety_25_team_advice",
    defaultMessage: "Conseil d’équipe : Stabiliser les routines et maintenir des repères clairs.",
  },
  SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_25_TEAM_KNOW: {
    id: "app.scope_report_valuepref_variety_25_team_know",
    defaultMessage: "J’aime quand les choses sont claires, prévisibles et bien structurées.",
  },
  SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_50_TITLE: {
  id: "app.scope_report_valuepref_variety_50_title",
  defaultMessage: "50e percentil (valeur modérée des tâches variées)",
},
SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_50_STRENGTHS_INTRO: { 
  id: "app.scope_report_valuepref_variety_50_strengths_intro", 
  defaultMessage: "Ce que la personne apporte :" 
},
SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_50_STRENGTHS_1: { 
  id: "app.scope_report_valuepref_variety_50_strengths_1", 
  defaultMessage: "Aime avoir un peu de variété, tout en gardant une base stable." 
},
SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_50_STRENGTHS_2: { 
  id: "app.scope_report_valuepref_variety_50_strengths_2", 
  defaultMessage: "Bonne adaptation à des postes \"mi-projets / mi-routine\"." 
},
SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_50_STRENGTHS_3: { 
  id: "app.scope_report_valuepref_variety_50_strengths_3", 
  defaultMessage: "Capable de s'ennuyer dans un poste trop figé mais pas adepte du chaos non plus." 
},
SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_50_DEVELOPMENT_INTRO: { 
  id: "app.scope_report_valuepref_variety_50_development_intro", 
  defaultMessage: "Points de développement :" 
},
SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_50_DEVELOPMENT_1: { 
  id: "app.scope_report_valuepref_variety_50_development_1", 
  defaultMessage: "Cultiver des sources de renouvellement et de stimulation pour maintenir son énergie à moyen terme, même en l'absence de nouveauté immédiate." 
},
SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_50_COLLABORATION: {
  id: "app.scope_report_valuepref_variety_50_collaboration",
  defaultMessage: "Variez modérément les tâches pour maintenir mon attention.",
},
SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_50_MANAGEMENT: {
  id: "app.scope_report_valuepref_variety_50_management",
  defaultMessage: "Combinez stabilité et quelques projets ponctuels.",
},
SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_50_RECOGNITION: {
  id: "app.scope_report_valuepref_variety_50_recognition",
  defaultMessage: "Valorisez ma polyvalence équilibrée.",
},
SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_50_TEAM_ADVICE: {
  id: "app.scope_report_valuepref_variety_50_team_advice",
  defaultMessage: "Introduire des changements progressifs dans les missions.",
},
SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_50_TEAM_KNOW: {
  id: "app.scope_report_valuepref_variety_50_team_know",
  defaultMessage: "J'aime un peu de nouveauté, mais j'ai besoin d'un cadre stable pour bien avancer.",
},

SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_75_TITLE: {
  id: "app.scope_report_valuepref_variety_75_title",
  defaultMessage: "75e percentil (forte valeur des tâches variées)",
},
SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_75_STRENGTHS_INTRO: { 
  id: "app.scope_report_valuepref_variety_75_strengths_intro", 
  defaultMessage: "Ce que la personne apporte :" 
},
SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_75_STRENGTHS_1: { 
  id: "app.scope_report_valuepref_variety_75_strengths_1", 
  defaultMessage: "Cherche le renouvellement, aime toucher à plusieurs sujets." 
},
SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_75_STRENGTHS_2: { 
  id: "app.scope_report_valuepref_variety_75_strengths_2", 
  defaultMessage: "S'épanouit dans des rôles transverses ou évolutifs." 
},
SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_75_STRENGTHS_3: { 
  id: "app.scope_report_valuepref_variety_75_strengths_3", 
  defaultMessage: "Force de proposition pour diversifier les méthodes, outils, projets." 
},
SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_75_DEVELOPMENT_INTRO: { 
  id: "app.scope_report_valuepref_variety_75_development_intro", 
  defaultMessage: "Points de développement :" 
},
SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_75_DEVELOPMENT_1: { 
  id: "app.scope_report_valuepref_variety_75_development_1", 
  defaultMessage: "Travailler sa capacité à aller au bout des tâches engagées, en renforçant sa rigueur et sa concentration." 
},
SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_75_DEVELOPMENT_2: { 
  id: "app.scope_report_valuepref_variety_75_development_2", 
  defaultMessage: "Développer des repères personnels pour mieux fonctionner dans des environnements très structurés." 
},
SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_75_COLLABORATION: {
  id: "app.scope_report_valuepref_variety_75_collaboration",
  defaultMessage: "Offrez-moi de la diversité, des projets, du rythme.",
},
SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_75_MANAGEMENT: {
  id: "app.scope_report_valuepref_variety_75_management",
  defaultMessage: "Donnez-moi de l'autonomie dans un cadre vivant.",
},
SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_75_RECOGNITION: {
  id: "app.scope_report_valuepref_variety_75_recognition",
  defaultMessage: "Mettez en avant ma capacité à jongler avec les sujets.",
},
SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_75_TEAM_ADVICE: {
  id: "app.scope_report_valuepref_variety_75_team_advice",
  defaultMessage: "Varier les projets, responsabiliser sur des sujets transverses.",
},
SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_75_TEAM_KNOW: {
  id: "app.scope_report_valuepref_variety_75_team_know",
  defaultMessage: "Je m'épanouis quand je touche à plusieurs choses, alors laissez-moi changer de casquette de temps en temps.",
},
  SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_100_STRENGTHS_INTRO: { id: "app.scope_report_valuepref_variety_100_strengths_intro", defaultMessage: "Ce que la personne apporte :" },
  SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_100_STRENGTHS_1: { id: "app.scope_report_valuepref_variety_100_strengths_1", defaultMessage: "Très flexible, curieux·se, adaptable." },
  SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_100_STRENGTHS_2: { id: "app.scope_report_valuepref_variety_100_strengths_2", defaultMessage: "Excelle dans les environnements changeants, agiles, en constante évolution." },
  SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_100_STRENGTHS_3: { id: "app.scope_report_valuepref_variety_100_strengths_3", defaultMessage: "Apporte de l’innovation par son envie de renouveau." },

  SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_100_DEVELOPMENT_INTRO: { id: "app.scope_report_valuepref_variety_100_development_intro", defaultMessage: "Ce que la personne apporte :" },
  SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_100_DEVELOPMENT_1: { id: "app.scope_report_valuepref_variety_100_development_1", defaultMessage: "Identifier des leviers de motivation même dans des contextes moins variés, pour maintenir son engagement." },
  SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_100_DEVELOPMENT_2: { id: "app.scope_report_valuepref_variety_100_development_2", defaultMessage: "Cultiver plus de constance et d’approfondissement sur certains sujets pour gagner en expertise et en crédibilité." },

  SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_100_COLLABORATION: {
    id: "app.scope_report_valuepref_variety_100_collaboration",
    defaultMessage: "Proposez-moi un environnement riche, changeant et stimulant.",
  },
  SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_100_MANAGEMENT: {
    id: "app.scope_report_valuepref_variety_100_management",
    defaultMessage: "Évitez les routines, autorisez-moi à pivoter ou créer.",
  },
  SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_100_RECOGNITION: {
    id: "app.scope_report_valuepref_variety_100_recognition",
    defaultMessage: "Soulignez ma créativité et ma souplesse d’adaptation.",
  },
  SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_100_TEAM_ADVICE: {
    id: "app.scope_report_valuepref_variety_100_team_advice",
    defaultMessage: "Conseil d’équipe : Maintenir un fort niveau de nouveauté et d’autonomie, éviter la monotonie.",
  },
  SCOPE_REPORT_TASK_VARIABILITY_PERCENTILE_100_TEAM_KNOW: {
    id: "app.scope_report_valuepref_variety_100_team_know",
    defaultMessage: "Si vous me laissez dans la routine, je perds toute ma motivation — j’ai besoin de nouveauté !",
  },



  
SCOPE_REPORT_COLLABORATION_LABEL: {
  id: "app.scope_report_collaboration_label",
  defaultMessage: "Pour assurer ma collaboration : ",
},
SCOPE_REPORT_MANAGEMENT_LABEL: {
  id: "app.scope_report_management_label",
  defaultMessage: "Pour m’encadrer au mieux : ",
},
SCOPE_REPORT_RECOGNITION_LABEL: {
  id: "app.scope_report_recognition_label",
  defaultMessage: "La meilleure façon de reconnaître mon travail : ",
},
SCOPE_REPORT_TEAM_KNOW_LABEL: {
  id: "app.scope_report_team_know_label",
  defaultMessage: "Ce que mon équipe doit savoir sur moi : ",
},
SCOPE_REPORT_ESSENTIAL_FOR_ME_LABEL: {
  id: "app.scope_report_essential_for_me_label",
  defaultMessage: "Ce qui est fondamental pour moi : ",
},
SCOPE_REPORT_OPTIMIZE_FOR_ME_LABEL: {
  id: "app.scope_report_optimize_my_performance_label",
  defaultMessage: "Comment optimiser ma performance : ",
},
SCOPE_REPORT_LEVERS_OF_MOTIVATION_LABEL: {
  id: "app.scope_report_levers_of_motivation_label",
  defaultMessage: "Mes leviers de motivation : ",
},
SCOPE_REPORT_TEAM_ADVICE_LABEL: {
  id: "app.scope_report_team_advice_label",
  defaultMessage: "Conseil d’équipe : ",
},


// VALEURS : POUVOIR
SCOPE_REPORT_POWER: {
  id: "app.scope_report_valuepref_power",
  defaultMessage: "Pouvoir",
},
SCOPE_REPORT_POWER_DESC: {
  id: "app.scope_report_valuepref_power_desc",
  defaultMessage: "Le désir d’avoir de l’influence, de contrôler les décisions ou de jouer un rôle central dans une organisation. Une personne motivée par le pouvoir aime orienter les actions des autres, décider, et être au cœur des enjeux stratégiques.",
},
SCOPE_REPORT_POWER_MANAGER_DESC: {
  id: "app.scope_report_valuepref_power_manager_desc",
  defaultMessage: "une personne attirée par le pouvoir aura besoin de responsabilités, de visibilité et d'autonomie décisionnelle.",
},
SCOPE_REPORT_POWER_DESC_LOW: {
  id: "app.scope_report_valuepref_power_desc_low",
  defaultMessage: "Besoin de contribuer sans dominer. On préfère la coopération à l'autorité, les rôles d'exécution ou d'égal à égal plutôt que de décider pour les autres.",
},
SCOPE_REPORT_POWER_MANAGER_DESC_LOW: {
  id: "app.scope_report_valuepref_power_manager_desc_low",
  defaultMessage: "donner un cadre clair, sans attendre de prise de pouvoir ou de leadership affirmé.",
},
SCOPE_REPORT_POWER_PERCENTILE_25_STRENGTHS_INTRO: { id: "app.scope_report_valuepref_power_25_strengths_intro", defaultMessage: "Ce que la personne apporte :" },
SCOPE_REPORT_POWER_PERCENTILE_25_STRENGTHS_1: { id: "app.scope_report_valuepref_power_25_strengths_1", defaultMessage: "Privilégie la collaboration à la hiérarchie." },
SCOPE_REPORT_POWER_PERCENTILE_25_STRENGTHS_2: { id: "app.scope_report_valuepref_power_25_strengths_2", defaultMessage: "À l’aise dans des rôles d’exécution ou d’égal à égal." },
SCOPE_REPORT_POWER_PERCENTILE_25_STRENGTHS_3: { id: "app.scope_report_valuepref_power_25_strengths_3", defaultMessage: "Souvent perçu·e comme modeste et accessible." },


SCOPE_REPORT_POWER_PERCENTILE_25_DEVELOPMENT_INTRO: { id: "app.scope_report_valuepref_power_25_development_intro", defaultMessage: "Points de développement :" },
SCOPE_REPORT_POWER_PERCENTILE_25_DEVELOPMENT_1: { id: "app.scope_report_valuepref_power_25_development_1", defaultMessage: "Gagner en affirmation pour oser prendre des responsabilités lorsqu’elles se présentent." },
SCOPE_REPORT_POWER_PERCENTILE_25_DEVELOPMENT_2: { id: "app.scope_report_valuepref_power_25_development_2", defaultMessage: "Développer sa capacité à se positionner dans les rapports de force, sans se mettre en retrait." },
SCOPE_REPORT_POWER_PERCENTILE_25_DEVELOPMENT_3: { id: "app.scope_report_valuepref_power_25_development_3", defaultMessage: "Apprendre à défendre ses idées même face à des personnalités dominantes." },


SCOPE_REPORT_POWER_PERCENTILE_25_TEAM_ADVICE: {
  id: "app.scope_report_valuepref_power_25_team_advice",
  defaultMessage: "Conseil d’équipe : Créer un espace participatif où la personne peut contribuer sans pression de diriger.",
},
SCOPE_REPORT_POWER_PERCENTILE_25_COLLABORATION: {
  id: "app.scope_report_valuepref_power_25_collaboration",
  defaultMessage: "Laissez-moi contribuer sans chercher à diriger.",
},
SCOPE_REPORT_POWER_PERCENTILE_25_MANAGEMENT: {
  id: "app.scope_report_valuepref_power_25_management",
  defaultMessage: "Soyez clair dans vos décisions et votre cadre de pilotage.",
},
SCOPE_REPORT_POWER_PERCENTILE_25_RECOGNITION: {
  id: "app.scope_report_valuepref_power_25_recognition",
  defaultMessage: "Valorisez mon engagement dans un rôle d’exécution fiable.",
},
SCOPE_REPORT_POWER_PERCENTILE_25_TEAM_KNOW: {
  id: "app.scope_report_valuepref_power_25_team_know",
  defaultMessage: "Pouvoir contribuer sans devoir prendre le dessus.",
},
SCOPE_REPORT_POWER_PERCENTILE_50_TITLE: {
  id: "app.scope_report_valuepref_power_50_title",
  defaultMessage: "50e percentil (valeur modérée du pouvoir)",
},
SCOPE_REPORT_POWER_PERCENTILE_50_STRENGTHS_INTRO: { 
  id: "app.scope_report_valuepref_power_50_strengths_intro", 
  defaultMessage: "Ce que la personne apporte :" 
},
SCOPE_REPORT_POWER_PERCENTILE_50_STRENGTHS_1: { 
  id: "app.scope_report_valuepref_power_50_strengths_1", 
  defaultMessage: "Capable de prendre le pouvoir quand c'est nécessaire, sans en abuser." 
},
SCOPE_REPORT_POWER_PERCENTILE_50_STRENGTHS_2: { 
  id: "app.scope_report_valuepref_power_50_strengths_2", 
  defaultMessage: "Bon équilibre entre leadership et esprit d'équipe." 
},
SCOPE_REPORT_POWER_PERCENTILE_50_STRENGTHS_3: { 
  id: "app.scope_report_valuepref_power_50_strengths_3", 
  defaultMessage: "Respecte les règles et l'autorité, tout en ayant sa propre voix." 
},
SCOPE_REPORT_POWER_PERCENTILE_50_DEVELOPMENT_INTRO: { 
  id: "app.scope_report_valuepref_power_50_development_intro", 
  defaultMessage: "Points de développement :" 
},
SCOPE_REPORT_POWER_PERCENTILE_50_DEVELOPMENT_1: { 
  id: "app.scope_report_valuepref_power_50_development_1", 
  defaultMessage: "Travailler son positionnement dans les environnements compétitifs pour trouver un juste équilibre entre affirmation de soi et préservation." 
},
SCOPE_REPORT_POWER_PERCENTILE_50_COLLABORATION: {
  id: "app.scope_report_valuepref_power_50_collaboration",
  defaultMessage: "Donnez-moi l'occasion de prendre le lead si besoin, sans obligation.",
},
SCOPE_REPORT_POWER_PERCENTILE_50_MANAGEMENT: {
  id: "app.scope_report_valuepref_power_50_management",
  defaultMessage: "Encouragez mes prises d'initiative ponctuelles.",
},
SCOPE_REPORT_POWER_PERCENTILE_50_RECOGNITION: {
  id: "app.scope_report_valuepref_power_50_recognition",
  defaultMessage: "Soulignez ma capacité à guider sans dominer.",
},
SCOPE_REPORT_POWER_PERCENTILE_50_TEAM_ADVICE: {
  id: "app.scope_report_valuepref_power_50_team_advice",
  defaultMessage: "Donner des responsabilités ponctuelles ou en co-animation pour tester le leadership.",
},
SCOPE_REPORT_POWER_PERCENTILE_50_TEAM_KNOW: {
  id: "app.scope_report_valuepref_power_50_team_know",
  defaultMessage: "Avoir mon mot à dire sans forcément porter toute la charge.",
},

SCOPE_REPORT_POWER_PERCENTILE_75_TITLE: {
  id: "app.scope_report_valuepref_power_75_title",
  defaultMessage: "75e percentil (forte valeur du pouvoir)",
},
SCOPE_REPORT_POWER_PERCENTILE_75_STRENGTHS_INTRO: { 
  id: "app.scope_report_valuepref_power_75_strengths_intro", 
  defaultMessage: "Ce que la personne apporte :" 
},
SCOPE_REPORT_POWER_PERCENTILE_75_STRENGTHS_1: { 
  id: "app.scope_report_valuepref_power_75_strengths_1", 
  defaultMessage: "Aime piloter, influencer, orienter les choix." 
},
SCOPE_REPORT_POWER_PERCENTILE_75_STRENGTHS_2: { 
  id: "app.scope_report_valuepref_power_75_strengths_2", 
  defaultMessage: "Peut jouer un rôle stratégique dans les décisions." 
},
SCOPE_REPORT_POWER_PERCENTILE_75_STRENGTHS_3: { 
  id: "app.scope_report_valuepref_power_75_strengths_3", 
  defaultMessage: "Ambitieux·se et proactif·ve pour faire bouger les lignes." 
},
SCOPE_REPORT_POWER_PERCENTILE_75_DEVELOPMENT_INTRO: { 
  id: "app.scope_report_valuepref_power_75_development_intro", 
  defaultMessage: "Points de développement :" 
},
SCOPE_REPORT_POWER_PERCENTILE_75_DEVELOPMENT_1: { 
  id: "app.scope_report_valuepref_power_75_development_1", 
  defaultMessage: "Apprendre à gérer les désaccords avec d'autres personnes influentes de manière constructive et posée." 
},
SCOPE_REPORT_POWER_PERCENTILE_75_DEVELOPMENT_2: { 
  id: "app.scope_report_valuepref_power_75_development_2", 
  defaultMessage: "Travailler la reconnaissance de soi au-delà du statut pour renforcer sa stabilité et sa motivation." 
},
SCOPE_REPORT_POWER_PERCENTILE_75_COLLABORATION: {
  id: "app.scope_report_valuepref_power_75_collaboration",
  defaultMessage: "Offrez-moi un espace d'influence réel et reconnu.",
},
SCOPE_REPORT_POWER_PERCENTILE_75_MANAGEMENT: {
  id: "app.scope_report_valuepref_power_75_management",
  defaultMessage: "Donnez-moi des missions avec leadership clair.",
},
SCOPE_REPORT_POWER_PERCENTILE_75_RECOGNITION: {
  id: "app.scope_report_valuepref_power_75_recognition",
  defaultMessage: "Célébrez mon rôle moteur dans l'équipe.",
},
SCOPE_REPORT_POWER_PERCENTILE_75_TEAM_ADVICE: {
  id: "app.scope_report_valuepref_power_75_team_advice",
  defaultMessage: "Canaliser son influence vers des missions à fort impact collectif.",
},
SCOPE_REPORT_POWER_PERCENTILE_75_TEAM_KNOW: {
  id: "app.scope_report_valuepref_power_75_team_know",
  defaultMessage: "Avoir un vrai impact et influencer les décisions.",
},
SCOPE_REPORT_POWER_PERCENTILE_100_STRENGTHS_INTRO: { id: "app.scope_report_valuepref_power_100_strengths_intro", defaultMessage: "Ce que la personne apporte :" },
SCOPE_REPORT_POWER_PERCENTILE_100_STRENGTHS_1: { id: "app.scope_report_valuepref_power_100_strengths_1", defaultMessage: "Volonté très forte d’avoir un impact et un pouvoir décisionnel." },
SCOPE_REPORT_POWER_PERCENTILE_100_STRENGTHS_2: { id: "app.scope_report_valuepref_power_100_strengths_2", defaultMessage: "Leader affirmé·e, impose naturellement sa vision." },
SCOPE_REPORT_POWER_PERCENTILE_100_STRENGTHS_3: { id: "app.scope_report_valuepref_power_100_strengths_3", defaultMessage: "Cherche les postes de contrôle ou d’autorité." },


SCOPE_REPORT_POWER_PERCENTILE_100_DEVELOPMENT_INTRO: { id: "app.scope_report_valuepref_power_100_development_intro", defaultMessage: "Points de développement :" },
SCOPE_REPORT_POWER_PERCENTILE_100_DEVELOPMENT_1: { id: "app.scope_report_valuepref_power_100_development_1", defaultMessage: "Cultiver une posture de leadership plus équilibrée, fondée sur la collaboration et l’écoute." },
SCOPE_REPORT_POWER_PERCENTILE_100_DEVELOPMENT_2: { id: "app.scope_report_valuepref_power_100_development_2", defaultMessage: "Apprendre à accueillir les remises en question du pouvoir comme des opportunités de dialogue et d’ajustement." },
SCOPE_REPORT_POWER_PERCENTILE_100_DEVELOPMENT_3: { id: "app.scope_report_valuepref_power_100_development_3", defaultMessage: "Partager davantage la responsabilité et l’influence." },


SCOPE_REPORT_POWER_PERCENTILE_100_TEAM_ADVICE: {
  id: "app.scope_report_valuepref_power_100_team_advice",
  defaultMessage: "Conseil d’équipe : Clarifier les rôles pour éviter les conflits d’ego, encourager un leadership partagé.",
},
SCOPE_REPORT_POWER_PERCENTILE_100_COLLABORATION: {
  id: "app.scope_report_valuepref_power_100_collaboration",
  defaultMessage: "Confiez-moi des fonctions à haute responsabilité.",
},
SCOPE_REPORT_POWER_PERCENTILE_100_MANAGEMENT: {
  id: "app.scope_report_valuepref_power_100_management",
  defaultMessage: "Déléguez-moi un périmètre de pouvoir clairement défini.",
},
SCOPE_REPORT_POWER_PERCENTILE_100_RECOGNITION: {
  id: "app.scope_report_valuepref_power_100_recognition",
  defaultMessage: "Reconnaissez publiquement mon autorité et mon impact.",
},
SCOPE_REPORT_POWER_PERCENTILE_100_TEAM_KNOW: {
  id: "app.scope_report_valuepref_power_100_team_know",
  defaultMessage: "Être aux commandes — diriger, décider, faire avancer.",
},

// VALEURS : SUCCES
SCOPE_REPORT_SUCCESS: {
  id: "app.scope_report_valuepref_success",
  defaultMessage: "Succès",
},
SCOPE_REPORT_SUCCESS_DESC: {
  id: "app.scope_report_valuepref_success_desc",
  defaultMessage: "Vouloir atteindre des objectifs élevés, être reconnu·e pour ses résultats et progresser vers l’excellence. Ces personnes sont souvent ambitieuses, performantes et tournées vers la réussite visible.",
},
SCOPE_REPORT_SUCCESS_MANAGER_DESC: {
  id: "app.scope_report_valuepref_success_manager_desc",
  defaultMessage: "un collaborateur motivé par le succès est souvent très orienté performance, progression, reconnaissance.",
},
SCOPE_REPORT_SUCCESS_DESC_LOW: {
  id: "app.scope_report_valuepref_success_desc_low",
  defaultMessage: "Besoin d'être utile plus que reconnu·e. On privilégie le travail bien fait à la performance visible, et l'accomplissement personnel à l'ambition affichée.",
},
SCOPE_REPORT_SUCCESS_MANAGER_DESC_LOW: {
  id: "app.scope_report_valuepref_success_manager_desc_low",
  defaultMessage: "proposer du sens, pas de pression de résultats ou de reconnaissance publique.",
},
SCOPE_REPORT_SUCCESS_PERCENTILE_25_STRENGTHS_INTRO: { id: "app.scope_report_valuepref_success_25_strengths_intro", defaultMessage: "Ce que la personne apporte :" },
SCOPE_REPORT_SUCCESS_PERCENTILE_25_STRENGTHS_1: { id: "app.scope_report_valuepref_success_25_strengths_1", defaultMessage: "Moins intéressé·e par la compétition ou la performance visible." },
SCOPE_REPORT_SUCCESS_PERCENTILE_25_STRENGTHS_2: { id: "app.scope_report_valuepref_success_25_strengths_2", defaultMessage: "Préfère l’accomplissement intérieur à la reconnaissance externe." },
SCOPE_REPORT_SUCCESS_PERCENTILE_25_STRENGTHS_3: { id: "app.scope_report_valuepref_success_25_strengths_3", defaultMessage: "Modeste, discret·e, centré·e sur le travail bien fait." },


SCOPE_REPORT_SUCCESS_PERCENTILE_25_DEVELOPMENT_INTRO: { id: "app.scope_report_valuepref_success_25_development_intro", defaultMessage: "Points de développement :" },
SCOPE_REPORT_SUCCESS_PERCENTILE_25_DEVELOPMENT_1: { id: "app.scope_report_valuepref_success_25_development_1", defaultMessage: "Développer une vision plus ambitieuse de ses capacités et de son potentiel." },
SCOPE_REPORT_SUCCESS_PERCENTILE_25_DEVELOPMENT_2: { id: "app.scope_report_valuepref_success_25_development_2", defaultMessage: "Être plus attentif·ve aux opportunités d’avancement et oser les saisir." },
SCOPE_REPORT_SUCCESS_PERCENTILE_25_DEVELOPMENT_3: { id: "app.scope_report_valuepref_success_25_development_3", defaultMessage: "Valoriser ses réussites même discrètes." },


SCOPE_REPORT_SUCCESS_PERCENTILE_25_TEAM_ADVICE: {
  id: "app.scope_report_valuepref_success_25_team_advice",
  defaultMessage: "Conseil d’équipe : Mettre en valeur ses réussites même discrètes, sans le forcer à se comparer.",
},
SCOPE_REPORT_SUCCESS_PERCENTILE_25_COLLABORATION: {
  id: "app.scope_report_valuepref_success_25_collaboration",
  defaultMessage: "Donnez-moi un rôle utile, sans pression de performance.",
},
SCOPE_REPORT_SUCCESS_PERCENTILE_25_MANAGEMENT: {
  id: "app.scope_report_valuepref_success_25_management",
  defaultMessage: "Mettez en avant le sens plus que les résultats.",
},
SCOPE_REPORT_SUCCESS_PERCENTILE_25_RECOGNITION: {
  id: "app.scope_report_valuepref_success_25_recognition",
  defaultMessage: "Valorisez ma contribution en toute discrétion.",
},
SCOPE_REPORT_SUCCESS_PERCENTILE_25_TEAM_KNOW: {
  id: "app.scope_report_valuepref_success_25_team_know",
  defaultMessage: "Me sentir utile, pas forcément reconnu·e.",
},
SCOPE_REPORT_SUCCESS_PERCENTILE_50_TITLE: {
  id: "app.scope_report_valuepref_success_50_title",
  defaultMessage: "50e percentil (valeur modérée du succès)",
},
SCOPE_REPORT_SUCCESS_PERCENTILE_50_STRENGTHS_INTRO: { 
  id: "app.scope_report_valuepref_success_50_strengths_intro", 
  defaultMessage: "Ce que la personne apporte :" 
},
SCOPE_REPORT_SUCCESS_PERCENTILE_50_STRENGTHS_1: { 
  id: "app.scope_report_valuepref_success_50_strengths_1", 
  defaultMessage: "Équilibre entre ambition et modestie, cherche à bien faire sans excès." 
},
SCOPE_REPORT_SUCCESS_PERCENTILE_50_STRENGTHS_2: { 
  id: "app.scope_report_valuepref_success_50_strengths_2", 
  defaultMessage: "Capable de viser l'excellence tout en gardant les pieds sur terre." 
},
SCOPE_REPORT_SUCCESS_PERCENTILE_50_STRENGTHS_3: { 
  id: "app.scope_report_valuepref_success_50_strengths_3", 
  defaultMessage: "Motivé·e par la réussite mais sans écraser les autres." 
},
SCOPE_REPORT_SUCCESS_PERCENTILE_50_DEVELOPMENT_INTRO: { 
  id: "app.scope_report_valuepref_success_50_development_intro", 
  defaultMessage: "Points de développement :" 
},
SCOPE_REPORT_SUCCESS_PERCENTILE_50_DEVELOPMENT_1: { 
  id: "app.scope_report_valuepref_success_50_development_1", 
  defaultMessage: "Clarifier ses propres ambitions pour éviter de rester dans une zone de confort trop longtemps." 
},
SCOPE_REPORT_SUCCESS_PERCENTILE_50_COLLABORATION: {
  id: "app.scope_report_valuepref_success_50_collaboration",
  defaultMessage: "Proposez des objectifs stimulants mais atteignables.",
},
SCOPE_REPORT_SUCCESS_PERCENTILE_50_MANAGEMENT: {
  id: "app.scope_report_valuepref_success_50_management",
  defaultMessage: "Encouragez sans pression excessive, valorisez les progrès.",
},
SCOPE_REPORT_SUCCESS_PERCENTILE_50_RECOGNITION: {
  id: "app.scope_report_valuepref_success_50_recognition",
  defaultMessage: "Soulignez mes réussites et mon professionnalisme équilibré.",
},
SCOPE_REPORT_SUCCESS_PERCENTILE_50_TEAM_ADVICE: {
  id: "app.scope_report_valuepref_success_50_team_advice",
  defaultMessage: "Offrir des défis motivants sans créer de compétition excessive.",
},
SCOPE_REPORT_SUCCESS_PERCENTILE_50_TEAM_KNOW: {
  id: "app.scope_report_valuepref_success_50_team_know",
  defaultMessage: "J'aime réussir et progresser, mais sans que ce soit une obsession permanente.",
},

SCOPE_REPORT_SUCCESS_PERCENTILE_75_TITLE: {
  id: "app.scope_report_valuepref_success_75_title",
  defaultMessage: "75e percentil (forte valeur du succès)",
},
SCOPE_REPORT_SUCCESS_PERCENTILE_75_STRENGTHS_INTRO: { 
  id: "app.scope_report_valuepref_success_75_strengths_intro", 
  defaultMessage: "Ce que la personne apporte :" 
},
SCOPE_REPORT_SUCCESS_PERCENTILE_75_STRENGTHS_1: { 
  id: "app.scope_report_valuepref_success_75_strengths_1", 
  defaultMessage: "Fortement motivé·e par l'atteinte d'objectifs ambitieux et la reconnaissance." 
},
SCOPE_REPORT_SUCCESS_PERCENTILE_75_STRENGTHS_2: { 
  id: "app.scope_report_valuepref_success_75_strengths_2", 
  defaultMessage: "Moteur de performance, pousse l'équipe vers l'excellence." 
},
SCOPE_REPORT_SUCCESS_PERCENTILE_75_STRENGTHS_3: { 
  id: "app.scope_report_valuepref_success_75_strengths_3", 
  defaultMessage: "Très investissement dans la progression de carrière et les projets stratégiques." 
},
SCOPE_REPORT_SUCCESS_PERCENTILE_75_DEVELOPMENT_INTRO: { 
  id: "app.scope_report_valuepref_success_75_development_intro", 
  defaultMessage: "Points de développement :" 
},
SCOPE_REPORT_SUCCESS_PERCENTILE_75_DEVELOPMENT_1: { 
  id: "app.scope_report_valuepref_success_75_development_1", 
  defaultMessage: "Apprendre à mieux gérer la frustration en cas d'échec ou de retard dans la progression." 
},
SCOPE_REPORT_SUCCESS_PERCENTILE_75_DEVELOPMENT_2: { 
  id: "app.scope_report_valuepref_success_75_development_2", 
  defaultMessage: "Cultiver la patience et valoriser les réussites intermédiaires." 
},
SCOPE_REPORT_SUCCESS_PERCENTILE_75_COLLABORATION: {
  id: "app.scope_report_valuepref_success_75_collaboration",
  defaultMessage: "Fixez des objectifs clairs avec des étapes de progression visible.",
},
SCOPE_REPORT_SUCCESS_PERCENTILE_75_MANAGEMENT: {
  id: "app.scope_report_valuepref_success_75_management",
  defaultMessage: "Donnez des responsabilités ambitieuses avec reconnaissance publique.",
},
SCOPE_REPORT_SUCCESS_PERCENTILE_75_RECOGNITION: {
  id: "app.scope_report_valuepref_success_75_recognition",
  defaultMessage: "Célébrez mes réussites de manière visible et concrète.",
},
SCOPE_REPORT_SUCCESS_PERCENTILE_75_TEAM_ADVICE: {
  id: "app.scope_report_valuepref_success_75_team_advice",
  defaultMessage: "Canaliser l'ambition vers des objectifs collectifs, éviter la compétition toxique.",
},
SCOPE_REPORT_SUCCESS_PERCENTILE_75_TEAM_KNOW: {
  id: "app.scope_report_valuepref_success_75_team_know",
  defaultMessage: "J'ai besoin de sentir que je progresse et que mes efforts sont reconnus — le succès me motive vraiment.",
},

SCOPE_REPORT_SUCCESS_PERCENTILE_100_STRENGTHS_INTRO: { id: "app.scope_report_valuepref_success_100_strengths_intro", defaultMessage: "Ce que la personne apporte :" },
SCOPE_REPORT_SUCCESS_PERCENTILE_100_STRENGTHS_1: { id: "app.scope_report_valuepref_success_100_strengths_1", defaultMessage: "Ultra-motivé·e par les résultats, la carrière, la reconnaissance." },
SCOPE_REPORT_SUCCESS_PERCENTILE_100_STRENGTHS_2: { id: "app.scope_report_valuepref_success_100_strengths_2", defaultMessage: "Très compétitif·ve, met tout en œuvre pour réussir." },
SCOPE_REPORT_SUCCESS_PERCENTILE_100_STRENGTHS_3: { id: "app.scope_report_valuepref_success_100_strengths_3", defaultMessage: "Fort moteur dans des environnements orientés objectifs." },


SCOPE_REPORT_SUCCESS_PERCENTILE_100_DEVELOPMENT_INTRO: { id: "app.scope_report_valuepref_success_100_development_intro", defaultMessage: "Points de développement :" },
SCOPE_REPORT_SUCCESS_PERCENTILE_100_DEVELOPMENT_1: { id: "app.scope_report_valuepref_success_100_development_1", defaultMessage: "Travailler l’équilibre entre ambition personnelle et coopération pour ne pas négliger les autres en chemin." },
SCOPE_REPORT_SUCCESS_PERCENTILE_100_DEVELOPMENT_2: { id: "app.scope_report_valuepref_success_100_development_2", defaultMessage: "Apprendre à mieux gérer son énergie et ses limites pour éviter le surinvestissement et l’épuisement." },
SCOPE_REPORT_SUCCESS_PERCENTILE_100_DEVELOPMENT_3: { id: "app.scope_report_valuepref_success_100_development_3", defaultMessage: "Aligner ses ambitions avec les valeurs collectives." },


SCOPE_REPORT_SUCCESS_PERCENTILE_100_TEAM_ADVICE: {
  id: "app.scope_report_valuepref_success_100_team_advice",
  defaultMessage: "Conseil d’équipe : Cadrer les ambitions avec les valeurs collectives pour éviter la compétition excessive.",
},
SCOPE_REPORT_SUCCESS_PERCENTILE_100_COLLABORATION: {
  id: "app.scope_report_valuepref_success_100_collaboration",
  defaultMessage: "Donnez-moi des objectifs ambitieux et visibles.",
},
SCOPE_REPORT_SUCCESS_PERCENTILE_100_MANAGEMENT: {
  id: "app.scope_report_valuepref_success_100_management",
  defaultMessage: "Adoptez un management exigeant et méritocratique.",
},
SCOPE_REPORT_SUCCESS_PERCENTILE_100_RECOGNITION: {
  id: "app.scope_report_valuepref_success_100_recognition",
  defaultMessage: "Récompensez mes résultats de manière marquante.",
},
SCOPE_REPORT_SUCCESS_PERCENTILE_100_TEAM_KNOW: {
  id: "app.scope_report_valuepref_success_100_team_know",
  defaultMessage: "Réussir, briller, et faire la différence — le résultat compte vraiment.",
},

// VALEURS : MORALITE
SCOPE_REPORT_MORALITY: {
  id: "app.scope_report_valuepref_morality",
  defaultMessage: "Moralité / Conduite éthique",
},
SCOPE_REPORT_MORALITY_DESC: {
  id: "app.scope_report_valuepref_morality_desc",
  defaultMessage: "Avoir un besoin fort de faire le bien, respecter des principes éthiques, et travailler de manière juste et responsable. Ces personnes sont très sensibles à la cohérence entre les actions et les valeurs.",
},
SCOPE_REPORT_MORALITY_MANAGER_DESC: {
  id: "app.scope_report_valuepref_morality_manager_desc",
  defaultMessage: "un collaborateur guidé par la Moralité / Conduite éthique aura besoin d'un cadre éthique, cohérent, aligné avec ses convictions.",
},
SCOPE_REPORT_MORALITY_DESC_LOW: {
  id: "app.scope_report_valuepref_morality_desc_low",
  defaultMessage: "Besoin de pragmatisme plus que de principes. On agit selon l'efficacité du moment, en s'adaptant au contexte, sans chercher un cadre moral strict.",
},
SCOPE_REPORT_MORALITY_MANAGER_DESC_LOW: {
  id: "app.scope_report_valuepref_morality_manager_desc_low",
  defaultMessage: "cadrer par l'objectif, pas par la morale.",
},
SCOPE_REPORT_MORALITY_PERCENTILE_25_STRENGTHS_INTRO: { id: "app.scope_report_valuepref_morality_25_strengths_intro", defaultMessage: "Ce que la personne apporte :" },
SCOPE_REPORT_MORALITY_PERCENTILE_25_STRENGTHS_1: { id: "app.scope_report_valuepref_morality_25_strengths_1", defaultMessage: "Pratique, adaptable, centré·e sur l’efficacité plus que les principes." },
SCOPE_REPORT_MORALITY_PERCENTILE_25_STRENGTHS_2: { id: "app.scope_report_valuepref_morality_25_strengths_2", defaultMessage: "Capable de naviguer dans des environnements ambigus." },
SCOPE_REPORT_MORALITY_PERCENTILE_25_STRENGTHS_3: { id: "app.scope_report_valuepref_morality_25_strengths_3", defaultMessage: "Flexible face aux règles." },


SCOPE_REPORT_MORALITY_PERCENTILE_25_DEVELOPMENT_INTRO: { id: "app.scope_report_valuepref_morality_25_development_intro", defaultMessage: "Points de développement :" },
SCOPE_REPORT_MORALITY_PERCENTILE_25_DEVELOPMENT_1: { id: "app.scope_report_valuepref_morality_25_development_1", defaultMessage: "Développer une attention plus fine à l’impact éthique de ses choix et décisions." },
SCOPE_REPORT_MORALITY_PERCENTILE_25_DEVELOPMENT_2: { id: "app.scope_report_valuepref_morality_25_development_2", defaultMessage: "Apprendre à mieux dialoguer avec des collègues sensibles aux enjeux moraux pour éviter les tensions." },
SCOPE_REPORT_MORALITY_PERCENTILE_25_DEVELOPMENT_3: { id: "app.scope_report_valuepref_morality_25_development_3", defaultMessage: "Prendre en compte les conséquences à long terme." },


SCOPE_REPORT_MORALITY_PERCENTILE_25_TEAM_ADVICE: {
  id: "app.scope_report_valuepref_morality_25_team_advice",
  defaultMessage: "Conseil d’équipe : Impliquer la personne dans les décisions pratiques, tout en rappelant l’éthique du cadre.",
},
SCOPE_REPORT_MORALITY_PERCENTILE_25_COLLABORATION: {
  id: "app.scope_report_valuepref_morality_25_collaboration",
  defaultMessage: "Donnez-moi de la liberté d'action, sans cadre moral rigide.",
},
SCOPE_REPORT_MORALITY_PERCENTILE_25_MANAGEMENT: {
  id: "app.scope_report_valuepref_morality_25_management",
  defaultMessage: "Orientez-moi sur les résultats, pas sur les principes.",
},
SCOPE_REPORT_MORALITY_PERCENTILE_25_RECOGNITION: {
  id: "app.scope_report_valuepref_morality_25_recognition",
  defaultMessage: "Valorisez mon efficacité dans les zones floues.",
},
SCOPE_REPORT_MORALITY_PERCENTILE_25_TEAM_KNOW: {
  id: "app.scope_report_valuepref_morality_25_team_know",
  defaultMessage: "Être efficace, même si ça sort parfois du cadre.",
},
SCOPE_REPORT_MORALITY_PERCENTILE_50_TITLE: {
  id: "app.scope_report_valuepref_morality_50_title",
  defaultMessage: "50e percentil (valeur modérée de la Moralité / Conduite éthique)",
},
SCOPE_REPORT_MORALITY_PERCENTILE_50_STRENGTHS_INTRO: { 
  id: "app.scope_report_valuepref_morality_50_strengths_intro", 
  defaultMessage: "Ce que la personne apporte :" 
},
SCOPE_REPORT_MORALITY_PERCENTILE_50_STRENGTHS_1: { 
  id: "app.scope_report_valuepref_morality_50_strengths_1", 
  defaultMessage: "Équilibre entre principes moraux et pragmatisme selon les situations." 
},
SCOPE_REPORT_MORALITY_PERCENTILE_50_STRENGTHS_2: { 
  id: "app.scope_report_valuepref_morality_50_strengths_2", 
  defaultMessage: "Capable de s'adapter tout en gardant un socle éthique." 
},
SCOPE_REPORT_MORALITY_PERCENTILE_50_STRENGTHS_3: { 
  id: "app.scope_report_valuepref_morality_50_strengths_3", 
  defaultMessage: "Sait naviguer dans les zones grises sans perdre ses repères." 
},
SCOPE_REPORT_MORALITY_PERCENTILE_50_DEVELOPMENT_INTRO: { 
  id: "app.scope_report_valuepref_morality_50_development_intro", 
  defaultMessage: "Points de développement :" 
},
SCOPE_REPORT_MORALITY_PERCENTILE_50_DEVELOPMENT_1: { 
  id: "app.scope_report_valuepref_morality_50_development_1", 
  defaultMessage: "Clarifier ses propres limites éthiques pour mieux les communiquer en cas de conflit moral." 
},
SCOPE_REPORT_MORALITY_PERCENTILE_50_COLLABORATION: {
  id: "app.scope_report_valuepref_morality_50_collaboration",
  defaultMessage: "Respectez mes valeurs de base tout en me laissant de la souplesse.",
},
SCOPE_REPORT_MORALITY_PERCENTILE_50_MANAGEMENT: {
  id: "app.scope_report_valuepref_morality_50_management",
  defaultMessage: "Expliquez le cadre éthique sans être rigide sur l'application.",
},
SCOPE_REPORT_MORALITY_PERCENTILE_50_RECOGNITION: {
  id: "app.scope_report_valuepref_morality_50_recognition",
  defaultMessage: "Valorisez ma capacité à faire le bon choix selon le contexte.",
},
SCOPE_REPORT_MORALITY_PERCENTILE_50_TEAM_ADVICE: {
  id: "app.scope_report_valuepref_morality_50_team_advice",
  defaultMessage: "Impliquer dans les réflexions éthiques tout en gardant de la flexibilité.",
},
SCOPE_REPORT_MORALITY_PERCENTILE_50_TEAM_KNOW: {
  id: "app.scope_report_valuepref_morality_50_team_know",
  defaultMessage: "J'ai des principes mais je sais m'adapter — parlez-moi des enjeux éthiques.",
},

SCOPE_REPORT_MORALITY_PERCENTILE_75_TITLE: {
  id: "app.scope_report_valuepref_morality_75_title",
  defaultMessage: "75e percentil (forte valeur de la Moralité / Conduite éthique)",
},
SCOPE_REPORT_MORALITY_PERCENTILE_75_STRENGTHS_INTRO: { 
  id: "app.scope_report_valuepref_morality_75_strengths_intro", 
  defaultMessage: "Ce que la personne apporte :" 
},
SCOPE_REPORT_MORALITY_PERCENTILE_75_STRENGTHS_1: { 
  id: "app.scope_report_valuepref_morality_75_strengths_1", 
  defaultMessage: "Forte vigilance éthique, guide moral pour l'équipe." 
},
SCOPE_REPORT_MORALITY_PERCENTILE_75_STRENGTHS_2: { 
  id: "app.scope_report_valuepref_morality_75_strengths_2", 
  defaultMessage: "Aide à prendre des décisions justes et responsables." 
},
SCOPE_REPORT_MORALITY_PERCENTILE_75_STRENGTHS_3: { 
  id: "app.scope_report_valuepref_morality_75_strengths_3", 
  defaultMessage: "Sensible aux impacts humains et sociétaux des actions." 
},
SCOPE_REPORT_MORALITY_PERCENTILE_75_DEVELOPMENT_INTRO: { 
  id: "app.scope_report_valuepref_morality_75_development_intro", 
  defaultMessage: "Points de développement :" 
},
SCOPE_REPORT_MORALITY_PERCENTILE_75_DEVELOPMENT_1: { 
  id: "app.scope_report_valuepref_morality_75_development_1", 
  defaultMessage: "Apprendre à gérer la frustration face aux compromis inévitables." 
},
SCOPE_REPORT_MORALITY_PERCENTILE_75_DEVELOPMENT_2: { 
  id: "app.scope_report_valuepref_morality_75_development_2", 
  defaultMessage: "Développer une communication plus diplomatique de ses convictions." 
},
SCOPE_REPORT_MORALITY_PERCENTILE_75_COLLABORATION: {
  id: "app.scope_report_valuepref_morality_75_collaboration",
  defaultMessage: "Impliquez-moi dans les décisions à dimension éthique.",
},
SCOPE_REPORT_MORALITY_PERCENTILE_75_MANAGEMENT: {
  id: "app.scope_report_valuepref_morality_75_management",
  defaultMessage: "Soyez transparent·e sur les valeurs et les principes de l'organisation.",
},
SCOPE_REPORT_MORALITY_PERCENTILE_75_RECOGNITION: {
  id: "app.scope_report_valuepref_morality_75_recognition",
  defaultMessage: "Reconnaissez mon rôle de conscience éthique de l'équipe.",
},
SCOPE_REPORT_MORALITY_PERCENTILE_75_TEAM_ADVICE: {
  id: "app.scope_report_valuepref_morality_75_team_advice",
  defaultMessage: "Valoriser sa vigilance éthique tout en l'aidant à accepter les imperfections du réel.",
},
SCOPE_REPORT_MORALITY_PERCENTILE_75_TEAM_KNOW: {
  id: "app.scope_report_valuepref_morality_75_team_know",
  defaultMessage: "J'ai besoin que notre travail soit éthiquement irréprochable — consultez-moi sur les dilemmes moraux.",
},

SCOPE_REPORT_MORALITY_PERCENTILE_100_STRENGTHS_INTRO: { id: "app.scope_report_valuepref_morality_100_strengths_intro", defaultMessage: "Ce que la personne apporte :" },
SCOPE_REPORT_MORALITY_PERCENTILE_100_STRENGTHS_1: { id: "app.scope_report_valuepref_morality_100_strengths_1", defaultMessage: "Très engagé·e moralement, défenseur·se de l’éthique." },
SCOPE_REPORT_MORALITY_PERCENTILE_100_STRENGTHS_2: { id: "app.scope_report_valuepref_morality_100_strengths_2", defaultMessage: "Apporte une vigilance de fond, veille à ce que tout reste juste." },
SCOPE_REPORT_MORALITY_PERCENTILE_100_STRENGTHS_3: { id: "app.scope_report_valuepref_morality_100_strengths_3", defaultMessage: "Peut jouer un rôle de conscience collective." },


SCOPE_REPORT_MORALITY_PERCENTILE_100_DEVELOPMENT_INTRO: { id: "app.scope_report_valuepref_morality_100_development_intro", defaultMessage: "Points de développement :" },
SCOPE_REPORT_MORALITY_PERCENTILE_100_DEVELOPMENT_1: { id: "app.scope_report_valuepref_morality_100_development_1", defaultMessage: "Cultiver davantage de souplesse face aux zones grises, en acceptant l’imperfection de certains contextes." },
SCOPE_REPORT_MORALITY_PERCENTILE_100_DEVELOPMENT_2: { id: "app.scope_report_valuepref_morality_100_development_2", defaultMessage: "Travailler sa capacité à avancer même lorsque tous ses principes ne sont pas pleinement respectés." },
SCOPE_REPORT_MORALITY_PERCENTILE_100_DEVELOPMENT_3: { id: "app.scope_report_valuepref_morality_100_development_3", defaultMessage: "Prendre du recul face aux différences de valeurs." },


SCOPE_REPORT_MORALITY_PERCENTILE_100_TEAM_ADVICE: {
  id: "app.scope_report_valuepref_morality_100_team_advice",
  defaultMessage: "Conseil d’équipe : Valoriser sa vigilance éthique, mais l’aider à faire preuve de tolérance et de recul.",
},
SCOPE_REPORT_MORALITY_PERCENTILE_100_COLLABORATION: {
  id: "app.scope_report_valuepref_morality_100_collaboration",
  defaultMessage: "Soyez irréprochable éthiquement et humainement.",
},
SCOPE_REPORT_MORALITY_PERCENTILE_100_MANAGEMENT: {
  id: "app.scope_report_valuepref_morality_100_management",
  defaultMessage: "Impliquez-moi dans les décisions à portée morale.",
},
SCOPE_REPORT_MORALITY_PERCENTILE_100_RECOGNITION: {
  id: "app.scope_report_valuepref_morality_100_recognition",
  defaultMessage: "Montrez que mes principes sont écoutés et respectés.",
},
SCOPE_REPORT_MORALITY_PERCENTILE_100_TEAM_KNOW: {
  id: "app.scope_report_valuepref_morality_100_team_know",
  defaultMessage: "Être en parfaite cohérence avec mes principes — sinon je me retire.",
},

// VALEURS : INTEGRITE
SCOPE_REPORT_INTEGRITY: {
  id: "app.scope_report_valuepref_integrity",
  defaultMessage: "Intégrité / Honneur",
},
SCOPE_REPORT_INTEGRITY_DESC: {
  id: "app.scope_report_valuepref_integrity_desc",
  defaultMessage: "L’Intégrité / Honneur, c’est le besoin d’être vrai, honnête, fidèle à ses valeurs, même sous pression. Ces personnes cherchent à garder une cohérence entre ce qu’elles pensent, disent et font.",
},
SCOPE_REPORT_INTEGRITY_MANAGER_DESC: {
  id: "app.scope_report_valuepref_integrity_manager_desc",
  defaultMessage: "une personne motivée par l'Intégrité / Honneur valorise la transparence, l'authenticité, la loyauté.",
},
SCOPE_REPORT_INTEGRITY_DESC_LOW: {
  id: "app.scope_report_valuepref_integrity_desc_low",
  defaultMessage: "Besoin de s'adapter plus que d'être aligné·e. On valorise la flexibilité et l'efficacité, quitte à ajuster ses principes selon la situation.",
},
SCOPE_REPORT_INTEGRITY_MANAGER_DESC_LOW: {
  id: "app.scope_report_valuepref_integrity_manager_desc_low",
  defaultMessage: "miser sur l'adaptabilité, sans imposer un cadre moral rigide.",
},
SCOPE_REPORT_INTEGRITY_PERCENTILE_25_STRENGTHS_INTRO: { id: "app.scope_report_valuepref_integrity_25_strengths_intro", defaultMessage: "Ce que la personne apporte :" },
SCOPE_REPORT_INTEGRITY_PERCENTILE_25_STRENGTHS_1: { id: "app.scope_report_valuepref_integrity_25_strengths_1", defaultMessage: "Sait s’adapter sans se sentir en contradiction." },
SCOPE_REPORT_INTEGRITY_PERCENTILE_25_STRENGTHS_2: { id: "app.scope_report_valuepref_integrity_25_strengths_2", defaultMessage: "Pratique, ajustable aux situations." },
SCOPE_REPORT_INTEGRITY_PERCENTILE_25_STRENGTHS_3: { id: "app.scope_report_valuepref_integrity_25_strengths_3", defaultMessage: "Priorise parfois l’efficacité au détriment de la cohérence." },


SCOPE_REPORT_INTEGRITY_PERCENTILE_25_DEVELOPMENT_INTRO: { id: "app.scope_report_valuepref_integrity_25_development_intro", defaultMessage: "Points de développement :" },
SCOPE_REPORT_INTEGRITY_PERCENTILE_25_DEVELOPMENT_1: { id: "app.scope_report_valuepref_integrity_25_development_1", defaultMessage: "Travailler la cohérence entre ses choix et ses valeurs pour éviter les perceptions d’opportunisme." },
SCOPE_REPORT_INTEGRITY_PERCENTILE_25_DEVELOPMENT_2: { id: "app.scope_report_valuepref_integrity_25_development_2", defaultMessage: "Cultiver une posture plus stable et alignée pour renforcer la confiance sur le long terme." },
SCOPE_REPORT_INTEGRITY_PERCENTILE_25_DEVELOPMENT_3: { id: "app.scope_report_valuepref_integrity_25_development_3", defaultMessage: "Clarifier ses propres limites et principes." },


SCOPE_REPORT_INTEGRITY_PERCENTILE_25_TEAM_ADVICE: {
  id: "app.scope_report_valuepref_integrity_25_team_advice",
  defaultMessage: "Conseil d’équipe : Insister sur la cohérence collective et les engagements partagés.",
},
SCOPE_REPORT_INTEGRITY_PERCENTILE_25_COLLABORATION: {
  id: "app.scope_report_valuepref_integrity_25_collaboration",
  defaultMessage: "Laissez-moi m’adapter au contexte librement.",
},
SCOPE_REPORT_INTEGRITY_PERCENTILE_25_MANAGEMENT: {
  id: "app.scope_report_valuepref_integrity_25_management",
  defaultMessage: "Fixez des objectifs plutôt que des règles morales.",
},
SCOPE_REPORT_INTEGRITY_PERCENTILE_25_RECOGNITION: {
  id: "app.scope_report_valuepref_integrity_25_recognition",
  defaultMessage: "Valorisez ma souplesse et mon sens de l’opportunité.",
},
SCOPE_REPORT_INTEGRITY_PERCENTILE_25_TEAM_KNOW: {
  id: "app.scope_report_valuepref_integrity_25_team_know",
  defaultMessage: "M’adapter selon les situations, même si je change de position.",
},
SCOPE_REPORT_INTEGRITY_PERCENTILE_50_TITLE: {
  id: "app.scope_report_valuepref_integrity_50_title",
  defaultMessage: "50e percentil (valeur modérée de l'Intégrité / Honneur)",
},
SCOPE_REPORT_INTEGRITY_PERCENTILE_50_STRENGTHS_INTRO: { 
  id: "app.scope_report_valuepref_integrity_50_strengths_intro", 
  defaultMessage: "Ce que la personne apporte :" 
},
SCOPE_REPORT_INTEGRITY_PERCENTILE_50_STRENGTHS_1: { 
  id: "app.scope_report_valuepref_integrity_50_strengths_1", 
  defaultMessage: "Équilibre entre authenticité et adaptation aux contextes." 
},
SCOPE_REPORT_INTEGRITY_PERCENTILE_50_STRENGTHS_2: { 
  id: "app.scope_report_valuepref_integrity_50_strengths_2", 
  defaultMessage: "Capable de rester fidèle à ses valeurs tout en faisant preuve de souplesse." 
},
SCOPE_REPORT_INTEGRITY_PERCENTILE_50_STRENGTHS_3: { 
  id: "app.scope_report_valuepref_integrity_50_strengths_3", 
  defaultMessage: "Sait quand tenir bon et quand faire des compromis acceptables." 
},
SCOPE_REPORT_INTEGRITY_PERCENTILE_50_DEVELOPMENT_INTRO: { 
  id: "app.scope_report_valuepref_integrity_50_development_intro", 
  defaultMessage: "Points de développement :" 
},
SCOPE_REPORT_INTEGRITY_PERCENTILE_50_DEVELOPMENT_1: { 
  id: "app.scope_report_valuepref_integrity_50_development_1", 
  defaultMessage: "Affiner sa boussole personnelle pour mieux communiquer ses limites non négociables." 
},
SCOPE_REPORT_INTEGRITY_PERCENTILE_50_COLLABORATION: {
  id: "app.scope_report_valuepref_integrity_50_collaboration",
  defaultMessage: "Respectez mes valeurs tout en me laissant m'adapter au contexte.",
},
SCOPE_REPORT_INTEGRITY_PERCENTILE_50_MANAGEMENT: {
  id: "app.scope_report_valuepref_integrity_50_management",
  defaultMessage: "Soyez cohérent·e dans vos décisions et vos messages.",
},
SCOPE_REPORT_INTEGRITY_PERCENTILE_50_RECOGNITION: {
  id: "app.scope_report_valuepref_integrity_50_recognition",
  defaultMessage: "Valorisez ma fiabilité et ma capacité d'adaptation éthique.",
},
SCOPE_REPORT_INTEGRITY_PERCENTILE_50_TEAM_ADVICE: {
  id: "app.scope_report_valuepref_integrity_50_team_advice",
  defaultMessage: "Maintenir la cohérence tout en permettant une certaine flexibilité situationnelle.",
},
SCOPE_REPORT_INTEGRITY_PERCENTILE_50_TEAM_KNOW: {
  id: "app.scope_report_valuepref_integrity_50_team_know",
  defaultMessage: "J'ai mes principes mais je sais m'adapter — la cohérence compte plus que la rigidité.",
},

SCOPE_REPORT_INTEGRITY_PERCENTILE_75_TITLE: {
  id: "app.scope_report_valuepref_integrity_75_title",
  defaultMessage: "75e percentil (forte valeur de l'Intégrité / Honneur)",
},
SCOPE_REPORT_INTEGRITY_PERCENTILE_75_STRENGTHS_INTRO: { 
  id: "app.scope_report_valuepref_integrity_75_strengths_intro", 
  defaultMessage: "Ce que la personne apporte :" 
},
SCOPE_REPORT_INTEGRITY_PERCENTILE_75_STRENGTHS_1: { 
  id: "app.scope_report_valuepref_integrity_75_strengths_1", 
  defaultMessage: "Forte cohérence entre ses valeurs, ses paroles et ses actes." 
},
SCOPE_REPORT_INTEGRITY_PERCENTILE_75_STRENGTHS_2: { 
  id: "app.scope_report_valuepref_integrity_75_strengths_2", 
  defaultMessage: "Inspire la confiance par sa transparence et son authenticité." 
},
SCOPE_REPORT_INTEGRITY_PERCENTILE_75_STRENGTHS_3: { 
  id: "app.scope_report_valuepref_integrity_75_strengths_3", 
  defaultMessage: "Excellent·e dans les rôles nécessitant une forte crédibilité." 
},
SCOPE_REPORT_INTEGRITY_PERCENTILE_75_DEVELOPMENT_INTRO: { 
  id: "app.scope_report_valuepref_integrity_75_development_intro", 
  defaultMessage: "Points de développement :" 
},
SCOPE_REPORT_INTEGRITY_PERCENTILE_75_DEVELOPMENT_1: { 
  id: "app.scope_report_valuepref_integrity_75_development_1", 
  defaultMessage: "Apprendre à composer avec les contradictions du monde professionnel sans perdre son authenticité." 
},
SCOPE_REPORT_INTEGRITY_PERCENTILE_75_DEVELOPMENT_2: { 
  id: "app.scope_report_valuepref_integrity_75_development_2", 
  defaultMessage: "Développer une plus grande tolérance aux imperfections des autres." 
},
SCOPE_REPORT_INTEGRITY_PERCENTILE_75_COLLABORATION: {
  id: "app.scope_report_valuepref_integrity_75_collaboration",
  defaultMessage: "Soyez transparent·e et cohérent·e dans vos interactions avec moi.",
},
SCOPE_REPORT_INTEGRITY_PERCENTILE_75_MANAGEMENT: {
  id: "app.scope_report_valuepref_integrity_75_management",
  defaultMessage: "Évitez les double-jeux ou les demandes contradictoires.",
},
SCOPE_REPORT_INTEGRITY_PERCENTILE_75_RECOGNITION: {
  id: "app.scope_report_valuepref_integrity_75_recognition",
  defaultMessage: "Mettez en avant ma fiabilité et ma droiture.",
},
SCOPE_REPORT_INTEGRITY_PERCENTILE_75_TEAM_ADVICE: {
  id: "app.scope_report_valuepref_integrity_75_team_advice",
  defaultMessage: "S'appuyer sur sa droiture tout en l'aidant à accepter les compromis nécessaires.",
},
SCOPE_REPORT_INTEGRITY_PERCENTILE_75_TEAM_KNOW: {
  id: "app.scope_report_valuepref_integrity_75_team_know",
  defaultMessage: "J'ai besoin de cohérence entre ce qu'on dit et ce qu'on fait — la transparence est essentielle.",
},

SCOPE_REPORT_INTEGRITY_PERCENTILE_100_STRENGTHS_INTRO: { id: "app.scope_report_valuepref_integrity_100_strengths_intro", defaultMessage: "Ce que la personne apporte :" },
SCOPE_REPORT_INTEGRITY_PERCENTILE_100_STRENGTHS_1: { id: "app.scope_report_valuepref_integrity_100_strengths_1", defaultMessage: "Très fidèle à ses valeurs, transparence et honnêteté absolue." },
SCOPE_REPORT_INTEGRITY_PERCENTILE_100_STRENGTHS_2: { id: "app.scope_report_valuepref_integrity_100_strengths_2", defaultMessage: "Pilier moral, fiabilité, sincérité." },
SCOPE_REPORT_INTEGRITY_PERCENTILE_100_STRENGTHS_3: { id: "app.scope_report_valuepref_integrity_100_strengths_3", defaultMessage: "Peut jouer un rôle de repère dans les périodes de doute." },


SCOPE_REPORT_INTEGRITY_PERCENTILE_100_DEVELOPMENT_INTRO: { id: "app.scope_report_valuepref_integrity_100_development_intro", defaultMessage: "Points de développement :" },
SCOPE_REPORT_INTEGRITY_PERCENTILE_100_DEVELOPMENT_1: { id: "app.scope_report_valuepref_integrity_100_development_1", defaultMessage: "Travailler une posture plus bienveillante envers soi-même et les autres, tout en gardant ses exigences." },
SCOPE_REPORT_INTEGRITY_PERCENTILE_100_DEVELOPMENT_2: { id: "app.scope_report_valuepref_integrity_100_development_2", defaultMessage: "Apprendre à composer avec certaines décisions stratégiques, même en cas de désalignement partiel, sans perdre de vue ses convictions." },
SCOPE_REPORT_INTEGRITY_PERCENTILE_100_DEVELOPMENT_3: { id: "app.scope_report_valuepref_integrity_100_development_3", defaultMessage: "Accepter la complexité des réalités." },


SCOPE_REPORT_INTEGRITY_PERCENTILE_100_TEAM_ADVICE: {
  id: "app.scope_report_valuepref_integrity_100_team_advice",
  defaultMessage: "Conseil d’équipe : Protéger ses zones de sens, mais lui permettre d’accepter la complexité des réalités.",
},
SCOPE_REPORT_INTEGRITY_PERCENTILE_100_COLLABORATION: {
  id: "app.scope_report_valuepref_integrity_100_collaboration",
  defaultMessage: "Respectez profondément mes valeurs personnelles.",
},
SCOPE_REPORT_INTEGRITY_PERCENTILE_100_MANAGEMENT: {
  id: "app.scope_report_valuepref_integrity_100_management",
  defaultMessage: "Ne tolérez aucune incohérence ou double discours.",
},
SCOPE_REPORT_INTEGRITY_PERCENTILE_100_RECOGNITION: {
  id: "app.scope_report_valuepref_integrity_100_recognition",
  defaultMessage: "Célébrez ma transparence, ma loyauté et mon Intégrité / Honneur absolue.",
},
SCOPE_REPORT_INTEGRITY_PERCENTILE_100_TEAM_KNOW: {
  id: "app.scope_report_valuepref_integrity_100_team_know",
  defaultMessage: "Rester droit·e et cohérent·e quoi qu’il arrive — je ne joue pas un double jeu.",
},

// VALEURS : AFFECTION
SCOPE_REPORT_AFFECTION: {
  id: "app.scope_report_valuepref_affection",
  defaultMessage: "Affection",
},
SCOPE_REPORT_AFFECTION_DESC: {
  id: "app.scope_report_valuepref_affection_desc",
  defaultMessage: "Rechercher des liens chaleureux, bienveillants et sincères au travail. Ces personnes ont besoin d’un climat humain, de relations positives, et aiment prendre soin des autres.",
},
SCOPE_REPORT_AFFECTION_MANAGER_DESC: {
  id: "app.scope_report_valuepref_affection_manager_desc",
  defaultMessage: "un profil motivé par l'affection aura besoin d'un environnement bienveillant, d'attention humaine et de chaleur relationnelle.",
},
SCOPE_REPORT_AFFECTION_DESC_LOW: {
  id: "app.scope_report_valuepref_affection_desc_low",
  defaultMessage: "Besoin de distance plus que de lien. On privilégie le professionnalisme à la proximité affective, et on fonctionne bien sans relations chaleureuses.",
},
SCOPE_REPORT_AFFECTION_MANAGER_DESC_LOW: {
  id: "app.scope_report_valuepref_affection_manager_desc_low",
  defaultMessage: "respecter la distance, éviter de forcer le lien personnel.",
},

SCOPE_REPORT_AFFECTION_PERCENTILE_25_STRENGTHS_INTRO: { id: "app.scope_report_valuepref_affection_25_strengths_intro", defaultMessage: "Ce que la personne apporte :" },
SCOPE_REPORT_AFFECTION_PERCENTILE_25_STRENGTHS_1: { id: "app.scope_report_valuepref_affection_25_strengths_1", defaultMessage: "Plus distant·e, centré·e sur la tâche ou les résultats." },
SCOPE_REPORT_AFFECTION_PERCENTILE_25_STRENGTHS_2: { id: "app.scope_report_valuepref_affection_25_strengths_2", defaultMessage: "Fonctionne bien dans des contextes professionnels froids ou formels." },
SCOPE_REPORT_AFFECTION_PERCENTILE_25_STRENGTHS_3: { id: "app.scope_report_valuepref_affection_25_strengths_3", defaultMessage: "Peu influencé·e par l’affect." },


SCOPE_REPORT_AFFECTION_PERCENTILE_25_DEVELOPMENT_INTRO: { id: "app.scope_report_valuepref_affection_25_development_intro", defaultMessage: "Points de développement :" },
SCOPE_REPORT_AFFECTION_PERCENTILE_25_DEVELOPMENT_1: { id: "app.scope_report_valuepref_affection_25_development_1", defaultMessage: "Cultiver une posture plus chaleureuse et présente pour renforcer la qualité des liens interpersonnels." },
SCOPE_REPORT_AFFECTION_PERCENTILE_25_DEVELOPMENT_2: { id: "app.scope_report_valuepref_affection_25_development_2", defaultMessage: "Développer une attention plus active aux besoins relationnels des autres." },
SCOPE_REPORT_AFFECTION_PERCENTILE_25_DEVELOPMENT_3: { id: "app.scope_report_valuepref_affection_25_development_3", defaultMessage: "Favoriser un climat de confiance." },


SCOPE_REPORT_AFFECTION_PERCENTILE_25_TEAM_ADVICE: {
  id: "app.scope_report_valuepref_affection_25_team_advice",
  defaultMessage: "Conseil d’équipe : Ne pas forcer à créer du lien, mais encourager la reconnaissance et la courtoisie.",
},
SCOPE_REPORT_AFFECTION_PERCENTILE_25_COLLABORATION: {
  id: "app.scope_report_valuepref_affection_25_collaboration",
  defaultMessage: "Respectez ma distance et mon besoin de professionnalisme.",
},
SCOPE_REPORT_AFFECTION_PERCENTILE_25_MANAGEMENT: {
  id: "app.scope_report_valuepref_affection_25_management",
  defaultMessage: "Évitez les relations trop personnelles ou affectives.",
},
SCOPE_REPORT_AFFECTION_PERCENTILE_25_RECOGNITION: {
  id: "app.scope_report_valuepref_affection_25_recognition",
  defaultMessage: "Valorisez ma compétence sans trop d’émotionnel.",
},
SCOPE_REPORT_AFFECTION_PERCENTILE_25_TEAM_KNOW: {
  id: "app.scope_report_valuepref_affection_25_team_know",
  defaultMessage: "Garder de la distance émotionnelle dans le travail.",
},
SCOPE_REPORT_AFFECTION_PERCENTILE_50_TITLE: {
  id: "app.scope_report_valuepref_affection_50_title",
  defaultMessage: "50e percentil (valeur modérée de l'affection)",
},
SCOPE_REPORT_AFFECTION_PERCENTILE_50_STRENGTHS_INTRO: { 
  id: "app.scope_report_valuepref_affection_50_strengths_intro", 
  defaultMessage: "Ce que la personne apporte :" 
},
SCOPE_REPORT_AFFECTION_PERCENTILE_50_STRENGTHS_1: { 
  id: "app.scope_report_valuepref_affection_50_strengths_1", 
  defaultMessage: "Équilibre entre proximité humaine et distance professionnelle." 
},
SCOPE_REPORT_AFFECTION_PERCENTILE_50_STRENGTHS_2: { 
  id: "app.scope_report_valuepref_affection_50_strengths_2", 
  defaultMessage: "Capable de créer du lien sans envahir l'espace des autres." 
},
SCOPE_REPORT_AFFECTION_PERCENTILE_50_STRENGTHS_3: { 
  id: "app.scope_report_valuepref_affection_50_strengths_3", 
  defaultMessage: "Adaptable selon les besoins relationnels du contexte." 
},
SCOPE_REPORT_AFFECTION_PERCENTILE_50_DEVELOPMENT_INTRO: { 
  id: "app.scope_report_valuepref_affection_50_development_intro", 
  defaultMessage: "Points de développement :" 
},
SCOPE_REPORT_AFFECTION_PERCENTILE_50_DEVELOPMENT_1: { 
  id: "app.scope_report_valuepref_affection_50_development_1", 
  defaultMessage: "Clarifier ses besoins relationnels pour mieux les communiquer à l'équipe." 
},
SCOPE_REPORT_AFFECTION_PERCENTILE_50_COLLABORATION: {
  id: "app.scope_report_valuepref_affection_50_collaboration",
  defaultMessage: "Offrez un juste équilibre entre convivialité et professionnalisme.",
},
SCOPE_REPORT_AFFECTION_PERCENTILE_50_MANAGEMENT: {
  id: "app.scope_report_valuepref_affection_50_management",
  defaultMessage: "Maintenez une proximité bienveillante sans tomber dans l'affect.",
},
SCOPE_REPORT_AFFECTION_PERCENTILE_50_RECOGNITION: {
  id: "app.scope_report_valuepref_affection_50_recognition",
  defaultMessage: "Reconnaissez ma contribution avec chaleur mais retenue.",
},
SCOPE_REPORT_AFFECTION_PERCENTILE_50_TEAM_ADVICE: {
  id: "app.scope_report_valuepref_affection_50_team_advice",
  defaultMessage: "Créer une ambiance chaleureuse sans forcer l'intimité.",
},
SCOPE_REPORT_AFFECTION_PERCENTILE_50_TEAM_KNOW: {
  id: "app.scope_report_valuepref_affection_50_team_know",
  defaultMessage: "J'aime les bonnes relations mais sans que ce soit trop personnel.",
},

SCOPE_REPORT_AFFECTION_PERCENTILE_75_TITLE: {
  id: "app.scope_report_valuepref_affection_75_title",
  defaultMessage: "75e percentil (forte valeur de l'affection)",
},
SCOPE_REPORT_AFFECTION_PERCENTILE_75_STRENGTHS_INTRO: { 
  id: "app.scope_report_valuepref_affection_75_strengths_intro", 
  defaultMessage: "Ce que la personne apporte :" 
},
SCOPE_REPORT_AFFECTION_PERCENTILE_75_STRENGTHS_1: { 
  id: "app.scope_report_valuepref_affection_75_strengths_1", 
  defaultMessage: "Fort investissement relationnel, créateur·rice de liens durables." 
},
SCOPE_REPORT_AFFECTION_PERCENTILE_75_STRENGTHS_2: { 
  id: "app.scope_report_valuepref_affection_75_strengths_2", 
  defaultMessage: "Apporte chaleur, soutien et cohésion à l'équipe." 
},
SCOPE_REPORT_AFFECTION_PERCENTILE_75_STRENGTHS_3: { 
  id: "app.scope_report_valuepref_affection_75_strengths_3", 
  defaultMessage: "Excellent·e pour maintenir le moral et la motivation collective." 
},
SCOPE_REPORT_AFFECTION_PERCENTILE_75_DEVELOPMENT_INTRO: { 
  id: "app.scope_report_valuepref_affection_75_development_intro", 
  defaultMessage: "Points de développement :" 
},
SCOPE_REPORT_AFFECTION_PERCENTILE_75_DEVELOPMENT_1: { 
  id: "app.scope_report_valuepref_affection_75_development_1", 
  defaultMessage: "Apprendre à prendre du recul émotionnel pour éviter l'épuisement relationnel." 
},
SCOPE_REPORT_AFFECTION_PERCENTILE_75_DEVELOPMENT_2: { 
  id: "app.scope_report_valuepref_affection_75_development_2", 
  defaultMessage: "Développer son autonomie affective pour moins dépendre de l'approbation des autres." 
},
SCOPE_REPORT_AFFECTION_PERCENTILE_75_COLLABORATION: {
  id: "app.scope_report_valuepref_affection_75_collaboration",
  defaultMessage: "Créez un environnement chaleureux où je peux m'épanouir relationnellement.",
},
SCOPE_REPORT_AFFECTION_PERCENTILE_75_MANAGEMENT: {
  id: "app.scope_report_valuepref_affection_75_management",
  defaultMessage: "Investissez la relation, montrez votre bienveillance personnelle.",
},
SCOPE_REPORT_AFFECTION_PERCENTILE_75_RECOGNITION: {
  id: "app.scope_report_valuepref_affection_75_recognition",
  defaultMessage: "Exprimez votre reconnaissance avec sincérité et chaleur humaine.",
},
SCOPE_REPORT_AFFECTION_PERCENTILE_75_TEAM_ADVICE: {
  id: "app.scope_report_valuepref_affection_75_team_advice",
  defaultMessage: "Nourrir le lien affectif tout en préservant les limites professionnelles.",
},
SCOPE_REPORT_AFFECTION_PERCENTILE_75_TEAM_KNOW: {
  id: "app.scope_report_valuepref_affection_75_team_know",
  defaultMessage: "J'ai besoin de sentir qu'on tient à moi en tant que personne, pas seulement comme collaborateur·rice.",
},

SCOPE_REPORT_AFFECTION_PERCENTILE_100_STRENGTHS_INTRO: { id: "app.scope_report_valuepref_affection_100_strengths_intro", defaultMessage: "Ce que la personne apporte :" },
SCOPE_REPORT_AFFECTION_PERCENTILE_100_STRENGTHS_1: { id: "app.scope_report_valuepref_affection_100_strengths_1", defaultMessage: "Très centré·e sur les liens affectifs, donne beaucoup." },
SCOPE_REPORT_AFFECTION_PERCENTILE_100_STRENGTHS_2: { id: "app.scope_report_valuepref_affection_100_strengths_2", defaultMessage: "S’investit dans les personnes autant que dans le travail." },
SCOPE_REPORT_AFFECTION_PERCENTILE_100_STRENGTHS_3: { id: "app.scope_report_valuepref_affection_100_strengths_3", defaultMessage: "Source d’amour du collectif et de soin relationnel." },


SCOPE_REPORT_AFFECTION_PERCENTILE_100_DEVELOPMENT_INTRO: { id: "app.scope_report_valuepref_affection_100_development_intro", defaultMessage: "Points de développement :" },
SCOPE_REPORT_AFFECTION_PERCENTILE_100_DEVELOPMENT_1: { id: "app.scope_report_valuepref_affection_100_development_1", defaultMessage: "Apprendre à mieux gérer l’impact émotionnel des tensions, rejets ou signes d’indifférence." },
SCOPE_REPORT_AFFECTION_PERCENTILE_100_DEVELOPMENT_2: { id: "app.scope_report_valuepref_affection_100_development_2", defaultMessage: "Renforcer son autonomie émotionnelle pour ne pas dépendre excessivement du regard ou du soutien des autres." },
SCOPE_REPORT_AFFECTION_PERCENTILE_100_DEVELOPMENT_3: { id: "app.scope_report_valuepref_affection_100_development_3", defaultMessage: "Fixer des limites saines dans la proximité." },


SCOPE_REPORT_AFFECTION_PERCENTILE_100_TEAM_ADVICE: {
  id: "app.scope_report_valuepref_affection_100_team_advice",
  defaultMessage: "Conseil d’équipe : Soutenir émotionnellement, mais fixer des limites si la proximité devient pesante.",
},
SCOPE_REPORT_AFFECTION_PERCENTILE_100_COLLABORATION: {
  id: "app.scope_report_valuepref_affection_100_collaboration",
  defaultMessage: "Faites-moi sentir que je suis apprécié·e, humainement autant que professionnellement.",
},
SCOPE_REPORT_AFFECTION_PERCENTILE_100_MANAGEMENT: {
  id: "app.scope_report_valuepref_affection_100_management",
  defaultMessage: "Créez un lien affectif et empathique dans le suivi.",
},
SCOPE_REPORT_AFFECTION_PERCENTILE_100_RECOGNITION: {
  id: "app.scope_report_valuepref_affection_100_recognition",
  defaultMessage: "Exprimez votre gratitude avec chaleur et attention personnelle.",
},
SCOPE_REPORT_AFFECTION_PERCENTILE_100_TEAM_KNOW: {
  id: "app.scope_report_valuepref_affection_100_team_know",
  defaultMessage: "Créer des liens affectifs profonds — j’ai besoin de connexion humaine.",
},

// VALEURS : HARMONIE
SCOPE_REPORT_HARMONY: {
  id: "app.scope_report_valuepref_harmony",
  defaultMessage: "Harmonie",
},
SCOPE_REPORT_HARMONY_DESC: {
  id: "app.scope_report_valuepref_harmony_desc",
  defaultMessage: "Le besoin de relations fluides, de collaboration sans tension, et de paix dans l’environnement de travail. Ces personnes évitent les conflits, privilégient le dialogue et veulent contribuer à une ambiance saine.",
},
SCOPE_REPORT_HARMONY_MANAGER_DESC: {
  id: "app.scope_report_valuepref_harmony_manager_desc",
  defaultMessage: "un profil motivé par l'harmonie va chercher à apaiser, créer du lien et maintenir un climat serein.",
},
SCOPE_REPORT_HARMONY_DESC_LOW: {
  id: "app.scope_report_valuepref_harmony_desc_low",
  defaultMessage: "Besoin de clarté plus que de paix. On préfère la vérité directe à l'évitement des tensions, et on sait gérer les conflits sans inconfort.",
},
SCOPE_REPORT_HARMONY_MANAGER_DESC_LOW: {
  id: "app.scope_report_valuepref_harmony_manager_desc_low",
  defaultMessage: "parler franchement, ne pas craindre les désaccords.",
},
SCOPE_REPORT_HARMONY_PERCENTILE_25_STRENGTHS_INTRO: { id: "app.scope_report_valuepref_harmony_25_strengths_intro", defaultMessage: "Ce que la personne apporte :" },
SCOPE_REPORT_HARMONY_PERCENTILE_25_STRENGTHS_1: { id: "app.scope_report_valuepref_harmony_25_strengths_1", defaultMessage: "Capable d’aborder les conflits de face sans inconfort." },
SCOPE_REPORT_HARMONY_PERCENTILE_25_STRENGTHS_2: { id: "app.scope_report_valuepref_harmony_25_strengths_2", defaultMessage: "Peut trancher, confronter ou dire les choses franchement." },
SCOPE_REPORT_HARMONY_PERCENTILE_25_STRENGTHS_3: { id: "app.scope_report_valuepref_harmony_25_strengths_3", defaultMessage: "Utile dans les contextes de changement ou de crise." },


SCOPE_REPORT_HARMONY_PERCENTILE_25_DEVELOPMENT_INTRO: { id: "app.scope_report_valuepref_harmony_25_development_intro", defaultMessage: "Points de développement :" },
SCOPE_REPORT_HARMONY_PERCENTILE_25_DEVELOPMENT_1: { id: "app.scope_report_valuepref_harmony_25_development_1", defaultMessage: "Travailler sa manière de communiquer pour faire passer ses messages avec plus de tact et de diplomatie." },
SCOPE_REPORT_HARMONY_PERCENTILE_25_DEVELOPMENT_2: { id: "app.scope_report_valuepref_harmony_25_development_2", defaultMessage: "Développer une plus grande aisance dans les dynamiques de groupe sensibles ou fragiles." },
SCOPE_REPORT_HARMONY_PERCENTILE_25_DEVELOPMENT_3: { id: "app.scope_report_valuepref_harmony_25_development_3", defaultMessage: "Renforcer l’écoute active." },


SCOPE_REPORT_HARMONY_PERCENTILE_25_TEAM_ADVICE: {
  id: "app.scope_report_valuepref_harmony_25_team_advice",
  defaultMessage: "Conseil d’équipe : Valoriser son franc-parler tout en renforçant l’écoute active.",
},
SCOPE_REPORT_HARMONY_PERCENTILE_25_COLLABORATION: {
  id: "app.scope_report_valuepref_harmony_25_collaboration",
  defaultMessage: "Ne craignez pas la confrontation avec moi.",
},
SCOPE_REPORT_HARMONY_PERCENTILE_25_MANAGEMENT: {
  id: "app.scope_report_valuepref_harmony_25_management",
  defaultMessage: "Soyez direct·e, clair·e, même dans les désaccords.",
},
SCOPE_REPORT_HARMONY_PERCENTILE_25_RECOGNITION: {
  id: "app.scope_report_valuepref_harmony_25_recognition",
  defaultMessage: "Félicitez ma capacité à dire les choses franchement.",
},
SCOPE_REPORT_HARMONY_PERCENTILE_25_TEAM_KNOW: {
  id: "app.scope_report_valuepref_harmony_25_team_know",
  defaultMessage: "Pouvoir dire les choses franchement, même si ça secoue.",
},
SCOPE_REPORT_HARMONY_PERCENTILE_50_TITLE: {
  id: "app.scope_report_valuepref_harmony_50_title",
  defaultMessage: "50e percentil (valeur modérée de l'harmonie)",
},
SCOPE_REPORT_HARMONY_PERCENTILE_50_STRENGTHS_INTRO: { 
  id: "app.scope_report_valuepref_harmony_50_strengths_intro", 
  defaultMessage: "Ce que la personne apporte :" 
},
SCOPE_REPORT_HARMONY_PERCENTILE_50_STRENGTHS_1: { 
  id: "app.scope_report_valuepref_harmony_50_strengths_1", 
  defaultMessage: "Équilibre entre préservation de l'harmonie et capacité à affronter les conflits." 
},
SCOPE_REPORT_HARMONY_PERCENTILE_50_STRENGTHS_2: { 
  id: "app.scope_report_valuepref_harmony_50_strengths_2", 
  defaultMessage: "Sait quand chercher le consensus et quand trancher." 
},
SCOPE_REPORT_HARMONY_PERCENTILE_50_STRENGTHS_3: { 
  id: "app.scope_report_valuepref_harmony_50_strengths_3", 
  defaultMessage: "Capable de naviguer dans les tensions sans les éviter systématiquement." 
},
SCOPE_REPORT_HARMONY_PERCENTILE_50_DEVELOPMENT_INTRO: { 
  id: "app.scope_report_valuepref_harmony_50_development_intro", 
  defaultMessage: "Points de développement :" 
},
SCOPE_REPORT_HARMONY_PERCENTILE_50_DEVELOPMENT_1: { 
  id: "app.scope_report_valuepref_harmony_50_development_1", 
  defaultMessage: "Affiner sa lecture des situations pour mieux choisir entre diplomatie et confrontation constructive." 
},
SCOPE_REPORT_HARMONY_PERCENTILE_50_COLLABORATION: {
  id: "app.scope_report_valuepref_harmony_50_collaboration",
  defaultMessage: "Favorisez le dialogue tout en acceptant les désaccords constructifs.",
},
SCOPE_REPORT_HARMONY_PERCENTILE_50_MANAGEMENT: {
  id: "app.scope_report_valuepref_harmony_50_management",
  defaultMessage: "Maintenez un cadre respectueux pour les divergences d'opinions.",
},
SCOPE_REPORT_HARMONY_PERCENTILE_50_RECOGNITION: {
  id: "app.scope_report_valuepref_harmony_50_recognition",
  defaultMessage: "Valorisez ma capacité à maintenir l'équilibre dans l'équipe.",
},
SCOPE_REPORT_HARMONY_PERCENTILE_50_TEAM_ADVICE: {
  id: "app.scope_report_valuepref_harmony_50_team_advice",
  defaultMessage: "Encourager la recherche de solutions équilibrées, en évitant l'évitement systématique.",
},
SCOPE_REPORT_HARMONY_PERCENTILE_50_TEAM_KNOW: {
  id: "app.scope_report_valuepref_harmony_50_team_know",
  defaultMessage: "J'aime l'harmonie mais je peux gérer les conflits si c'est constructif.",
},

SCOPE_REPORT_HARMONY_PERCENTILE_75_TITLE: {
  id: "app.scope_report_valuepref_harmony_75_title",
  defaultMessage: "75e percentil (forte valeur de l'harmonie)",
},
SCOPE_REPORT_HARMONY_PERCENTILE_75_STRENGTHS_INTRO: { 
  id: "app.scope_report_valuepref_harmony_75_strengths_intro", 
  defaultMessage: "Ce que la personne apporte :" 
},
SCOPE_REPORT_HARMONY_PERCENTILE_75_STRENGTHS_1: { 
  id: "app.scope_report_valuepref_harmony_75_strengths_1", 
  defaultMessage: "Forte capacité de médiation et de recherche de consensus." 
},
SCOPE_REPORT_HARMONY_PERCENTILE_75_STRENGTHS_2: { 
  id: "app.scope_report_valuepref_harmony_75_strengths_2", 
  defaultMessage: "Créateur·rice d'ambiances apaisées et collaboratives." 
},
SCOPE_REPORT_HARMONY_PERCENTILE_75_STRENGTHS_3: { 
  id: "app.scope_report_valuepref_harmony_75_strengths_3", 
  defaultMessage: "Excellent·e pour désamorcer les tensions et fédérer." 
},
SCOPE_REPORT_HARMONY_PERCENTILE_75_DEVELOPMENT_INTRO: { 
  id: "app.scope_report_valuepref_harmony_75_development_intro", 
  defaultMessage: "Points de développement :" 
},
SCOPE_REPORT_HARMONY_PERCENTILE_75_DEVELOPMENT_1: { 
  id: "app.scope_report_valuepref_harmony_75_development_1", 
  defaultMessage: "Apprendre à exprimer ses désaccords sans crainte de briser l'harmonie." 
},
SCOPE_REPORT_HARMONY_PERCENTILE_75_DEVELOPMENT_2: { 
  id: "app.scope_report_valuepref_harmony_75_development_2", 
  defaultMessage: "Développer sa capacité à gérer les conflits nécessaires plutôt que de les éviter." 
},
SCOPE_REPORT_HARMONY_PERCENTILE_75_COLLABORATION: {
  id: "app.scope_report_valuepref_harmony_75_collaboration",
  defaultMessage: "Créez un climat serein et respectueux pour tous.",
},
SCOPE_REPORT_HARMONY_PERCENTILE_75_MANAGEMENT: {
  id: "app.scope_report_valuepref_harmony_75_management",
  defaultMessage: "Évitez les confrontations brutales, privilégiez le dialogue.",
},
SCOPE_REPORT_HARMONY_PERCENTILE_75_RECOGNITION: {
  id: "app.scope_report_valuepref_harmony_75_recognition",
  defaultMessage: "Mettez en avant mon rôle d'artisan·e de la cohésion d'équipe.",
},
SCOPE_REPORT_HARMONY_PERCENTILE_75_TEAM_ADVICE: {
  id: "app.scope_report_valuepref_harmony_75_team_advice",
  defaultMessage: "S'appuyer sur sa capacité de médiation tout en l'encourager à s'affirmer.",
},
SCOPE_REPORT_HARMONY_PERCENTILE_75_TEAM_KNOW: {
  id: "app.scope_report_valuepref_harmony_75_team_know",
  defaultMessage: "J'ai vraiment besoin d'une ambiance sereine — les tensions me paralysent.",
},
SCOPE_REPORT_HARMONY_PERCENTILE_100_STRENGTHS_INTRO: { id: "app.scope_report_valuepref_harmony_100_strengths_intro", defaultMessage: "Ce que la personne apporte :" },
SCOPE_REPORT_HARMONY_PERCENTILE_100_STRENGTHS_1: { id: "app.scope_report_valuepref_harmony_100_strengths_1", defaultMessage: "Très pacificateur·rice, apaise les tensions, cherche constamment l’équilibre." },
SCOPE_REPORT_HARMONY_PERCENTILE_100_STRENGTHS_2: { id: "app.scope_report_valuepref_harmony_100_strengths_2", defaultMessage: "Fait passer l’entente avant tout." },
SCOPE_REPORT_HARMONY_PERCENTILE_100_STRENGTHS_3: { id: "app.scope_report_valuepref_harmony_100_strengths_3", defaultMessage: "Souvent fédérateur·rice dans des équipes plurielles." },


SCOPE_REPORT_HARMONY_PERCENTILE_100_DEVELOPMENT_INTRO: { id: "app.scope_report_valuepref_harmony_100_development_intro", defaultMessage: "Points de développement :" },
SCOPE_REPORT_HARMONY_PERCENTILE_100_DEVELOPMENT_1: { id: "app.scope_report_valuepref_harmony_100_development_1", defaultMessage: "Travailler l’affirmation de soi pour oser exprimer ses idées, même au risque de bousculer l’harmonie." },
SCOPE_REPORT_HARMONY_PERCENTILE_100_DEVELOPMENT_2: { id: "app.scope_report_valuepref_harmony_100_development_2", defaultMessage: "Apprendre à préserver ses convictions personnelles tout en restant dans une dynamique relationnelle positive." },
SCOPE_REPORT_HARMONY_PERCENTILE_100_DEVELOPMENT_3: { id: "app.scope_report_valuepref_harmony_100_development_3", defaultMessage: "Accepter que le conflit peut être constructif." },


SCOPE_REPORT_HARMONY_PERCENTILE_100_TEAM_ADVICE: {
  id: "app.scope_report_valuepref_harmony_100_team_advice",
  defaultMessage: "Conseil d’équipe : Encourager à exprimer ses désaccords sans peur du conflit, avec des règles de discussion.",
},
SCOPE_REPORT_HARMONY_PERCENTILE_100_COLLABORATION: {
  id: "app.scope_report_valuepref_harmony_100_collaboration",
  defaultMessage: "Évitez les conflits brutaux, proposez des solutions conciliantes.",
},
SCOPE_REPORT_HARMONY_PERCENTILE_100_MANAGEMENT: {
  id: "app.scope_report_valuepref_harmony_100_management",
  defaultMessage: "Protégez l’harmonie du groupe, impliquez-moi en cas de tension.",
},
SCOPE_REPORT_HARMONY_PERCENTILE_100_RECOGNITION: {
  id: "app.scope_report_valuepref_harmony_100_recognition",
  defaultMessage: "Soulignez mon rôle de pacificateur·rice et de ciment du collectif.",
},
SCOPE_REPORT_HARMONY_PERCENTILE_100_TEAM_KNOW: {
  id: "app.scope_report_valuepref_harmony_100_team_know",
  defaultMessage: "Préserver la paix à tout prix — les tensions me bloquent totalement.",
},
SCOPE_REPORT_MANAGER_SUMMARY_LABEL: {
  id: "app.scope_report_manager_summary_label",
  defaultMessage: "En résumé pour un manager :  ",
},
// --- Coping Table: Modification de soi ---
SCOPE_REPORT_COPING_SELF_MODIFICATION: {
  id: "app.scope_report_coping_self_modification",
  defaultMessage: "Modification de soi"
},
SCOPE_REPORT_COPING_SELF_MODIFICATION_DESC: {
  id: "app.scope_report_coping_self_modification_desc",
  defaultMessage: "Savoir modifier et adapter ses envies et besoins face à une crise pour assumer les conséquences"
},
SCOPE_REPORT_COPING_SELF_MODIFICATION_STRENGTHS: {
  id: "app.scope_report_coping_self_modification_strengths",
  defaultMessage: "Résilience : capacité à faire face et à rebondir<br />Maîtrise : fait preuve de stabilité et d’équilibre émotionnel"
},
SCOPE_REPORT_COPING_SELF_MODIFICATION_LIMITS: {
  id: "app.scope_report_coping_self_modification_limits",
  defaultMessage: "Auto-effacement : peut nuire à ses envies et besoins sur du long terme<br />Epuisement : s’adapter est aussi difficile et fatiguant sur du long terme"
},

// --- Coping Table: Appropriation ---
SCOPE_REPORT_COPING_INTERNAL_ATTRIBUTION: {
  id: "app.scope_report_coping_internal_attribution",
  defaultMessage: "Appropriation"
},
SCOPE_REPORT_COPING_INTERNAL_ATTRIBUTION_DESC: {
  id: "app.scope_report_coping_internal_attribution_desc",
  defaultMessage: "Déterminer son rôle et l’impact que l’on a dans un problème existant"
},
SCOPE_REPORT_COPING_INTERNAL_ATTRIBUTION_STRENGTHS: {
  id: "app.scope_report_coping_internal_attribution_strengths",
  defaultMessage: "Réaliste : voit les choses tels quel sont, sans exagérer ni idéaliser<br />Investi : s’implique pleinement dans ce qu’il fait"
},
SCOPE_REPORT_COPING_INTERNAL_ATTRIBUTION_LIMITS: {
  id: "app.scope_report_coping_internal_attribution_limits",
  defaultMessage: "Sur-responsable : tendance à prendre trop en charge, sentiment de devoir et d’obligation<br />Illusoire : image idéalisée de soi"
},

// --- Coping Table: Renforcement de l’estime de soi ---
SCOPE_REPORT_COPING_SELF_BOLSTERING: {
  id: "app.scope_report_coping_self_bolstering",
  defaultMessage: "Renforcement de l’estime de soi"
},
SCOPE_REPORT_COPING_SELF_BOLSTERING_DESC: {
  id: "app.scope_report_coping_self_bolstering_desc",
  defaultMessage: "Se rassurer et ne pas laisser les conséquences extérieures nous affecter"
},
SCOPE_REPORT_COPING_SELF_BOLSTERING_STRENGTHS: {
  id: "app.scope_report_coping_self_bolstering_strengths",
  defaultMessage: "Confiance : sentiment de sécurité et de certitude<br />Equanimité : reste stable et serein face aux hauts et au bas du quotidien"
},
SCOPE_REPORT_COPING_SELF_BOLSTERING_LIMITS: {
  id: "app.scope_report_coping_self_bolstering_limits",
  defaultMessage: "Utopiste : s’imagine un monde idéal et manque de réalisme<br />Passivité : manque de réaction face aux événements à prendre en main"
},

// --- Coping Table: Résolution de problèmes ---
SCOPE_REPORT_COPING_PROBLEM_SOLVING: {
  id: "app.scope_report_coping_problem_solving",
  defaultMessage: "Résolution de problèmes"
},
SCOPE_REPORT_COPING_PROBLEM_SOLVING_DESC: {
  id: "app.scope_report_coping_problem_solving_desc",
  defaultMessage: "Capacité d’évaluer toutes les options et déterminer la meilleure solution pour un cas précis"
},
SCOPE_REPORT_COPING_PROBLEM_SOLVING_STRENGTHS: {
  id: "app.scope_report_coping_problem_solving_strengths",
  defaultMessage: "Analytique : capacité à analyser des situations complexes<br />Créatif : stimule l’innovation et la pensée originale"
},
SCOPE_REPORT_COPING_PROBLEM_SOLVING_LIMITS: {
  id: "app.scope_report_coping_problem_solving_limits",
  defaultMessage: "Chronophage : demande parfois du temps sans garantie de résultat<br />Subjectif : dépend de la perception de chacun"
},

// --- Coping Table: Rumination ---
SCOPE_REPORT_COPING_RUMINATION: {
  id: "app.scope_report_coping_rumination",
  defaultMessage: "Rumination"
},
SCOPE_REPORT_COPING_RUMINATION_DESC: {
  id: "app.scope_report_coping_rumination_desc",
  defaultMessage: "Être constamment en réflexion sur un sujet"
},
SCOPE_REPORT_COPING_RUMINATION_STRENGTHS: {
  id: "app.scope_report_coping_rumination_strengths",
  defaultMessage: "Instructif : apprendre de ses erreurs et expériences<br />Implication : démontre un intérêt profond pour les évènements"
},
SCOPE_REPORT_COPING_RUMINATION_LIMITS: {
  id: "app.scope_report_coping_rumination_limits",
  defaultMessage: "Envahissant : focalise l’attention sur un seul sujet au détriment du reste<br />Anxiogène : augmente l’anxiété en exagérant les scénarios/faits"
},

// --- Coping Table: Pensée magique ---
SCOPE_REPORT_COPING_WISHFUL_THINKING: {
  id: "app.scope_report_coping_wishful_thinking",
  defaultMessage: "Pensée magique"
},
SCOPE_REPORT_COPING_WISHFUL_THINKING_DESC: {
  id: "app.scope_report_coping_wishful_thinking_desc",
  defaultMessage: "Ne pas s’impliquer dans un problème pensant qu’il se résoudra sans notre intervention"
},
SCOPE_REPORT_COPING_WISHFUL_THINKING_STRENGTHS: {
  id: "app.scope_report_coping_wishful_thinking_strengths",
  defaultMessage: "Optimisme : ne dramatise pas les situations et reste serein en toute circonstance"
},
SCOPE_REPORT_COPING_WISHFUL_THINKING_LIMITS: {
  id: "app.scope_report_coping_wishful_thinking_limits",
  defaultMessage: "Naïveté : manque de réalisme et sous-estime les risques et obstacles<br />Complaisant : accepte des situations médiocres"
},

SCOPE_REPORT_COPING_PROBLEM_FOCUSED_AXIS_HIGH: {
  id: "app.scope_report_coping_problem_focused_axis_high",
  defaultMessage: "Orientation vers le problème (élevé)"
},
SCOPE_REPORT_COPING_PROBLEM_FOCUSED_AXIS_HIGH_DESC: {
  id: "app.scope_report_coping_problem_focused_axis_high_desc",
  defaultMessage: "Définition pour orientation vers le problème élevé."
},
SCOPE_REPORT_COPING_PROBLEM_FOCUSED_AXIS_LOW: {
  id: "app.scope_report_coping_problem_focused_axis_low",
  defaultMessage: "Orientation vers le problème (faible)"
},
SCOPE_REPORT_COPING_PROBLEM_FOCUSED_AXIS_LOW_DESC: {
  id: "app.scope_report_coping_problem_focused_axis_low_desc",
  defaultMessage: "Définition pour orientation vers le problème faible."
},
SCOPE_REPORT_COPING_EMOTION_FOCUSED_AXIS_HIGH: {
  id: "app.scope_report_coping_emotion_focused_axis_high",
  defaultMessage: "Orientation vers l'émotion (élevé)"
},
SCOPE_REPORT_COPING_EMOTION_FOCUSED_AXIS_HIGH_DESC: {
  id: "app.scope_report_coping_emotion_focused_axis_high_desc",
  defaultMessage: "Définition pour orientation vers l'émotion élevée."
},
SCOPE_REPORT_COPING_EMOTION_FOCUSED_AXIS_LOW: {
  id: "app.scope_report_coping_emotion_focused_axis_low",
  defaultMessage: "Orientation vers l'émotion (faible)"
},
SCOPE_REPORT_COPING_EMOTION_FOCUSED_AXIS_LOW_DESC: {
  id: "app.scope_report_coping_emotion_focused_axis_low_desc",
  defaultMessage: "Définition pour orientation vers l'émotion faible."
},
SCOPE_REPORT_COPING_AVOIDANCE_AXIS_HIGH: {
  id: "app.scope_report_coping_avoidance_axis_high",
  defaultMessage: "Évitement (élevé)"
},
SCOPE_REPORT_COPING_AVOIDANCE_AXIS_HIGH_DESC: {
  id: "app.scope_report_coping_avoidance_axis_high_desc",
  defaultMessage: "Définition pour évitement élevé."
},
SCOPE_REPORT_COPING_AVOIDANCE_AXIS_LOW: {
  id: "app.scope_report_coping_avoidance_axis_low",
  defaultMessage: "Évitement (faible)"
},
SCOPE_REPORT_COPING_AVOIDANCE_AXIS_LOW_DESC: {
  id: "app.scope_report_coping_avoidance_axis_low_desc",
  defaultMessage: "Définition pour évitement faible."
},
SCOPE_REPORT_COPING_SELF_TITLE: {
  id: "app.scope_report_coping_self_title",
  defaultMessage: "Coping impliquant soi-même"
},
SCOPE_REPORT_COPING_COGNITIVE_TITLE: {
  id: "app.scope_report_coping_cognitive_title",
  defaultMessage: "Coping cognitif"
},
SCOPE_REPORT_COPING_STRATEGY: {
  id: "app.scope_report_coping_strategy",
  defaultMessage: "Stratégie de coping"
},
SCOPE_REPORT_COPING_EXPLANATION: {
  id: "app.scope_report_coping_explanation",
  defaultMessage: "Explication"
},
SCOPE_REPORT_COPING_STRENGTHS: {
  id: "app.scope_report_coping_strengths",
  defaultMessage: "Forces"
},
SCOPE_REPORT_COPING_LIMITS: {
  id: "app.scope_report_coping_limits",
  defaultMessage: "Limites"
},
SCOPE_REPORT_COPING_NOTE: {
  id: "app.scope_report_coping_note",
  defaultMessage: "Note"
},

SCOPE_REPORT_COPING_SOCIAL_SUPPORT: {
  id: "app.scope_report_coping_social_support",
  defaultMessage: "Recherche de support social"
},
SCOPE_REPORT_COPING_SOCIAL_SUPPORT_DESC: {
  id: "app.scope_report_coping_social_support_desc",
  defaultMessage: "Tendance à rechercher l'aide, le conseil, l'information ou le réconfort matériel ou émotionnel auprès de son réseau social (collègues, amis, famille, mentors)."
},
SCOPE_REPORT_COPING_SOCIAL_SUPPORT_STRENGTHS: {
  id: "app.scope_report_coping_social_support_strengths",
  defaultMessage: "- C'est une ressource précieuse pour obtenir de l'aide concrète, du soutien émotionnel, ou de nouvelles perspectives sur un problème.<br />- Permet de mutualiser les ressources"
},
SCOPE_REPORT_COPING_SOCIAL_SUPPORT_LIMITS: {
  id: "app.scope_report_coping_social_support_limits",
  defaultMessage: "- Risque de dépendance si cette stratégie est exclusive.<br />- Il est important de bien choisir ses \"supporters\"<br />- Difficulté à demander de l'aide pour certaines personnes (peur de déranger, de paraître faible)."
},

SCOPE_REPORT_COPING_EMPATHY_SEEKING: {
  id: "app.scope_report_coping_empathy_seeking",
  defaultMessage: "Recherche d’empathie"
},
SCOPE_REPORT_COPING_EMPATHY_SEEKING_DESC: {
  id: "app.scope_report_coping_empathy_seeking_desc",
  defaultMessage: "Tendance à chercher auprès d'autrui la compréhension, la validation et le partage de ses états émotionnels avec les autres."
},
SCOPE_REPORT_COPING_EMPATHY_SEEKING_STRENGTHS: {
  id: "app.scope_report_coping_empathy_seeking_strengths",
  defaultMessage: "- Permet de se sentir compris(e), soutenu(e) et moins seul(e), ce qui peut soulager la détresse émotionnelle.<br />- Partager vos ressentis peut vous aider à normaliser votre expérience<br />- Peut renforcer les liens sociaux et la confiance"
},
SCOPE_REPORT_COPING_EMPATHY_SEEKING_LIMITS: {
  id: "app.scope_report_coping_empathy_seeking_limits",
  defaultMessage: "- Risque de devenir dépendant(e) de la validation externe pour gérer ses émotions.<br />- Peut maintenir dans un état passif.<br />- Peut être épuisant pour l'entourage"
},

SCOPE_REPORT_COPING_EMOTION_SUPPRESSION: {
  id: "app.scope_report_coping_emotion_suppression",
  defaultMessage: "Suppression de l’émotion"
},
SCOPE_REPORT_COPING_EMOTION_SUPPRESSION_DESC: {
  id: "app.scope_report_coping_emotion_suppression_desc",
  defaultMessage: "Tendance à inhiber, minimiser ou éviter consciemment l'expression ou la prise de conscience de ses émotions face à une situation stressante."
},
SCOPE_REPORT_COPING_EMOTION_SUPPRESSION_STRENGTHS: {
  id: "app.scope_report_coping_emotion_suppression_strengths",
  defaultMessage: "- Peut être utile temporairement dans des situations d'urgence où une action immédiate et rationnelle est requise, permettant de \"garder la tête froide\" pour agir.<br />- Peut aider à maintenir une façade professionnelle dans des contextes où l'expression émotionnelle intense est inappropriée, le temps de trouver un espace pour les gérer"
},
SCOPE_REPORT_COPING_EMOTION_SUPPRESSION_LIMITS: {
  id: "app.scope_report_coping_emotion_suppression_limits",
  defaultMessage: "- Les émotions refoulées ont tendance à resurgir<br />- Peut mener à un coût physiologique (stress chronique) et psychologique (difficulté à se connecter à soi et aux autres).<br />- Empêche de tirer les enseignements que les émotions peuvent apporter<br />- Peut être perçu par les autres comme de la froideur ou un manque d'empathie."
},
SCOPE_REPORT_COPING_OTHERS_TITLE: {
  id: "app.scope_report_coping_others_title",
  defaultMessage: "Coping impliquant autrui"
},
ATTITUDES_REPORT_TITLE: {
  id: "app.attitudes_report_title",
  defaultMessage: "Attitudes Assessment Report"
},
ATTITUDES_ASSESSMENT_FOR_CANDIDATE: {
  id: "app.attitudes_assessment_for_candidate",
  defaultMessage: "Assessment for candidate:"
},
ATTITUDES_REPORT_GENERATED_ON: {
  id: "app.attitudes_report_generated_on",
  defaultMessage: "Report generated on"
},
ATTITUDES_FUNDAMENTAL_ATTITUDES: {
  id: "app.attitudes_fundamental_attitudes",
  defaultMessage: "Fundamental Attitudes"
},
ATTITUDES_FUNDAMENTAL_ATTITUDES_DESC: {
  id: "app.attitudes_fundamental_attitudes_desc",
  defaultMessage: "The fundamental attitudes as defined and described by Patek Philippe aim to:"
},
ATTITUDES_CLARIFY_EXPECTED_BEHAVIORS: {
  id: "app.attitudes_clarify_expected_behaviors",
  defaultMessage: "Clarify expected behaviors."
},
ATTITUDES_FACILITATE_COMMON_LIFE: {
  id: "app.attitudes_facilitate_common_life",
  defaultMessage: "Facilitate the \"common life\" by providing a reference framework for our behaviors."
},
ATTITUDES_HARMONIZE_ACTIONS: {
  id: "app.attitudes_harmonize_actions",
  defaultMessage: "Allow harmonizing the way things are done so that everyone moves in the same direction (alignment)."
},
ATTITUDES_KEY_STAGE_EMPLOYEE_LIFECYCLE: {
  id: "app.attitudes_key_stage_employee_lifecycle",
  defaultMessage: "Constitute a key stage in the employee's life cycle: recruitment, integration, performance management and development."
},
ATTITUDES_FIVE_ATTITUDES: {
  id: "app.attitudes_five_attitudes",
  defaultMessage: "The fundamental attitudes are five in number:"
},
ATTITUDES_QUALITY_NAME: {
  id: "app.attitudes_quality_name",
  defaultMessage: "Quality"
},
ATTITUDES_QUALITY_DESC: {
  id: "app.attitudes_quality_desc",
  defaultMessage: "\"I am proud of the quality of my work\""
},
ATTITUDES_RESPECT_NAME: {
  id: "app.attitudes_respect_name",
  defaultMessage: "Respect"
},
ATTITUDES_RESPECT_DESC: {
  id: "app.attitudes_respect_desc",
  defaultMessage: "\"I show respect\""
},
ATTITUDES_COOPERATION_NAME: {
  id: "app.attitudes_cooperation_name",
  defaultMessage: "Cooperation"
},
ATTITUDES_COOPERATION_DESC: {
  id: "app.attitudes_cooperation_desc",
  defaultMessage: "\"I have excellent teamwork\""
},
ATTITUDES_ENGAGEMENT_NAME: {
  id: "app.attitudes_engagement_name",
  defaultMessage: "Engagement"
},
ATTITUDES_ENGAGEMENT_DESC: {
  id: "app.attitudes_engagement_desc",
  defaultMessage: "\"I get involved\""
},
ATTITUDES_OPENNESS_NAME: {
  id: "app.attitudes_openness_name",
  defaultMessage: "Openness to change"
},
ATTITUDES_OPENNESS_DESC: {
  id: "app.attitudes_openness_desc",
  defaultMessage: "\"I am receptive and proactive\""
},
ATTITUDES_LOADING_DATA: {
  id: "app.attitudes_loading_data",
  defaultMessage: "Loading attitude assessment data..."
},
ATTITUDES_NO_USER_SELECTED: {
  id: "app.attitudes_no_user_selected",
  defaultMessage: "No user selected. Please return and select a user."
},
ATTITUDES_GAP_REFERENCE_GROUP: {
  id: "app.attitudes_gap_reference_group",
  defaultMessage: "Gap Relative to Reference Group"
},
ATTITUDES_ABSOLUTE_DIFFERENCE_HIGH_PERFORMERS: {
  id: "app.attitudes_absolute_difference_high_performers",
  defaultMessage: "Absolute difference with the average of high performers identified by management"
},
ATTITUDES_ATTITUDE: {
  id: "app.attitudes_attitude",
  defaultMessage: "Attitude"
},
ATTITUDES_INTERPRETATION: {
  id: "app.attitudes_interpretation",
  defaultMessage: "Interpretation"
},
ATTITUDES_CLEARLY_ABOVE: {
  id: "app.attitudes_clearly_above",
  defaultMessage: "Clearly above"
},
ATTITUDES_ABOVE: {
  id: "app.attitudes_above",
  defaultMessage: "Above"
},
ATTITUDES_COMPARABLE: {
  id: "app.attitudes_comparable",
  defaultMessage: "Comparable"
},
ATTITUDES_BELOW: {
  id: "app.attitudes_below",
  defaultMessage: "Below"
},
ATTITUDES_CLEARLY_BELOW: {
  id: "app.attitudes_clearly_below",
  defaultMessage: "Clearly below"
},
ATTITUDES_PERCENTILE_RANKING: {
  id: "app.attitudes_percentile_ranking",
  defaultMessage: "Percentile Ranking of Attitudes"
},
ATTITUDES_RELATIVE_POSITION_REFERENCE_POPULATION: {
  id: "app.attitudes_relative_position_reference_population",
  defaultMessage: "Relative position compared to the reference population (middle management)"
},
ATTITUDES_PERCENTILE_DATA_NOT_AVAILABLE: {
  id: "app.attitudes_percentile_data_not_available",
  defaultMessage: "Percentile data not available."
},
ATTITUDES_LEGEND: {
  id: "app.attitudes_legend",
  defaultMessage: "Legend:"
},
ATTITUDES_TOP_16_EXCELLENT: {
  id: "app.attitudes_top_16_excellent",
  defaultMessage: "≥84th: Excellent (Top 16%)"
},
ATTITUDES_ABOVE_AVERAGE: {
  id: "app.attitudes_above_average",
  defaultMessage: "30-84th: Above average"
},
ATTITUDES_SLIGHTLY_BELOW: {
  id: "app.attitudes_slightly_below",
  defaultMessage: "16-30th: Slightly below"
},
ATTITUDES_DEVELOPMENT_ZONE: {
  id: "app.attitudes_development_zone",
  defaultMessage: "<16th: Development zone"
},
ATTITUDES_POSITION: {
  id: "app.attitudes_position",
  defaultMessage: "Position"
},
ATTITUDES_ATTITUDE_LABEL: {
  id: "app.attitudes_attitude_label",
  defaultMessage: "Attitude:"
},
ATTITUDES_ADDITIONAL_ANALYSIS_1: {
  id: "app.attitudes_additional_analysis_1",
  defaultMessage: "Additional Analysis 1: Expanded View"
},
ATTITUDES_RAW_SCORES_EXPANDED_VIEW: {
  id: "app.attitudes_raw_scores_expanded_view",
  defaultMessage: "Raw Scores - Expanded View (Scale 1.0-4.0)"
},
ATTITUDES_ZOOM_REAL_RANGE: {
  id: "app.attitudes_zoom_real_range",
  defaultMessage: "Zoom on the real range of variation to better visualize differences"
},
ATTITUDES_SCORE: {
  id: "app.attitudes_score",
  defaultMessage: "Score"
},
ATTITUDES_ADDITIONAL_ANALYSIS_2: {
  id: "app.attitudes_additional_analysis_2",
  defaultMessage: "Additional Analysis 2: Positioning by Standard Deviation"
},
ATTITUDES_POSITION_RELATIVE_HIGH_PERFORMERS_MEAN: {
  id: "app.attitudes_position_relative_high_performers_mean",
  defaultMessage: "Position relative to the mean of high performers"
},
ATTITUDES_REFERENCE_HIGH_PERFORMERS_MANAGEMENT: {
  id: "app.attitudes_reference_high_performers_management",
  defaultMessage: "Reference: candidates identified as high performers by management"
},
ATTITUDES_EXCELLENCE_SD: {
  id: "app.attitudes_excellence_sd",
  defaultMessage: "Excellence (≥+1 SD)"
},
ATTITUDES_ABOVE_SD: {
  id: "app.attitudes_above_sd",
  defaultMessage: "Above (+0 to +1 SD)"
},
ATTITUDES_BELOW_SD: {
  id: "app.attitudes_below_sd",
  defaultMessage: "Below (0 to -1 SD)"
},
ATTITUDES_DEVELOPMENT_SD: {
  id: "app.attitudes_development_sd",
  defaultMessage: "Development (<-1 SD)"
},
ATTITUDES_ANALYSIS: {
  id: "app.attitudes_analysis",
  defaultMessage: "Analysis"
},
ATTITUDES_LEGEND_HIGH_PERFORMERS: {
  id: "app.attitudes_legend_high_performers",
  defaultMessage: "Legend (relative to high performers):"
},
ATTITUDES_SD_EXCELLENCE: {
  id: "app.attitudes_sd_excellence",
  defaultMessage: "≥+1 SD: Excellence"
},
ATTITUDES_SD_ABOVE: {
  id: "app.attitudes_sd_above",
  defaultMessage: "+0 to +1 SD: Above"
},
ATTITUDES_SD_AVERAGE: {
  id: "app.attitudes_sd_average",
  defaultMessage: "-1 to 0 SD: Average"
},
ATTITUDES_SD_BELOW: {
  id: "app.attitudes_sd_below",
  defaultMessage: "-1 to -2 SD: Below"
},
ATTITUDES_SD_DEVELOPMENT: {
  id: "app.attitudes_sd_development",
  defaultMessage: "<-1 SD: Development"
},
ATTITUDES_ADDITIONAL_ANALYSIS_3: {
  id: "app.attitudes_additional_analysis_3",
  defaultMessage: "Additional Analysis 3: Normalized Scores"
},
ATTITUDES_Z_SCORES: {
  id: "app.attitudes_z_scores",
  defaultMessage: "Z-Scores (Standardized Scores)"
},
ATTITUDES_STANDARDIZED_POSITION: {
  id: "app.attitudes_standardized_position",
  defaultMessage: "Standardized position: 0 = reference group mean, ±1 = ±1 standard deviation"
},
ATTITUDES_Z_SCORE_SD: {
  id: "app.attitudes_z_score_sd",
  defaultMessage: "Z-Score (Standard Deviations)"
},
ATTITUDES_Z_SCORE_RAW: {
  id: "app.attitudes_z_score_raw",
  defaultMessage: "Z-score: (Raw score: )"
},
ATTITUDES_NORMALIZED_POSITION: {
  id: "app.attitudes_normalized_position",
  defaultMessage: "Normalized Position"
},
ATTITUDES_ADDITIONAL_ANALYSIS_4: {
  id: "app.attitudes_additional_analysis_4",
  defaultMessage: "Additional Analysis 4: Detailed Comparison"
},
ATTITUDES_CANDIDATE_SCORE: {
  id: "app.attitudes_candidate_score",
  defaultMessage: "Candidate Score"
},
ATTITUDES_REFERENCE_MEAN: {
  id: "app.attitudes_reference_mean",
  defaultMessage: "Reference Mean"
},
ATTITUDES_REFERENCE_MEDIAN: {
  id: "app.attitudes_reference_median",
  defaultMessage: "Reference Median"
},
ATTITUDES_GAP_MEAN: {
  id: "app.attitudes_gap_mean",
  defaultMessage: "Gap (Mean)"
},
ATTITUDES_GAP_MEDIAN: {
  id: "app.attitudes_gap_median",
  defaultMessage: "Gap (Median)"
},
ATTITUDES_RAW_ATTITUDES_SCORES: {
  id: "app.attitudes_raw_attitudes_scores",
  defaultMessage: "Raw Attitudes Scores (Scale 0-4)"
},
ATTITUDES_RAW_SCORE: {
  id: "app.attitudes_raw_score",
  defaultMessage: "Raw Score"
},
ATTITUDES_NO_ATTITUDE_DATA: {
  id: "app.attitudes_no_attitude_data",
  defaultMessage: "No attitude data available for visualization."
},
ATTITUDES_SCOPE_ASSESSMENT_SYSTEM: {
  id: "app.attitudes_scope_assessment_system",
  defaultMessage: "SCOPE Assessment System | Professional Personality Evaluation"
},
ATTITUDES_CONFIDENTIAL_REPORT: {
  id: "app.attitudes_confidential_report",
  defaultMessage: "This report is confidential and intended for professional development purposes only."
},
ATTITUDES_BACK_TO_ADMIN: {
  id: "app.attitudes_back_to_admin",
  defaultMessage: "← Back to Admin"
}
});
